import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AnnouncementTypeScalar: { input: any; output: any; }
  CategoryScalar: { input: any; output: any; }
  RecipeCategory: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

/** Represents an Annual Wellness Plan (AWP) record from Salesforce. */
export type Awp = {
  __typename?: 'AWP';
  /** Salesforce Account ID associated with the AWP (Account__c custom field). */
  Account__c?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether this wellness exam should be deleted. */
  Delete_Wellness_Exam__c?: Maybe<Scalars['Boolean']['output']>;
  /** Date of the wellness exam (Exam_Date__c custom field). */
  Exam_Date__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce record ID of the AWP. */
  Id: Scalars['ID']['output'];
  /** Display name of the member (Member_Name__c custom field). */
  Member_Name__c?: Maybe<Scalars['String']['output']>;
  /** Reference to the AwpMember entity for the member. */
  Member_Name__r?: Maybe<AwpMember>;
  /** Personal Health Record ID (PHR_ID__c custom field). */
  PHR_ID__c?: Maybe<Scalars['ID']['output']>;
  /** Current status of the wellness exam. */
  Status__c?: Maybe<WellnessExamStatus>;
  /** Date the AWP document was uploaded (Upload_Date__c custom field). */
  Upload_Date__c?: Maybe<Scalars['String']['output']>;
  /** Upload status of the AWP document. */
  Upload_Status__c?: Maybe<WellnessExamUploadStatus>;
};

/** Input parameters for the AWPByAccountId query. */
export type AwpByAccountIdInput = {
  /** Salesforce Account ID to retrieve AWPs for. */
  AccountID?: InputMaybe<Scalars['String']['input']>;
  /** Salesforce record ID to filter by a specific AWP. */
  Id?: InputMaybe<Scalars['ID']['input']>;
  /** Member ID to filter AWPs by member. */
  MemberID?: InputMaybe<Scalars['String']['input']>;
  /** When true, only return approved AWP records. */
  OnlyApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Physician ID to filter AWPs by physician. */
  PhysicianID?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the file content of an AWP document. */
export type AwpFile = {
  __typename?: 'AWPFile';
  /** Base64-encoded content of the Personal Health Record file. */
  PHR?: Maybe<Scalars['String']['output']>;
};

/** Represents a physician account (practice) from Salesforce. */
export type Account = {
  __typename?: 'Account';
  /** Physician's actual website URL (Actual_Website__c custom field). */
  Actual_Website__c?: Maybe<Scalars['String']['output']>;
  /** Additional information line 1 (Additional_Line_1__c custom field). */
  Additional_Line_1__c?: Maybe<Scalars['String']['output']>;
  /** Additional information line 2 (Additional_Line_2__c custom field). */
  Additional_Line_2__c?: Maybe<Scalars['String']['output']>;
  /** Billing city. */
  BillingCity?: Maybe<Scalars['String']['output']>;
  /** Billing postal code. */
  BillingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Billing state. */
  BillingState?: Maybe<Scalars['String']['output']>;
  /** Billing street address. */
  BillingStreet?: Maybe<Scalars['String']['output']>;
  /** Display name shown on the membership card (Card_Display_Name__c custom field). */
  Card_Display_Name__c?: Maybe<Scalars['String']['output']>;
  /** Card phone number line 1 (Card_Phone_1__c custom field). */
  Card_Phone_1__c?: Maybe<Scalars['String']['output']>;
  /** Card phone number line 2 (Card_Phone_2__c custom field). */
  Card_Phone_2__c?: Maybe<Scalars['String']['output']>;
  /** Card phone number line 3 (Card_Phone_3__c custom field). */
  Card_Phone_3__c?: Maybe<Scalars['String']['output']>;
  /** Card phone number line 4 (Card_Phone_4__c custom field). */
  Card_Phone_4__c?: Maybe<Scalars['String']['output']>;
  /** Card phone number line 5 (Card_Phone_5__c custom field). */
  Card_Phone_5__c?: Maybe<Scalars['String']['output']>;
  /** Card phone number line 6 (Card_Phone_6__c custom field). */
  Card_Phone_6__c?: Maybe<Scalars['String']['output']>;
  /** Card text line 1 (Card_Text_1__c custom field). */
  Card_Text_1__c?: Maybe<Scalars['String']['output']>;
  /** Card text line 2 (Card_Text_2__c custom field). */
  Card_Text_2__c?: Maybe<Scalars['String']['output']>;
  /** Card text line 3 (Card_Text_3__c custom field). */
  Card_Text_3__c?: Maybe<Scalars['String']['output']>;
  /** Card text line 4 (Card_Text_4__c custom field). */
  Card_Text_4__c?: Maybe<Scalars['String']['output']>;
  /** Card text line 5 (Card_Text_5__c custom field). */
  Card_Text_5__c?: Maybe<Scalars['String']['output']>;
  /** Card text line 6 (Card_Text_6__c custom field). */
  Card_Text_6__c?: Maybe<Scalars['String']['output']>;
  /** Co-brand name for the practice (Co_brand_Name__c custom field). */
  Co_brand_Name__c?: Maybe<Scalars['String']['output']>;
  /** Connect user ID associated with the account (restricted to internal staff). */
  ConnectUserId?: Maybe<Scalars['String']['output']>;
  /** Contact email address (Contact_Email__c custom field). */
  Contact_Email__c?: Maybe<Scalars['String']['output']>;
  /** Physician credentials (Credentials__c custom field). */
  Credentials__c?: Maybe<Scalars['String']['output']>;
  /** First name of the physician (First_Name__c custom field). */
  First_Name__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce record ID of the account. */
  Id: Scalars['ID']['output'];
  /** Last name of the physician (Last_Name__c custom field). */
  Last_Name__c?: Maybe<Scalars['String']['output']>;
  /** Membership tier of the account. */
  Membership_Tier__c?: Maybe<AccountMembershipTier>;
  /** Middle name of the physician (Middle_Name__c custom field). */
  Middle_Name__c?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number (Mobile__c custom field). */
  Mobile__c?: Maybe<Scalars['String']['output']>;
  /** Display name of the account. */
  Name?: Maybe<Scalars['String']['output']>;
  /** Primary phone number of the account. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Physician identifier (PhysicianID__c custom field). */
  PhysicianID__c?: Maybe<Scalars['String']['output']>;
  /** Physician status type (Physician_Status_Type__c custom field). */
  Physician_Status_Type__c?: Maybe<Scalars['String']['output']>;
  /** Emergency contact information displayed on the portal (Portal_Emergency_Contact__c custom field). */
  Portal_Emergency_Contact__c?: Maybe<Scalars['String']['output']>;
};

/** Union of all domain errors that can occur when retrieving an account by ID. */
export type AccountByIdDomainError = AccountByIdNotFoundError;

/** Encapsulates all domain errors for the accountById operation. */
export type AccountByIdFailure = {
  __typename?: 'AccountByIdFailure';
  /** All errors associated with required Account. */
  errors: Array<AccountByIdDomainError>;
};

/** Domain error returned when an account is not found by the given ID. */
export type AccountByIdNotFoundError = DomainError & {
  __typename?: 'AccountByIdNotFoundError';
  /** Id that was included in the query */
  Id: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for accountById. Returns Account on success or AccountByIdFailure on failure. */
export type AccountByIdResult = Account | AccountByIdFailure;

export type AccountInfoType = {
  __typename?: 'AccountInfoType';
  Name?: Maybe<Scalars['String']['output']>;
  PhysicianID__c?: Maybe<Scalars['String']['output']>;
};

export type AccountInput = {
  Id?: InputMaybe<Scalars['String']['input']>;
};

/** Defines the membership tier levels available for physician accounts. */
export enum AccountMembershipTier {
  /** AWP Plus membership tier */
  AwpPlus = 'AWP_PLUS',
  /** Cardiology membership tier */
  Cardiology = 'CARDIOLOGY',
  /** Endocrinology membership tier */
  Endocrinology = 'ENDOCRINOLOGY',
  /** Men's Health membership tier */
  MensHealth = 'MENS_HEALTH',
  /** Pediatric membership tier */
  Pediatric = 'PEDIATRIC',
  /** Standard membership tier */
  StandardMembership = 'STANDARD_MEMBERSHIP',
  /** Women's Health membership tier */
  WomensHealth = 'WOMENS_HEALTH'
}

export type AccountType = {
  __typename?: 'AccountType';
  BillingCity?: Maybe<Scalars['String']['output']>;
  BillingPostalCode?: Maybe<Scalars['String']['output']>;
  BillingState?: Maybe<Scalars['String']['output']>;
  BillingStreet?: Maybe<Scalars['String']['output']>;
  Friday_End_Time__c?: Maybe<Scalars['String']['output']>;
  Friday_Start_Time__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Member_Service_State__c?: Maybe<Scalars['String']['output']>;
  Monday_End_Time__c?: Maybe<Scalars['String']['output']>;
  Monday_Start_Time__c?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Opening_Date__c?: Maybe<Scalars['String']['output']>;
  Physician_Image_URL__c?: Maybe<Scalars['String']['output']>;
  Saturday_End_Time__c?: Maybe<Scalars['String']['output']>;
  Saturday_Start_Time__c?: Maybe<Scalars['String']['output']>;
  Sunday_End_Time__c?: Maybe<Scalars['String']['output']>;
  Sunday_Start_Time__c?: Maybe<Scalars['String']['output']>;
  Thursday_End_Time__c?: Maybe<Scalars['String']['output']>;
  Thursday_Start_Time__c?: Maybe<Scalars['String']['output']>;
  Tuesday_End_Time__c?: Maybe<Scalars['String']['output']>;
  Tuesday_Start_Time__c?: Maybe<Scalars['String']['output']>;
  Wednesday_End_Time__c?: Maybe<Scalars['String']['output']>;
  Wednesday_Start_Time__c?: Maybe<Scalars['String']['output']>;
};

/** Filter criteria for the allAccounts query. */
export type AccountsFilters = {
  /** When true, only return active accounts. */
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, include all physicians regardless of status. */
  includeAllPhysicians?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input parameters for the allAccounts query. */
export type AccountsInput = {
  /** Optional filter criteria for accounts. */
  filters?: InputMaybe<AccountsFilters>;
  /** Maximum number of records to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records to skip for pagination. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the paginated result of the allAccounts query. */
export type AccountsResult = {
  __typename?: 'AccountsResult';
  /** List of account records. */
  edges: Array<Account>;
  /** Current pagination limit. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Current pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

export type ActivityReportInput = {
  Id?: InputMaybe<Scalars['String']['input']>;
  Range?: InputMaybe<Scalars['String']['input']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AffiliateContact = {
  __typename?: 'AffiliateContact';
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  RecordTypeId?: Maybe<Scalars['String']['output']>;
};

export type AffiliateType = {
  __typename?: 'AffiliateType';
  AccountId?: Maybe<Scalars['String']['output']>;
  BillingCity?: Maybe<Scalars['String']['output']>;
  BillingLatitude?: Maybe<Scalars['Float']['output']>;
  BillingLongitude?: Maybe<Scalars['Float']['output']>;
  BillingPostalCode?: Maybe<Scalars['String']['output']>;
  BillingState?: Maybe<Scalars['String']['output']>;
  BillingStreet?: Maybe<Scalars['String']['output']>;
  Billing_Address_Description__c?: Maybe<Scalars['String']['output']>;
  ContextID__c?: Maybe<Scalars['String']['output']>;
  DepartmentId__c?: Maybe<Scalars['String']['output']>;
  Display_Name__c?: Maybe<Scalars['String']['output']>;
  Fax?: Maybe<Scalars['String']['output']>;
  First_Name__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Last_Name__c?: Maybe<Scalars['String']['output']>;
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  Middle_Name__c?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  PhysicianID__c?: Maybe<Scalars['String']['output']>;
  Specialty__c?: Maybe<Scalars['String']['output']>;
};

export type AffiliateWithContacts = {
  __typename?: 'AffiliateWithContacts';
  AccountId?: Maybe<Scalars['String']['output']>;
  BillingCity?: Maybe<Scalars['String']['output']>;
  BillingLatitude?: Maybe<Scalars['Float']['output']>;
  BillingLongitude?: Maybe<Scalars['Float']['output']>;
  BillingPostalCode?: Maybe<Scalars['String']['output']>;
  BillingState?: Maybe<Scalars['String']['output']>;
  BillingStreet?: Maybe<Scalars['String']['output']>;
  Billing_Address_Description__c?: Maybe<Scalars['String']['output']>;
  Contacts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContextID__c?: Maybe<Scalars['String']['output']>;
  DepartmentId__c?: Maybe<Scalars['String']['output']>;
  Display_Name__c?: Maybe<Scalars['String']['output']>;
  Fax?: Maybe<Scalars['String']['output']>;
  First_Name__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Last_Name__c?: Maybe<Scalars['String']['output']>;
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  Middle_Name__c?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  PhysicianID__c?: Maybe<Scalars['String']['output']>;
  Specialty__c?: Maybe<Scalars['String']['output']>;
};

/** Represents a single practice report edge containing file metadata. */
export type AllPracticeReportEdge = {
  __typename?: 'AllPracticeReportEdge';
  /** Timestamp when the report was created. */
  Created?: Maybe<Scalars['String']['output']>;
  /** Name of the report file. */
  File_Name?: Maybe<Scalars['String']['output']>;
  /** Type of the report file. */
  File_Type?: Maybe<Scalars['String']['output']>;
  /** File path of the report on the server. */
  Path?: Maybe<Scalars['String']['output']>;
  /** Identifier of the physician who owns the report. */
  Physician_ID?: Maybe<Scalars['String']['output']>;
};

/** Represents the result of the allPracticeReport query containing a list of report edges. */
export type AllPracticeReportResult = {
  __typename?: 'AllPracticeReportResult';
  /** List of practice report edges. */
  edges: Array<AllPracticeReportEdge>;
};

export type Announcements = {
  __typename?: 'Announcements';
  field_announcements_type?: Maybe<Scalars['AnnouncementTypeScalar']['output']>;
  field_body?: Maybe<Scalars['String']['output']>;
  field_priority?: Maybe<Scalars['String']['output']>;
  field_title?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** Represents a file attachment associated with a secure message. */
export type Attachment = {
  __typename?: 'Attachment';
  /** Timestamp when the attachment was created. */
  createdTimestamp?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the attachment. */
  id: Scalars['ID']['output'];
  /** MIME type of the attachment content. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Original file name of the attachment. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Represents the binary content of an attachment. */
export type AttachmentData = {
  __typename?: 'AttachmentData';
  /** Base64-encoded content of the attachment. */
  content: Scalars['String']['output'];
};

/** Union of all domain errors that can occur when retrieving attachment data by ID. */
export type AttachmentDataByIdDomainError = AttachmentDataByIdInvalidMailboxIdError | AttachmentDataByIdInvalidMessageIdError | AttachmentDataByIdInvalidThreadIdError | AttachmentDataByIdNotFoundError;

/** Encapsulates all domain errors for the attachmentDataById operation. */
export type AttachmentDataByIdFailure = {
  __typename?: 'AttachmentDataByIdFailure';
  /** All errors associated with required Attachment. */
  errors: Array<AttachmentDataByIdDomainError>;
};

/** Input parameters for the attachmentDataById query. */
export type AttachmentDataByIdInput = {
  /** Unique identifier of the attachment to retrieve. */
  attachmentId: Scalars['ID']['input'];
  /** Unique identifier of the mailbox containing the thread. */
  mailboxId: Scalars['ID']['input'];
  /** Unique identifier of the message containing the attachment. */
  messageId: Scalars['ID']['input'];
  /** Unique identifier of the thread containing the message. */
  threadId: Scalars['ID']['input'];
};

/** Domain error returned when the mailbox ID is invalid for the attachment data request. */
export type AttachmentDataByIdInvalidMailboxIdError = DomainError & {
  __typename?: 'AttachmentDataByIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the message ID is invalid for the attachment data request. */
export type AttachmentDataByIdInvalidMessageIdError = DomainError & {
  __typename?: 'AttachmentDataByIdInvalidMessageIdError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The invalid message ID that was provided. */
  messageId: Scalars['ID']['output'];
};

/** Domain error returned when the thread ID is invalid for the attachment data request. */
export type AttachmentDataByIdInvalidThreadIdError = DomainError & {
  __typename?: 'AttachmentDataByIdInvalidThreadIdError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The invalid thread ID that was provided. */
  threadId: Scalars['ID']['output'];
};

/** Domain error returned when the requested attachment is not found. */
export type AttachmentDataByIdNotFoundError = DomainError & {
  __typename?: 'AttachmentDataByIdNotFoundError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for attachmentDataById. Returns AttachmentData on success or AttachmentDataByIdFailure on failure. */
export type AttachmentDataByIdResult = AttachmentData | AttachmentDataByIdFailure | MailboxByIdFailure;

export type AttachmentType = {
  __typename?: 'AttachmentType';
  createdTimestamp?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AttachmentTypeInput = {
  createdTimestamp?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentsByIdInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  mailboxId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentsByMessageIdInput = {
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  mailboxId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeType = {
  __typename?: 'AttributeType';
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Union of all domain errors that can occur when retrieving an AWP by PHR ID. */
export type AwpByPhrIdDomainError = AwpByPhrIdNotFoundError;

/** Encapsulates all domain errors for the awpByPhrId operation. */
export type AwpByPhrIdFailure = {
  __typename?: 'AwpByPhrIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<AwpByPhrIdDomainError>;
};

/** Domain error returned when an AWP record is not found for the given PHR ID. */
export type AwpByPhrIdNotFoundError = DomainError & {
  __typename?: 'AwpByPhrIdNotFoundError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The PHR ID that was not found. */
  phrId: Scalars['ID']['output'];
};

/** Result type for awpByPhrId. Returns AwpByPhrIdSuccess on success or AwpByPhrIdFailure on failure. */
export type AwpByPhrIdResult = AwpByPhrIdFailure | AwpByPhrIdSuccess;

/** Represents a successful response when retrieving an AWP by PHR ID. */
export type AwpByPhrIdSuccess = {
  __typename?: 'AwpByPhrIdSuccess';
  /** The AWP record. */
  awp: Awp;
  /** Pre-signed URL for downloading the AWP document. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Pre-signed URL for uploading a replacement AWP document. */
  uploadUrl: Scalars['String']['output'];
};

/** Represents a member entity stub referenced by AWP records. */
export type AwpMember = {
  __typename?: 'AwpMember';
  /** Salesforce record ID of the member. */
  Id: Scalars['ID']['output'];
  /** MDVIP identifier for the member (MDVIPID__c custom field). */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
};

export type CampaignMemberType = {
  __typename?: 'CampaignMemberType';
  CampaignId?: Maybe<Scalars['String']['output']>;
  ContactId?: Maybe<Scalars['String']['output']>;
  Guest_Count__c?: Maybe<Scalars['String']['output']>;
  Guest_Relationship__c?: Maybe<Scalars['String']['output']>;
  Guest__c?: Maybe<Scalars['String']['output']>;
  HasResponded?: Maybe<Scalars['Boolean']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Meeting_Attendance__c?: Maybe<Scalars['String']['output']>;
  Membership_Status__c?: Maybe<Scalars['String']['output']>;
  Mtg_Attended__c?: Maybe<Scalars['String']['output']>;
  Registration_Received__c?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

export type CampaignType = {
  __typename?: 'CampaignType';
  Attendees?: Maybe<Array<Maybe<CampaignMemberType>>>;
  Event_Begin_Time__c?: Maybe<Scalars['String']['output']>;
  Event_End_Time__c?: Maybe<Scalars['String']['output']>;
  Id: Scalars['String']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Name_Of_Venue__c?: Maybe<Scalars['String']['output']>;
  Registered?: Maybe<Scalars['Int']['output']>;
  Room_Capacity__c?: Maybe<Scalars['String']['output']>;
  Room_Max_Capacity__c?: Maybe<Scalars['String']['output']>;
  Venue_Address__c?: Maybe<Scalars['String']['output']>;
  formattedEndDate?: Maybe<Scalars['String']['output']>;
  formattedStartDate?: Maybe<Scalars['String']['output']>;
  formattedStartTime?: Maybe<Scalars['String']['output']>;
};

export type CaseContactType = {
  __typename?: 'CaseContactType';
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  RecordType?: Maybe<ContactRecordType>;
};

export type CaseInput = {
  Id?: InputMaybe<Scalars['String']['input']>;
};

export enum CaseStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Waiting = 'WAITING'
}

export type CaseType = {
  __typename?: 'CaseType';
  Account?: Maybe<AccountType>;
  CaseNumber?: Maybe<Scalars['String']['output']>;
  Contact?: Maybe<CaseContactType>;
  Date_Added__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

/**
 * Defines the client application channels used by the @channel directive
 * to restrict field access based on the originating platform.
 */
export enum Channel {
  /** Express Pay checkout flow (unauthenticated) */
  ExpressPay = 'EXPRESS_PAY',
  /** MDVIP mobile application */
  MobileApp = 'MOBILE_APP',
  /** MDVIP web portal */
  Portal = 'PORTAL',
  /** Internal Salesforce integration channel */
  SalesforceInternal = 'SALESFORCE_INTERNAL'
}

export enum ConnectUserEnum {
  Du = 'DU',
  Ru = 'RU',
  Up = 'UP'
}

export type Contact = {
  /** AccountId from Contact record */
  AccountId: Scalars['String']['output'];
  /**
   * Date_Of_Birth__c from Contact record
   * Format: YYYY-MM-DD
   */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Disposition_Code__c from Contact record */
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  /** Email from Contact record */
  Email?: Maybe<Scalars['String']['output']>;
  /**
   * Emergency_Phone__c from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  /** Estimated_Paid_Through__c from Contact record */
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  /**
   * Fax from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Fax?: Maybe<Scalars['String']['output']>;
  /** FirstName from Contact record */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Gender__c from Contact record */
  Gender__c?: Maybe<Scalars['String']['output']>;
  /** Id from Contact record */
  Id: Scalars['ID']['output'];
  /** LastName from Contact record */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Last_App_Login__c from Contact record */
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  /** MailingCity from Contact record */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** MailingPostalCode from Contact record */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** MailingState from Contact record */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** MailingStreet from Contact record */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /**
   * MobilePhone from Contact record
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /**
   * Phone from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Phone?: Maybe<Scalars['String']['output']>;
  /** User preference to enable push notifications for new secure messages */
  Push_Notifications__c?: Maybe<Scalars['Boolean']['output']>;
  /** User preference to enable email notifications for new secure messages */
  SM_Email_Notification__c?: Maybe<Scalars['Boolean']['output']>;
  /** Salutation from Contact record */
  Salutation?: Maybe<Scalars['String']['output']>;
  /**
   * Localized string of Date_Of_Birth__c
   * Format: MM/DD/YYYY
   */
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
};

export type ContactListMember = {
  __typename?: 'ContactListMember';
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  RecordTypeId?: Maybe<Scalars['String']['output']>;
};

export type ContactNotFoundError = DomainError & {
  __typename?: 'ContactNotFoundError';
  message: Scalars['String']['output'];
};

export type ContactRecordType = {
  __typename?: 'ContactRecordType';
  Name?: Maybe<Scalars['String']['output']>;
};

export type ContactType = {
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  Fax?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gender__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  MailingCity?: Maybe<Scalars['String']['output']>;
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  MailingState?: Maybe<Scalars['String']['output']>;
  MailingStreet?: Maybe<Scalars['String']['output']>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingCity */
  Primary_City__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingState */
  Primary_State__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingStreet */
  Primary_Street_Address__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingPostalCode */
  Primary_Zip_Postal_Code__c?: Maybe<Scalars['String']['output']>;
  Salutation?: Maybe<Scalars['String']['output']>;
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
};

/** Input parameters for the deprecated createAWP mutation. */
export type CreateAwpInput = {
  /** Formatted exam date string. */
  Date_of_Physical?: InputMaybe<Scalars['String']['input']>;
  /** MDVIP member ID. */
  Member_ID?: InputMaybe<Scalars['String']['input']>;
  /** PHR upload status. */
  PHR_Status?: InputMaybe<Scalars['String']['input']>;
  /** Physician ID. */
  Physician_ID?: InputMaybe<Scalars['String']['input']>;
  /** Username of the user creating the AWP. */
  User?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the response from the deprecated createAWP mutation. */
export type CreateAwpResponse = {
  __typename?: 'CreateAWPResponse';
  /** Personal Health Record ID of the created AWP. */
  PHR_ID?: Maybe<Scalars['String']['output']>;
  /** Salesforce Wellness Exam ID of the created AWP. */
  Wellness_Exam_ID?: Maybe<Scalars['String']['output']>;
};

/** Encapsulates all domain errors for the createBroadcastMessageThread operation. */
export type CreateBroadcastMessageThreadFailure = {
  __typename?: 'CreateBroadcastMessageThreadFailure';
  /** List of domain errors that occurred during broadcast thread creation. */
  errors: Array<CreateMessageThreadDomainError>;
};

/** Input parameters for the createBroadcastMessageThread mutation. */
export type CreateBroadcastMessageThreadInput = {
  /** Whether replies are allowed in the broadcast thread. */
  allowReply: Scalars['Boolean']['input'];
  /** Optional unique identifier for the thread. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Unique identifier of the mailbox to create the thread in. */
  mailboxId: Scalars['ID']['input'];
  /** Initial messages to include in the broadcast thread. */
  messages: Array<CreateBroadcastMessageThreadInputMessage>;
  /** Display name of the thread. */
  name: Scalars['String']['input'];
};

/** Input parameters for a message within a new broadcast thread. */
export type CreateBroadcastMessageThreadInputMessage = {
  /** File attachments to include with the message. */
  attachments?: InputMaybe<Array<CreateMessageThreadInputMessageAttachment>>;
  /** Blind carbon copy recipients of the broadcast message. */
  bcc: Array<CreateMessageThreadInputRecipient>;
  /** Body content of the message. */
  body: Scalars['String']['input'];
  /** Carbon copy recipients of the message. */
  cc?: InputMaybe<Array<CreateMessageThreadInputRecipient>>;
  /** Whether the message is a draft. */
  draft: Scalars['Boolean']['input'];
  /** Sender of the message. */
  from: CreateMessageThreadInputSender;
  /** Optional unique identifier for the message. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the message has been read. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subject line of the message. */
  subject: Scalars['String']['input'];
  /** Primary recipients of the message. */
  to?: InputMaybe<Array<CreateMessageThreadInputRecipient>>;
};

/** Result type for createBroadcastMessageThread. Returns CreateBroadcastMessageThreadSuccess on success or CreateBroadcastMessageThreadFailure on failure. */
export type CreateBroadcastMessageThreadResult = CreateBroadcastMessageThreadFailure | CreateBroadcastMessageThreadSuccess | MailboxByIdFailure;

/** Represents a successful creation of a broadcast message thread. */
export type CreateBroadcastMessageThreadSuccess = {
  __typename?: 'CreateBroadcastMessageThreadSuccess';
  /** The newly created broadcast message thread. */
  thread: MessageThread;
};

export type CreateCampaignMemberInput = {
  AccountID?: InputMaybe<Scalars['String']['input']>;
  AcquisitionChannel?: InputMaybe<Scalars['String']['input']>;
  AcquisitionSubChannel?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use AcquisitionSubChannel - Typo */
  AcquistionSubChannel?: InputMaybe<Scalars['String']['input']>;
  CampaignID: Scalars['String']['input'];
  ContactID: Scalars['String']['input'];
  Date_Of_Birth__c?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  Gender__c?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  LeadID?: InputMaybe<Scalars['String']['input']>;
  LeadSource?: InputMaybe<Scalars['String']['input']>;
  MDVIPCanContact?: InputMaybe<Scalars['Boolean']['input']>;
  MDVIPID?: InputMaybe<Scalars['String']['input']>;
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  MailingState?: InputMaybe<Scalars['String']['input']>;
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  Phone?: InputMaybe<Scalars['String']['input']>;
  PhysicianName?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use MailingCity */
  Primary_City__c?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use MailingState */
  Primary_State__c?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use MailingStreet */
  Primary_Street_Address__c?: InputMaybe<Scalars['String']['input']>;
  ProfileName?: InputMaybe<Scalars['String']['input']>;
  Referral_Name__c?: InputMaybe<Scalars['String']['input']>;
  Salutation?: InputMaybe<Scalars['String']['input']>;
  Unknown_Insurance_Company_Name__c?: InputMaybe<Scalars['String']['input']>;
  UserName?: InputMaybe<Scalars['String']['input']>;
  UserNameNotQualified?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use MailingPostalCode */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateF2FCase = {
  AccountID?: InputMaybe<Scalars['String']['input']>;
  ContactID?: InputMaybe<Scalars['String']['input']>;
  DateofFaceofFace?: InputMaybe<Scalars['String']['input']>;
  PhysicianName?: InputMaybe<Scalars['String']['input']>;
  ProfileName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMessageInput = {
  attachments?: InputMaybe<Array<InputMaybe<CreateMessageAttachmentInput>>>;
  bcc?: InputMaybe<Array<InputMaybe<CreateMessageUserInput>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<InputMaybe<CreateMessageUserInput>>>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<CreateMessageUserInput>;
  mailboxId?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<InputMaybe<CreateMessageUserInput>>>;
};

/** Union of all domain errors that can occur when creating a message thread. */
export type CreateMessageThreadDomainError = CreateMessageThreadMailboxInvalidIdError | CreateMessageThreadMailboxInvalidMailboxIdError | CreateMessageThreadMailboxNotFoundError | CreateMessageThreadUnauthorizedError;

/** Input parameters for an attachment on a message within a new thread. */
export type CreateMessageThreadInputMessageAttachment = {
  /** Timestamp when the attachment was created. */
  createdTimestamp: Scalars['String']['input'];
  /** Unique identifier of the attachment. */
  id: Scalars['ID']['input'];
  /** MIME type of the attachment content. */
  mimeType: Scalars['String']['input'];
  /** Original file name of the attachment. */
  name: Scalars['String']['input'];
};

/** Input parameters for a recipient when creating a message thread. */
export type CreateMessageThreadInputRecipient = {
  /** Email address of the recipient. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the recipient. */
  id: Scalars['ID']['input'];
  /** Display name of the recipient. */
  name: Scalars['String']['input'];
};

/** Input parameters for the sender when creating a message thread. */
export type CreateMessageThreadInputSender = {
  /** Unique identifier of the sender. */
  id: Scalars['ID']['input'];
  /** Display name of the sender. */
  name: Scalars['String']['input'];
};

/** Domain error returned when the thread ID is invalid for the create thread request. */
export type CreateMessageThreadMailboxInvalidIdError = DomainError & {
  __typename?: 'CreateMessageThreadMailboxInvalidIdError';
  /** The invalid thread ID that was provided. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the mailbox ID is invalid for the create thread request. */
export type CreateMessageThreadMailboxInvalidMailboxIdError = DomainError & {
  __typename?: 'CreateMessageThreadMailboxInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the mailbox is not found for the create thread request. */
export type CreateMessageThreadMailboxNotFoundError = DomainError & {
  __typename?: 'CreateMessageThreadMailboxNotFoundError';
  /** The mailbox ID that was not found. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the user is unauthorized to create a message thread. */
export type CreateMessageThreadUnauthorizedError = DomainError & {
  __typename?: 'CreateMessageThreadUnauthorizedError';
  /** The mailbox IDs the user is unauthorized to create threads in. */
  mailboxIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type CreateMessageUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unreadCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Union of all domain errors that can occur when creating a new AWP. */
export type CreateNewAwpDomainError = CreateNewAwpFailedError;

/** Domain error returned when creating a new AWP fails. */
export type CreateNewAwpFailedError = DomainError & {
  __typename?: 'CreateNewAwpFailedError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Encapsulates all domain errors for the createNewAwp operation. */
export type CreateNewAwpFailure = {
  __typename?: 'CreateNewAwpFailure';
  /** List of domain errors that occurred. */
  errors: Array<CreateNewAwpDomainError>;
};

/** Input parameters for the createNewAwp mutation. */
export type CreateNewAwpInput = {
  /** Display name of the person creating the AWP (typically the physician's full name). */
  createdByName: Scalars['String']['input'];
  /** Formatted exam date string - 08/10/2023 or 2023-08-10 */
  examDate: Scalars['String']['input'];
  /** Member MDVIP Id */
  memberMdvipId: Scalars['ID']['input'];
  /** Physician id */
  physicianId: Scalars['ID']['input'];
  /** PHR status or AWP upload status - Pending is the default value when missing */
  uploadStatus?: InputMaybe<WellnessExamUploadStatus>;
};

/** Result type for createNewAwp. Returns CreateNewAwpSuccess on success or CreateNewAwpFailure on failure. */
export type CreateNewAwpResponse = CreateNewAwpFailure | CreateNewAwpSuccess;

/** Represents a successful response from the createNewAwp mutation. */
export type CreateNewAwpSuccess = {
  __typename?: 'CreateNewAwpSuccess';
  /** MDVIP member ID associated with the created AWP. */
  memberMdvipId: Scalars['ID']['output'];
  /** Personal Health Record ID of the created AWP. */
  phrId: Scalars['ID']['output'];
  /** Pre-signed URL for uploading the AWP document. */
  uploadUrl: Scalars['String']['output'];
  /** Salesforce Wellness Exam ID of the created AWP. */
  wellnessExamId: Scalars['ID']['output'];
};

/** Union of all domain errors that can occur when creating a new message. */
export type CreateNewMessageDomainError = CreateNewMessageInvalidMailboxIdError | CreateNewMessageInvalidThreadIdError | CreateNewMessageMailboxThreadNotFoundError;

/** Encapsulates all domain errors for the createNewMessage operation. */
export type CreateNewMessageFailure = {
  __typename?: 'CreateNewMessageFailure';
  /** List of domain errors that occurred during message creation. */
  errors: Array<CreateNewMessageDomainError>;
};

/** Input parameters for the createNewMessage mutation. */
export type CreateNewMessageInput = {
  /** File attachments to include with the message. */
  attachments: Array<CreateNewMessageInputAttachment>;
  /** Blind carbon copy recipients of the message. */
  bcc?: InputMaybe<Array<CreateNewMessageInputRecipient>>;
  /** Body content of the message. */
  body: Scalars['String']['input'];
  /** Carbon copy recipients of the message. */
  cc?: InputMaybe<Array<CreateNewMessageInputRecipient>>;
  /** Whether the message is a draft. */
  draft: Scalars['Boolean']['input'];
  /** Sender of the message. */
  from: CreateNewMessageInputSender;
  /** Unique identifier of the mailbox to create the message in. */
  mailboxId: Scalars['ID']['input'];
  /** Whether the message has been read. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subject line of the message. */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the thread to add the message to. */
  threadId: Scalars['ID']['input'];
  /** Primary recipients of the message. */
  to: Array<CreateNewMessageInputRecipient>;
};

/** Input parameters for an attachment on a new message. */
export type CreateNewMessageInputAttachment = {
  /** Timestamp when the attachment was created. */
  createdTimestamp: Scalars['String']['input'];
  /** Unique identifier of the attachment. */
  id: Scalars['ID']['input'];
  /** MIME type of the attachment content. */
  mimeType: Scalars['String']['input'];
  /** Original file name of the attachment. */
  name: Scalars['String']['input'];
};

/** Input parameters for a recipient of a new message. */
export type CreateNewMessageInputRecipient = {
  /** Email address of the recipient. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the recipient. */
  id: Scalars['ID']['input'];
  /** Display name of the recipient. */
  name: Scalars['String']['input'];
};

/** Input parameters for the sender of a new message. */
export type CreateNewMessageInputSender = {
  /** Unique identifier of the sender. */
  id: Scalars['ID']['input'];
  /** Display name of the sender. */
  name: Scalars['String']['input'];
};

/** Domain error returned when the mailbox ID is invalid for the create message request. */
export type CreateNewMessageInvalidMailboxIdError = DomainError & {
  __typename?: 'CreateNewMessageInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the thread ID is invalid for the create message request. */
export type CreateNewMessageInvalidThreadIdError = DomainError & {
  __typename?: 'CreateNewMessageInvalidThreadIdError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The invalid thread ID that was provided. */
  threadId: Scalars['ID']['output'];
};

/** Domain error returned when the mailbox thread is not found for the create message request. */
export type CreateNewMessageMailboxThreadNotFoundError = DomainError & {
  __typename?: 'CreateNewMessageMailboxThreadNotFoundError';
  /** The mailbox ID that was searched. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The thread ID that was not found. */
  threadId: Scalars['ID']['output'];
};

/** Result type for createNewMessage. Returns CreateNewMessageSuccess on success or CreateNewMessageFailure on failure. */
export type CreateNewMessageResult = CreateNewMessageFailure | CreateNewMessageSuccess | MailboxByIdFailure;

/** Represents a successful creation of a new message. */
export type CreateNewMessageSuccess = {
  __typename?: 'CreateNewMessageSuccess';
  /** The newly created message. */
  message: Message;
};

/** Input for ACH bank account information when creating a new payment profile. */
export type CreateNewPaymentProfileAchInput = {
  /** Name of the ACH bank. */
  ACHBankName__c: Scalars['String']['input'];
  /** Last 6 digits of Account number */
  ACHLast6__c: Scalars['String']['input'];
  /** Last 9 digits of Routing number */
  ACHRoutingLast9__c: Scalars['String']['input'];
  /** ACH account type (Checking, Savings, or Other). */
  ACH_Name_of_Account__c: PaymentProfileAchAccountType;
  /** Name on the bank account. */
  Name_on_Card__c: Scalars['String']['input'];
};

/** Input for credit card information when creating a new payment profile. */
export type CreateNewPaymentProfileCreditCardInput = {
  /** Last 4 digits of Credit card number */
  CCLast4__c: Scalars['String']['input'];
  /** Card type classification. */
  Card_Type__c: PaymentProfileCardType;
  /** Credit card expiration month. */
  Expiration_Month__c: Scalars['String']['input'];
  /** Credit card expiration year. */
  Expiration_Year__c: Scalars['String']['input'];
  /** Name on the credit card. */
  Name_on_Card__c: Scalars['String']['input'];
  /** Payment method type (VISA, AMEX, MC, DISC, ACH). */
  PaymentType__c?: InputMaybe<PaymentProfilePaymentType>;
};

/** Union of all domain errors that can occur when creating a new payment profile. */
export type CreateNewPaymentProfileDomainError = CreateNewPaymentProfileFailedDomainError | CreateNewPaymentProfileInvalidInputDomainError;

/** Domain error returned when creating a payment profile fails. */
export type CreateNewPaymentProfileFailedDomainError = DomainError & {
  __typename?: 'CreateNewPaymentProfileFailedDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Encapsulates all domain errors for the createNewPaymentProfile operation. */
export type CreateNewPaymentProfileFailure = {
  __typename?: 'CreateNewPaymentProfileFailure';
  /** List of domain errors that occurred. */
  errors: Array<CreateNewPaymentProfileDomainError>;
};

/** Input parameters for the createNewPaymentProfile mutation. */
export type CreateNewPaymentProfileInput = {
  /**
   * ACH information to create a new payment profile
   * Requires one of ACHInfo and CreditCardInfo
   */
  ACHInfo?: InputMaybe<CreateNewPaymentProfileAchInput>;
  /** Whether this payment profile is active. */
  Active__c: Scalars['Boolean']['input'];
  /** Billing address line 1. */
  Address_1__c?: InputMaybe<Scalars['String']['input']>;
  /** Billing address line 2. */
  Address_2__c?: InputMaybe<Scalars['String']['input']>;
  /** Card affluence classification. */
  Affluence__c?: InputMaybe<Scalars['String']['input']>;
  /** Authorization transaction ID from payment gateway verification. */
  Auth_Transaction_Id__c: Scalars['String']['input'];
  /** Billing address city. */
  City__c?: InputMaybe<Scalars['String']['input']>;
  /**
   * Credit Card information to create a new payment profile
   * Requires one of ACHInfo and CreditCardInfo
   */
  CreditCardInfo?: InputMaybe<CreateNewPaymentProfileCreditCardInput>;
  /** Whether this should be the default payment profile. */
  Default__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Expiration status of the payment method. */
  Expired__c?: InputMaybe<Scalars['String']['input']>;
  /** Gateway token ID from payment gateway verification. */
  Gateway_Token_Id__c: Scalars['String']['input'];
  /** Whether this is an HSA card. */
  HSACard__c: PaymentProfileHsaCard;
  /** Country of the card issuer. */
  Issuer_Country__c?: InputMaybe<Scalars['String']['input']>;
  /** Pre-paid card type classification. */
  Pre_Paid_Type__c?: InputMaybe<Scalars['String']['input']>;
  /** Limited to 500 characters */
  Source_URL__c: Scalars['String']['input'];
  /** Billing address state. */
  States__c?: InputMaybe<Scalars['String']['input']>;
  /**
   * Limit to 100 characters
   * Use the first 100 characters of Source_URL__c if missing
   */
  Web_MD_Domain__c?: InputMaybe<Scalars['String']['input']>;
  /** Billing address ZIP code. */
  Zipcode__c?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment profile type (Guest or Payment).
   * Defaults to Payment. If channel is EXPRESS_PAY, uses the passed value.
   * Otherwise defaults to Payment.
   */
  paymentProfileType?: InputMaybe<PaymentProfileType>;
};

/** Domain error returned when the input for creating a payment profile is invalid. */
export type CreateNewPaymentProfileInvalidInputDomainError = DomainError & {
  __typename?: 'CreateNewPaymentProfileInvalidInputDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for createNewPaymentProfile. Returns CreateNewPaymentProfileSuccess on success or CreateNewPaymentProfileFailure on failure. */
export type CreateNewPaymentProfileResult = CreateNewPaymentProfileFailure | CreateNewPaymentProfileSuccess;

/** Represents a successful payment profile creation. */
export type CreateNewPaymentProfileSuccess = {
  __typename?: 'CreateNewPaymentProfileSuccess';
  /** Salesforce record ID of the created payment profile. */
  Id: Scalars['ID']['output'];
};

/** Encapsulates all domain errors for the createNonBroadcastMessageThread operation. */
export type CreateNonBroadcastMessageThreadFailure = {
  __typename?: 'CreateNonBroadcastMessageThreadFailure';
  /** List of domain errors that occurred during non-broadcast thread creation. */
  errors: Array<CreateMessageThreadDomainError>;
};

/** Input parameters for the createNonBroadcastMessageThread mutation. */
export type CreateNonBroadcastMessageThreadInput = {
  /** Whether replies are allowed in the thread. */
  allowReply: Scalars['Boolean']['input'];
  /** Optional unique identifier for the thread. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Unique identifier of the mailbox to create the thread in. */
  mailboxId: Scalars['ID']['input'];
  /** Initial messages to include in the thread. */
  messages: Array<CreateNonBroadcastMessageThreadInputMessage>;
  /** Display name of the thread. */
  name: Scalars['String']['input'];
};

/** Input parameters for a message within a new non-broadcast thread. */
export type CreateNonBroadcastMessageThreadInputMessage = {
  /** File attachments to include with the message. */
  attachments?: InputMaybe<Array<CreateMessageThreadInputMessageAttachment>>;
  /** Blind carbon copy recipients of the message. */
  bcc?: InputMaybe<Array<CreateMessageThreadInputRecipient>>;
  /** Body content of the message. */
  body: Scalars['String']['input'];
  /** Carbon copy recipients of the message. */
  cc?: InputMaybe<Array<CreateMessageThreadInputRecipient>>;
  /** Whether the message is a draft. */
  draft: Scalars['Boolean']['input'];
  /** Sender of the message. */
  from: CreateMessageThreadInputSender;
  /** Optional unique identifier for the message. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the message has been read. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subject line of the message. */
  subject: Scalars['String']['input'];
  /** Primary recipients of the message. */
  to: Array<CreateMessageThreadInputRecipient>;
};

/** Result type for createNonBroadcastMessageThread. Returns CreateNonBroadcastMessageThreadSuccess on success or CreateNonBroadcastMessageThreadFailure on failure. */
export type CreateNonBroadcastMessageThreadResult = CreateNonBroadcastMessageThreadFailure | CreateNonBroadcastMessageThreadSuccess | MailboxByIdFailure;

/** Represents a successful creation of a non-broadcast message thread. */
export type CreateNonBroadcastMessageThreadSuccess = {
  __typename?: 'CreateNonBroadcastMessageThreadSuccess';
  /** The newly created non-broadcast message thread. */
  thread: MessageThread;
};

/** Union of all domain errors that can occur when creating a one-time payment. */
export type CreateOneTimePaymentDomainError = CreateOneTimePaymentFailedDomainError;

/** Domain error returned when creating a one-time payment fails. */
export type CreateOneTimePaymentFailedDomainError = DomainError & {
  __typename?: 'CreateOneTimePaymentFailedDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Encapsulates all domain errors for the createOneTimePayment operation. */
export type CreateOneTimePaymentFailure = {
  __typename?: 'CreateOneTimePaymentFailure';
  /** List of domain errors that occurred. */
  errors: Array<CreateOneTimePaymentDomainError>;
};

/** Input parameters for the createOneTimePayment mutation. */
export type CreateOneTimePaymentInput = {
  /** Payment amount in dollars. */
  Amount__c: Scalars['Float']['input'];
  /** Salesforce Payment Profile ID to charge. */
  Payment_Profile__c: Scalars['String']['input'];
  /**
   * When true, marks this as a reinstatement payment (Reinstatement_Payment__c in Salesforce).
   * Only affects the SF payload when true; no impact on existing non-reinstatement flow.
   */
  Reinstatement_Payment__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** YYYY-MM-DD formatted date */
  Schedule_Date__c: Scalars['String']['input'];
  /** Limited to 500 characters */
  Source_URL__c: Scalars['String']['input'];
  /** Type of payment being created. */
  Type__c: PaymentType;
  /** UTM campaign tracking parameter. */
  UTM_Campaign__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM medium tracking parameter. */
  UTM_Medium__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM source tracking parameter. */
  UTM_Source__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM term tracking parameter. */
  UTM_Term__c?: InputMaybe<Scalars['String']['input']>;
  /**
   * Limit to 100 characters
   * Use the first 100 characters of Source_URL__c if missing
   */
  Web_MD_Domain__c?: InputMaybe<Scalars['String']['input']>;
  /** When true, skip creating transaction queue record if currentBalance > 0 (autopay mode) */
  isAutopay?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result type for createOneTimePayment. Returns CreateOneTimePaymentSuccess on success or CreateOneTimePaymentFailure on failure. */
export type CreateOneTimePaymentResult = CreateOneTimePaymentFailure | CreateOneTimePaymentSuccess;

/** Represents a successful one-time payment creation. */
export type CreateOneTimePaymentSuccess = {
  __typename?: 'CreateOneTimePaymentSuccess';
  /** Salesforce record ID of the created payment. */
  Id: Scalars['ID']['output'];
  /** Name of the created payment record. */
  Name: Scalars['String']['output'];
};

export type CreatePaymentInput = {
  Amount__c: Scalars['String']['input'];
  Contact__c: Scalars['String']['input'];
  Payment_Profile__c: Scalars['String']['input'];
  Schedule_Date__c: Scalars['String']['input'];
  Type__c: Scalars['String']['input'];
};

export type CreatePaymentProfileInput = {
  ACHBankName__c?: InputMaybe<Scalars['String']['input']>;
  ACHLast6__c?: InputMaybe<Scalars['String']['input']>;
  ACHRoutingLast9__c?: InputMaybe<Scalars['String']['input']>;
  ACH_Account_Type__c?: InputMaybe<Scalars['String']['input']>;
  ACH_Name_of_Account__c?: InputMaybe<Scalars['String']['input']>;
  Active__c?: InputMaybe<Scalars['Boolean']['input']>;
  Address_1__c?: InputMaybe<Scalars['String']['input']>;
  Address_2__c?: InputMaybe<Scalars['String']['input']>;
  Auth_Transaction_Id__c?: InputMaybe<Scalars['String']['input']>;
  CCLast4__c?: InputMaybe<Scalars['String']['input']>;
  Card_Type__c?: InputMaybe<Scalars['String']['input']>;
  City__c?: InputMaybe<Scalars['String']['input']>;
  Contact__c?: InputMaybe<Scalars['String']['input']>;
  Default__c?: InputMaybe<Scalars['Boolean']['input']>;
  Expiration_Month__c?: InputMaybe<Scalars['String']['input']>;
  Expiration_Year__c?: InputMaybe<Scalars['String']['input']>;
  Expired__c?: InputMaybe<Scalars['String']['input']>;
  Gateway_Token_Id__c?: InputMaybe<Scalars['String']['input']>;
  HSACard__c?: InputMaybe<Scalars['String']['input']>;
  Issuer_Country__c?: InputMaybe<Scalars['String']['input']>;
  Name_on_Card__c?: InputMaybe<Scalars['String']['input']>;
  PaymentType__c?: InputMaybe<PaymentTypeEnum>;
  States__c?: InputMaybe<Scalars['String']['input']>;
  Zipcode__c?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePhysicianPracticeStaffDomainError = CreatePhysicianPracticeStaffInvalidDataError;

/** A domain-specific failure while creating a new PhysicianPracticestaff */
export type CreatePhysicianPracticeStaffFailure = {
  __typename?: 'CreatePhysicianPracticeStaffFailure';
  /** All errors associated with failure. */
  errors: Array<CreatePhysicianPracticeStaffDomainError>;
};

export type CreatePhysicianPracticeStaffInput = {
  /** Email of the new PhysicianPracticestaff */
  Email: Scalars['String']['input'];
  /** First name of the new PhysicianPracticestaff */
  FirstName: Scalars['String']['input'];
  /** Last name of the new PhysicianPracticestaff */
  LastName: Scalars['String']['input'];
  /** MailingCity of the new PhysicianPracticestaff */
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  /** MailingPostalCode of the new PhysicianPracticestaff */
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** MailingState of the new PhysicianPracticestaff */
  MailingState?: InputMaybe<Scalars['String']['input']>;
  /** MailingStreet of the new PhysicianPracticestaff */
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  /**
   * MobilePhone of the new PhysicianPracticestaff
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone: Scalars['String']['input'];
  /**
   * Phone of the new PhysicianPracticestaff
   * Format: (XXX) XXX-XXXX
   */
  Phone: Scalars['String']['input'];
  /** Salutation of the new PhysicianPracticestaff */
  Salutation: Scalars['String']['input'];
  /** AccountId or ContactId for the new PhysicianPracticestaff */
  UserId: Scalars['String']['input'];
};

/** Invalid Data domain error */
export type CreatePhysicianPracticeStaffInvalidDataError = DomainError & {
  __typename?: 'CreatePhysicianPracticeStaffInvalidDataError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** A human-friendly error reason. */
  reason: Scalars['String']['output'];
};

export type CreatePhysicianPracticeStaffResult = CreatePhysicianPracticeStaffFailure | CreatePhysicianPracticeStaffSuccessResult;

export enum CreatePhysicianPracticeStaffSuccesStatus {
  Success = 'SUCCESS'
}

export type CreatePhysicianPracticeStaffSuccessResult = {
  __typename?: 'CreatePhysicianPracticeStaffSuccessResult';
  status: CreatePhysicianPracticeStaffSuccesStatus;
};

export type CreateProspectDomainError = CreateProspectInvalidContactIdError;

/** Union of all domain errors that can occur when creating a prospect F2F case. */
export type CreateProspectF2FCaseDomainError = CreateProspectF2FCaseInvalidDataError;

/** Encapsulates all domain errors for the createProspectF2FCase operation. */
export type CreateProspectF2FCaseFailure = {
  __typename?: 'CreateProspectF2FCaseFailure';
  /** All errors associated while creating a prospect f2f case. */
  errors: Array<CreateProspectF2FCaseDomainError>;
};

/** Input parameters for the createProspectF2FCase mutation. */
export type CreateProspectF2FCaseInput = {
  /** Salesforce Account ID of the physician for the new face-to-face case. */
  AccountID: Scalars['String']['input'];
  /** ContactID of the new prospect face-to-face case */
  ContactID: Scalars['String']['input'];
  /** Date of face to face appointment - Should follow 'MM/DD/YYYY' format */
  DateofFaceofFace?: InputMaybe<Scalars['String']['input']>;
  /** Physician name of the new prospect face-to-face case */
  PhysicianName: Scalars['String']['input'];
  /** ProfileName of the new prospect face-to-face case */
  ProfileName?: InputMaybe<Scalars['String']['input']>;
};

/** Domain error returned when the input data for creating a prospect F2F case is invalid. */
export type CreateProspectF2FCaseInvalidDataError = DomainError & {
  __typename?: 'CreateProspectF2FCaseInvalidDataError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for createProspectF2FCase. Returns CreateProspectF2FCaseSuccess on success or CreateProspectF2FCaseFailure on failure. */
export type CreateProspectF2FCaseResult = CreateProspectF2FCaseFailure | CreateProspectF2FCaseSuccess;

/** Represents a successful prospect F2F case creation. */
export type CreateProspectF2FCaseSuccess = {
  __typename?: 'CreateProspectF2FCaseSuccess';
  /** Success status of creating a new prospect f2f case */
  status?: Maybe<CreateProspectF2FCaseSuccessStatus>;
};

/** Defines the success status values for creating a prospect F2F case. */
export enum CreateProspectF2FCaseSuccessStatus {
  /** Means the Prospect F2F case successfully created */
  Success = 'SUCCESS'
}

/** A domain-specific failure to create a prospect. */
export type CreateProspectFailure = {
  __typename?: 'CreateProspectFailure';
  /** All errors associated while creating a prospect. */
  errors: Array<CreateProspectDomainError>;
};

export type CreateProspectInput = {
  /**
   * AcquisitionChannel of the new prospect
   *
   * Default: 'Field'
   */
  AcquisitionChannel?: InputMaybe<Scalars['String']['input']>;
  /**
   * AcquisitionSubChannel of the new prospect
   *
   * Default: 'Practice'
   */
  AcquisitionSubChannel?: InputMaybe<Scalars['String']['input']>;
  /** CampaignID of the new prospect */
  CampaignID?: InputMaybe<Scalars['String']['input']>;
  /** Contact Id of the new prospect */
  ContactId: Scalars['String']['input'];
  /** DOB of the new prospect - Should be 'MM/DD/YYYY' format or it will be rejected */
  DOB?: InputMaybe<Scalars['String']['input']>;
  /** Email of the new prospect */
  Email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fax from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Fax?: InputMaybe<Scalars['String']['input']>;
  /** FirstName of the new prospect */
  FirstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the new prospect */
  Gender?: InputMaybe<Scalars['String']['input']>;
  /** Insurance of the new prospect */
  Insurance?: InputMaybe<Scalars['String']['input']>;
  /** LastName of the new prospect */
  LastName: Scalars['String']['input'];
  /** LeadSource of the new prospect */
  LeadSource: Scalars['String']['input'];
  /** MDVIPCanContact of the new prospect */
  MDVIPCanContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** MailingCity of the new prospect */
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  /** MailingPostalCode of the new prospect */
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** MailingState of the new prospect */
  MailingState?: InputMaybe<Scalars['String']['input']>;
  /** MailingStreet of the new prospect */
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  /**
   * MobilePhone of the new prospect
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Phone of the new prospect
   * Format: (XXX) XXX-XXXX
   */
  Phone?: InputMaybe<Scalars['String']['input']>;
  /** ProfileName of the new prospect */
  ProfileName: Scalars['String']['input'];
  /** ReferralName of the new prospect */
  ReferralName?: InputMaybe<Scalars['String']['input']>;
  /** Salutation of the new prospect */
  Salutation?: InputMaybe<Scalars['String']['input']>;
  /** UserName of the new prospect */
  UserName: Scalars['String']['input'];
};

export type CreateProspectInvalidContactIdError = DomainError & {
  __typename?: 'CreateProspectInvalidContactIdError';
  /** ContactId field that was in the input */
  ContactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type CreateProspectPayload = {
  __typename?: 'CreateProspectPayload';
  LeadId: Scalars['String']['output'];
};

export type CreateProspectResult = CreateProspectFailure | CreateProspectPayload;

export type CreateReciprocityVisitInput = {
  Account__c?: InputMaybe<Scalars['String']['input']>;
  DOB_Provided__c?: InputMaybe<Scalars['String']['input']>;
  MDVIPID_Provided__c?: InputMaybe<Scalars['String']['input']>;
  Patient_Email_ID_Provided__c?: InputMaybe<Scalars['String']['input']>;
  Patient_First_Name__c?: InputMaybe<Scalars['String']['input']>;
  Patient_Home_Phone_Provided__c?: InputMaybe<Scalars['String']['input']>;
  Patient_Last_Name__c?: InputMaybe<Scalars['String']['input']>;
  Patient_Mobile_Phone_Provided__c?: InputMaybe<Scalars['String']['input']>;
  Reason_for_Visit__c?: InputMaybe<Scalars['String']['input']>;
  Referring_Physician__c?: InputMaybe<Scalars['String']['input']>;
  Visit_Date__c?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReferralType = {
  __typename?: 'CreateReferralType';
  ReferralId?: Maybe<Scalars['String']['output']>;
  SpecialistReferralId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreateThreadInput = {
  allowReply?: InputMaybe<Scalars['Boolean']['input']>;
  broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailBoxId?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<MessageThreadInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWaitlistEntryInput = {
  accountId: Scalars['ID']['input'];
  caseStatus?: InputMaybe<CaseStatus>;
  connectUserName: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  physicianName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  profileName: Scalars['String']['input'];
};

/** Union of all domain errors that can occur when deactivating a payment profile by ID. */
export type DeactivatePaymentProfileByIdDomainError = DeactivatePaymentProfileByIdNotFoundDomainError;

/** Encapsulates all domain errors for the deactivatePaymentProfileById operation. */
export type DeactivatePaymentProfileByIdFailure = {
  __typename?: 'DeactivatePaymentProfileByIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<DeactivatePaymentProfileByIdDomainError>;
};

/** Domain error returned when a payment profile is not found during deactivation. */
export type DeactivatePaymentProfileByIdNotFoundDomainError = {
  __typename?: 'DeactivatePaymentProfileByIdNotFoundDomainError';
  /** The payment profile ID that was not found. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for deactivatePaymentProfileById. Returns PaymentProfile on success or DeactivatePaymentProfileByIdFailure on failure. */
export type DeactivatePaymentProfileByIdResult = DeactivatePaymentProfileByIdFailure | PaymentProfile;

/** Union of all domain errors that can occur when retrieving the default payment profile. */
export type DefaultPaymentProfileDomainError = DefaultPaymentProfileNotFoundDomainError;

/** Encapsulates all domain errors for the defaultPaymentProfileForContact operation. */
export type DefaultPaymentProfileFailure = {
  __typename?: 'DefaultPaymentProfileFailure';
  /** List of domain errors that occurred. */
  errors: Array<DefaultPaymentProfileDomainError>;
};

/** Domain error returned when no default payment profile is found for the contact. */
export type DefaultPaymentProfileNotFoundDomainError = DomainError & {
  __typename?: 'DefaultPaymentProfileNotFoundDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for defaultPaymentProfileForContact. Returns PaymentProfile on success or DefaultPaymentProfileFailure on failure. */
export type DefaultPaymentProfileResult = DefaultPaymentProfileFailure | PaymentProfile;

/** Union of all domain errors that can occur when deleting a message by ID. */
export type DeleteMessageByIdDomainError = DeleteMessageByIdInvalidIdError | DeleteMessageByIdInvalidMailboxIdError | DeleteMessageByIdInvalidThreadIdError | DeleteMessageByIdNotFoundError;

/** Encapsulates all domain errors for the deleteMessageById operation. */
export type DeleteMessageByIdFailure = {
  __typename?: 'DeleteMessageByIdFailure';
  /** List of domain errors that occurred during message deletion. */
  errors: Array<DeleteMessageByIdDomainError>;
};

/** Input parameters for the deleteMessageById mutation. */
export type DeleteMessageByIdInput = {
  /** Unique identifier of the message to delete. */
  id: Scalars['ID']['input'];
  /** Unique identifier of the mailbox containing the message. */
  mailboxId: Scalars['ID']['input'];
  /** Unique identifier of the thread containing the message. */
  threadId: Scalars['ID']['input'];
};

/** Domain error returned when the message ID is invalid for the delete request. */
export type DeleteMessageByIdInvalidIdError = DomainError & {
  __typename?: 'DeleteMessageByIdInvalidIdError';
  /** The invalid message ID that was provided. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the mailbox ID is invalid for the delete message request. */
export type DeleteMessageByIdInvalidMailboxIdError = DomainError & {
  __typename?: 'DeleteMessageByIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the thread ID is invalid for the delete message request. */
export type DeleteMessageByIdInvalidThreadIdError = DomainError & {
  __typename?: 'DeleteMessageByIdInvalidThreadIdError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The invalid thread ID that was provided. */
  threadId: Scalars['ID']['output'];
};

/** Domain error returned when the message to delete is not found. */
export type DeleteMessageByIdNotFoundError = DomainError & {
  __typename?: 'DeleteMessageByIdNotFoundError';
  /** The message ID that was not found. */
  id: Scalars['ID']['output'];
  /** The mailbox ID that was searched. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The thread ID that was searched. */
  threadId: Scalars['ID']['output'];
};

/** Result type for deleteMessageById. Returns DeleteMessageByIdSuccess on success or DeleteMessageByIdFailure on failure. */
export type DeleteMessageByIdResult = DeleteMessageByIdFailure | DeleteMessageByIdSuccess | MailboxByIdFailure;

/** Represents a successful deletion of a message. */
export type DeleteMessageByIdSuccess = {
  __typename?: 'DeleteMessageByIdSuccess';
  /** Unique identifier of the deleted message. */
  id: Scalars['ID']['output'];
  /** Unique identifier of the mailbox that contained the deleted message. */
  mailboxId: Scalars['ID']['output'];
  /** Unique identifier of the thread that contained the deleted message. */
  threadId: Scalars['ID']['output'];
};

export type DeleteMessageInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  mailboxId?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};

/** Union of all domain errors that can occur when deleting a message thread by ID. */
export type DeleteMessageThreadByIdDomainError = DeleteMessageThreadByIdInvalidIdError | DeleteMessageThreadByIdInvalidMailboxIdError | DeleteMessageThreadByIdNotFoundError;

/** Encapsulates all domain errors for the deleteMessageThreadById operation. */
export type DeleteMessageThreadByIdFailure = {
  __typename?: 'DeleteMessageThreadByIdFailure';
  /** List of domain errors that occurred during message thread deletion. */
  errors: Array<DeleteMessageThreadByIdDomainError>;
};

/** Input parameters for the deleteMessageThreadById mutation. */
export type DeleteMessageThreadByIdInput = {
  /** Unique identifier of the thread to delete. */
  id: Scalars['ID']['input'];
  /** Unique identifier of the mailbox containing the thread. */
  mailboxId: Scalars['ID']['input'];
};

/** Domain error returned when the thread ID is invalid for the delete thread request. */
export type DeleteMessageThreadByIdInvalidIdError = DomainError & {
  __typename?: 'DeleteMessageThreadByIdInvalidIdError';
  /** The invalid thread ID that was provided. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the mailbox ID is invalid for the delete thread request. */
export type DeleteMessageThreadByIdInvalidMailboxIdError = DomainError & {
  __typename?: 'DeleteMessageThreadByIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the message thread to delete is not found. */
export type DeleteMessageThreadByIdNotFoundError = DomainError & {
  __typename?: 'DeleteMessageThreadByIdNotFoundError';
  /** The thread ID that was not found. */
  id: Scalars['ID']['output'];
  /** The mailbox ID that was searched. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for deleteMessageThreadById. Returns DeleteMessageThreadByIdSuccess on success or DeleteMessageThreadByIdFailure on failure. */
export type DeleteMessageThreadByIdResult = DeleteMessageThreadByIdFailure | DeleteMessageThreadByIdSuccess | MailboxByIdFailure;

/** Represents a successful deletion of a message thread. */
export type DeleteMessageThreadByIdSuccess = {
  __typename?: 'DeleteMessageThreadByIdSuccess';
  /** Unique identifier of the deleted thread. */
  id: Scalars['ID']['output'];
  /** Unique identifier of the mailbox that contained the deleted thread. */
  mailboxId: Scalars['ID']['output'];
};

/** Represents a domain-specific error returned by this subgraph when a business rule violation occurs. */
export type DomainError = {
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type DynamicEmailType = {
  __typename?: 'DynamicEmailType';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  senderAddress?: InputMaybe<Scalars['String']['input']>;
};

export type EmailResponseError = {
  __typename?: 'EmailResponseError';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
};

export type EmailResponseType = {
  __typename?: 'EmailResponseType';
  actionName?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<EmailResponseError>>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  outputValues?: Maybe<Scalars['String']['output']>;
};

export type EmailType = {
  __typename?: 'EmailType';
  emailAddressesArray?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailBody?: Maybe<Scalars['String']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  senderAddress?: Maybe<Scalars['String']['output']>;
  senderType?: Maybe<Scalars['String']['output']>;
};

export type EnableAutopaySuccess = {
  __typename?: 'EnableAutopaySuccess';
  /** A human-friendly success message. */
  message: Scalars['String']['output'];
};

export type EnableMemberAutopayByContactIdDomainError = EnableMemberAutopayByContactIdInvalidContactIdError;

export type EnableMemberAutopayByContactIdFailure = {
  __typename?: 'EnableMemberAutopayByContactIdFailure';
  /** All errors associated with required Member By Id. */
  errors: Array<EnableMemberAutopayByContactIdDomainError>;
};

export type EnableMemberAutopayByContactIdInvalidContactIdError = DomainError & {
  __typename?: 'EnableMemberAutopayByContactIdInvalidContactIdError';
  /** ContactId that was included in the query */
  ContactId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type EnableMemberAutopayByContactIdResult = EnableAutopaySuccess | EnableMemberAutopayByContactIdFailure | Member;

/**
 * This enum is the extended version of the PaymentProfilePaymentType enum
 * The reason why we introduced this is because we only use `Check` for listing purpose.
 */
export enum ExtendedPaymentProfilePaymentType {
  /** ACH bank account transfer */
  Ach = 'ACH',
  /** American Express credit card */
  Amex = 'AMEX',
  /** Check payment (used for listing only) */
  Check = 'Check',
  /** Discover credit or debit card */
  Disc = 'DISC',
  /** Mastercard credit or debit card */
  Mc = 'MC',
  /** Visa credit or debit card */
  Visa = 'VISA'
}

export type F2FCaseType = {
  __typename?: 'F2FCaseType';
  AccountId?: Maybe<Scalars['String']['output']>;
  ContactId?: Maybe<Scalars['String']['output']>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  Date_of_Face_to_Face__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  LastModifiedDate?: Maybe<Scalars['String']['output']>;
  Meeting_Time__c?: Maybe<Scalars['String']['output']>;
  Result__c?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

export type FaqType = {
  __typename?: 'FaqType';
  field_answer?: Maybe<Scalars['String']['output']>;
  field_faq_category?: Maybe<Scalars['CategoryScalar']['output']>;
  field_question?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** Represents a Salesforce Feature_Flag__c record controlling portal feature visibility for a user. */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** Whether the AWP Audit feature is enabled. */
  AWPAudit__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the AWP Create feature is enabled. */
  AWPCreate__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the AWP Manage feature is enabled. */
  AWPManage__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the AWP Plus feature is enabled. */
  AWPPlus__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the AWP Read feature is enabled. */
  AWPRead__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the physician is accepting junior members. */
  AcceptingJuniorMembers__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Analytics Report feature is enabled. */
  AnalyticsReport__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Apparel and Merchandise feature is enabled. */
  ApparelandMerchandise__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Cardiology feature is enabled. */
  Cardiology__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Collateral and Stationery feature is enabled. */
  CollateralandStationary__c?: Maybe<Scalars['Boolean']['output']>;
  /** Salesforce Contact ID (Contact__c custom field). */
  Contact__c: Scalars['ID']['output'];
  /** Whether the Endocrinology feature is enabled. */
  Endocrinology__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Events and Marketing Materials feature is enabled. */
  EventsandMarketingMaterials__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Financial Reports feature is enabled. */
  FinancialReports__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Foundation feature is enabled. */
  Foundation__c?: Maybe<Scalars['Boolean']['output']>;
  /** Salesforce record ID. */
  Id: Scalars['ID']['output'];
  /** Whether the MCE Referrals feature is enabled. */
  MCEReferrals__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the MDVIP Webmail feature is enabled. */
  MDVIPWebmail__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Manage CHL feature is enabled. */
  ManageCHL__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Manage Group Practice feature is enabled. */
  ManageGroupPractice__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Manage Office Hours feature is enabled. */
  ManageOfficeHours__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Manage Payments feature is enabled. */
  ManagePayments__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Manage Portal User feature is enabled. */
  ManagePortalUser__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Medical Resources feature is enabled. */
  MedicalResources__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Member Satisfaction feature is enabled. */
  MemberSatisfaction__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Men's Health feature is enabled. */
  MensHealth__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the My Events feature is enabled. */
  MyEvents__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the My Initiatives feature is enabled. */
  MyInitiatives__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the My Waiting List feature is enabled. */
  MyWaitinglist__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Notifications feature is enabled. */
  Notifications__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Office Depot / Office Max feature is enabled. */
  OfficeDepotOfficeMax__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Patients feature is enabled. */
  Patients__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Pediatric feature is enabled. */
  Pediatric__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Programs feature is enabled. */
  Programs__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Prospects feature is enabled. */
  Prospects__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Reciprocity Visit feature is enabled. */
  ReciprocityVisit__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Secure Messaging feature is enabled. */
  SecureMessaging__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Secure Messaging Read-Only feature is enabled. */
  SecureMsg_Read_Only__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Staples.com feature is enabled. */
  Staplesdotcom__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the To-Dos feature is enabled. */
  ToDos__c?: Maybe<Scalars['Boolean']['output']>;
  /** Salesforce User ID (User__c custom field). */
  User__c: Scalars['ID']['output'];
  /** Whether the Value-Based Care feature is enabled. */
  ValueBasedCare__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Women's Health feature is enabled. */
  WomensHealth__c?: Maybe<Scalars['Boolean']['output']>;
};

/** Union of all domain errors that can occur when retrieving a feature flag by Connect user ID. */
export type FeatureFlagByConnectUserIdDomainError = FeatureFlagByConnectUserIdNotFoundError;

/** Encapsulates all domain errors for the featureFlagByConnectUserId operation. */
export type FeatureFlagByConnectUserIdFailure = {
  __typename?: 'FeatureFlagByConnectUserIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<FeatureFlagByConnectUserIdDomainError>;
};

/** Domain error returned when a feature flag record is not found for the given Connect user ID. */
export type FeatureFlagByConnectUserIdNotFoundError = DomainError & {
  __typename?: 'FeatureFlagByConnectUserIdNotFoundError';
  /** The Connect user ID that was not found. */
  connectUserId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for featureFlagByConnectUserId. Returns FeatureFlag on success or FeatureFlagByConnectUserIdFailure on failure. */
export type FeatureFlagByConnectUserIdResult = FeatureFlag | FeatureFlagByConnectUserIdFailure;

/** Union of all domain errors that can occur when retrieving a feature flag by contact ID. */
export type FeatureFlagByContactIdDomainError = FeatureFlagByContactIdMissingInputError | FeatureFlagByContactIdNotFoundError;

/** Encapsulates all domain errors for the featureFlagByContactId operation. */
export type FeatureFlagByContactIdFailure = {
  __typename?: 'FeatureFlagByContactIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<FeatureFlagByContactIdDomainError>;
};

/** Domain error returned when the required contact ID input is missing. */
export type FeatureFlagByContactIdMissingInputError = DomainError & {
  __typename?: 'FeatureFlagByContactIdMissingInputError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when a feature flag record is not found for the given contact ID. */
export type FeatureFlagByContactIdNotFoundError = DomainError & {
  __typename?: 'FeatureFlagByContactIdNotFoundError';
  /** The contact ID that was not found. */
  contactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for featureFlagByContactId. Returns FeatureFlag on success or FeatureFlagByContactIdFailure on failure. */
export type FeatureFlagByContactIdResult = FeatureFlag | FeatureFlagByContactIdFailure;

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  AWPAudit__c?: Maybe<Scalars['Boolean']['output']>;
  AWPCreate__c?: Maybe<Scalars['Boolean']['output']>;
  AWPManage__c?: Maybe<Scalars['Boolean']['output']>;
  AWPPlus__c?: Maybe<Scalars['Boolean']['output']>;
  AWPRead__c?: Maybe<Scalars['Boolean']['output']>;
  AcceptingJuniorMembers__c?: Maybe<Scalars['Boolean']['output']>;
  AnalyticsReport__c?: Maybe<Scalars['Boolean']['output']>;
  ApparelandMerchandise__c?: Maybe<Scalars['Boolean']['output']>;
  CollateralandStationary__c?: Maybe<Scalars['Boolean']['output']>;
  EventsandMarketingMaterials__c?: Maybe<Scalars['Boolean']['output']>;
  FinancialReports__c?: Maybe<Scalars['Boolean']['output']>;
  Foundation__c?: Maybe<Scalars['Boolean']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  MCEReferrals__c?: Maybe<Scalars['Boolean']['output']>;
  MDVIPWebmail__c?: Maybe<Scalars['Boolean']['output']>;
  ManageCHL__c?: Maybe<Scalars['Boolean']['output']>;
  ManageGroupPractice__c?: Maybe<Scalars['Boolean']['output']>;
  ManageOfficeHours__c?: Maybe<Scalars['Boolean']['output']>;
  ManagePayments__c?: Maybe<Scalars['Boolean']['output']>;
  ManagePortalUser__c?: Maybe<Scalars['Boolean']['output']>;
  MedicalResources__c?: Maybe<Scalars['Boolean']['output']>;
  MemberSatisfaction__c?: Maybe<Scalars['Boolean']['output']>;
  MyEvents__c?: Maybe<Scalars['Boolean']['output']>;
  MyInitiatives__c?: Maybe<Scalars['Boolean']['output']>;
  MyWaitinglist__c?: Maybe<Scalars['Boolean']['output']>;
  Notifications__c?: Maybe<Scalars['Boolean']['output']>;
  OfficeDepotOfficeMax__c?: Maybe<Scalars['Boolean']['output']>;
  Patients__c?: Maybe<Scalars['Boolean']['output']>;
  Programs__c?: Maybe<Scalars['Boolean']['output']>;
  Prospects__c?: Maybe<Scalars['Boolean']['output']>;
  ReciprocityVisit__c?: Maybe<Scalars['Boolean']['output']>;
  SecureMessaging__c?: Maybe<Scalars['Boolean']['output']>;
  Staplesdotcom__c?: Maybe<Scalars['Boolean']['output']>;
  ToDos__c?: Maybe<Scalars['Boolean']['output']>;
  WomensHealth__c?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureFlagsInput = {
  AWPAudit__c?: InputMaybe<Scalars['Boolean']['input']>;
  AWPCreate__c?: InputMaybe<Scalars['Boolean']['input']>;
  AWPManage__c?: InputMaybe<Scalars['Boolean']['input']>;
  AWPPlus__c?: InputMaybe<Scalars['Boolean']['input']>;
  AWPRead__c?: InputMaybe<Scalars['Boolean']['input']>;
  AcceptingJuniorMembers__c?: InputMaybe<Scalars['Boolean']['input']>;
  AnalyticsReport__c?: InputMaybe<Scalars['Boolean']['input']>;
  ApparelandMerchandise__c?: InputMaybe<Scalars['Boolean']['input']>;
  CollateralandStationary__c?: InputMaybe<Scalars['Boolean']['input']>;
  EventsandMarketingMaterials__c?: InputMaybe<Scalars['Boolean']['input']>;
  FinancialReports__c?: InputMaybe<Scalars['Boolean']['input']>;
  Foundation__c?: InputMaybe<Scalars['Boolean']['input']>;
  MCEReferrals__c?: InputMaybe<Scalars['Boolean']['input']>;
  MDVIPWebmail__c?: InputMaybe<Scalars['Boolean']['input']>;
  ManageCHL__c?: InputMaybe<Scalars['Boolean']['input']>;
  ManageGroupPractice__c?: InputMaybe<Scalars['Boolean']['input']>;
  ManageOfficeHours__c?: InputMaybe<Scalars['Boolean']['input']>;
  ManagePayments__c?: InputMaybe<Scalars['Boolean']['input']>;
  ManagePortalUser__c?: InputMaybe<Scalars['Boolean']['input']>;
  MedicalResources__c?: InputMaybe<Scalars['Boolean']['input']>;
  MemberSatisfaction__c?: InputMaybe<Scalars['Boolean']['input']>;
  MyEvents__c?: InputMaybe<Scalars['Boolean']['input']>;
  MyInitiatives__c?: InputMaybe<Scalars['Boolean']['input']>;
  MyWaitinglist__c?: InputMaybe<Scalars['Boolean']['input']>;
  Notifications__c?: InputMaybe<Scalars['Boolean']['input']>;
  OfficeDepotOfficeMax__c?: InputMaybe<Scalars['Boolean']['input']>;
  Patients__c?: InputMaybe<Scalars['Boolean']['input']>;
  Programs__c?: InputMaybe<Scalars['Boolean']['input']>;
  Prospects__c?: InputMaybe<Scalars['Boolean']['input']>;
  ReciprocityVisit__c?: InputMaybe<Scalars['Boolean']['input']>;
  SecureMessaging__c?: InputMaybe<Scalars['Boolean']['input']>;
  Staplesdotcom__c?: InputMaybe<Scalars['Boolean']['input']>;
  ToDos__c?: InputMaybe<Scalars['Boolean']['input']>;
  WomensHealth__c?: InputMaybe<Scalars['Boolean']['input']>;
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export type FoundationInput = {
  Amount?: InputMaybe<Scalars['String']['input']>;
  Frequency?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  PhysicianId?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
};

export type FoundationType = {
  __typename?: 'FoundationType';
  Amount?: Maybe<Scalars['String']['output']>;
  EndDate?: Maybe<Scalars['String']['output']>;
  Frequency?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  PhyRollOutId?: Maybe<Scalars['String']['output']>;
  PhysicianId?: Maybe<Scalars['String']['output']>;
  StartDate?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

export type GetAllThreadsInput = {
  mailboxId: Scalars['ID']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  toMailboxId?: InputMaybe<Scalars['String']['input']>;
};

export type InitiativesInput = {
  CampaignID?: InputMaybe<Scalars['String']['input']>;
  ContactID?: InputMaybe<Scalars['String']['input']>;
  Engagement__c?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
};

export type InitiativesType = {
  __typename?: 'InitiativesType';
  CampaignMembers?: Maybe<Array<Maybe<CampaignMemberType>>>;
  Campaign__c?: Maybe<Scalars['String']['output']>;
  End_Date__c?: Maybe<Scalars['String']['output']>;
  Engagement__c?: Maybe<Scalars['String']['output']>;
  Enrollees?: Maybe<Scalars['Int']['output']>;
  Id: Scalars['String']['output'];
  Launch_Date__c?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Target_Audience__c?: Maybe<Scalars['String']['output']>;
};

/** Represents the insurance information associated with a member. */
export type Insurance = {
  __typename?: 'Insurance';
  /** Insurance company name. */
  Name?: Maybe<Scalars['String']['output']>;
};

export type InsuranceType = {
  __typename?: 'InsuranceType';
  Name?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<AttributeType>;
};

/** Represents a Litle gateway error code mapping to a member-facing message. */
export type LitleErrorByCode = {
  __typename?: 'LitleErrorByCode';
  /** Member portal error message for this response code. */
  MemberPortal__c?: Maybe<Scalars['String']['output']>;
  /** Litle gateway response code (ResponseCode__c custom field). */
  ResponseCode__c: Scalars['ID']['output'];
};

/** Union of all domain errors that can occur when retrieving a Litle error by code. */
export type LitleErrorByCodeDomainError = LitleErrorByCodeNotFoundDomainError;

/** Encapsulates all domain errors for the litleErrorByCode operation. */
export type LitleErrorByCodeFailure = {
  __typename?: 'LitleErrorByCodeFailure';
  /** List of domain errors that occurred. */
  errors: Array<LitleErrorByCodeDomainError>;
};

/** Domain error returned when a Litle error code is not found. */
export type LitleErrorByCodeNotFoundDomainError = {
  __typename?: 'LitleErrorByCodeNotFoundDomainError';
  /** The Litle response code that was not found. */
  code: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for litleErrorByCode. Returns LitleErrorByCode on success or LitleErrorByCodeFailure on failure. */
export type LitleErrorByCodeResult = LitleErrorByCode | LitleErrorByCodeFailure;

export type LitleInterfaceDetailsType = {
  __typename?: 'LitleInterfaceDetailsType';
  LitleEnvelopeClose__c?: Maybe<Scalars['String']['output']>;
  LitleEnvelopeOpen__c?: Maybe<Scalars['String']['output']>;
  LitlePassword__c?: Maybe<Scalars['String']['output']>;
  LitlePayPageURL__c?: Maybe<Scalars['String']['output']>;
  LitlePayPage__c?: Maybe<Scalars['String']['output']>;
  LitleURL__c?: Maybe<Scalars['String']['output']>;
  LitleUserName__c?: Maybe<Scalars['String']['output']>;
  MerchantTxnId__c?: Maybe<Scalars['Int']['output']>;
  PayPageId__c?: Maybe<Scalars['String']['output']>;
  ReportGroup__c?: Maybe<Scalars['String']['output']>;
  RoutingNumber__c?: Maybe<Scalars['String']['output']>;
  ValidateFSA__c?: Maybe<Scalars['Boolean']['output']>;
  eProtect_Endpoint__c?: Maybe<Scalars['String']['output']>;
  eProtect_Password__c?: Maybe<Scalars['String']['output']>;
  eProtect_Username__c?: Maybe<Scalars['String']['output']>;
};

/** Represents the Litle (Worldpay) payment gateway configuration settings. */
export type LitleSettings = {
  __typename?: 'LitleSettings';
  /** Litle gateway password. */
  LitlePassword__c: Scalars['String']['output'];
  /** Litle gateway URL endpoint. */
  LitleURL__c: Scalars['String']['output'];
  /** Litle gateway username. */
  LitleUserName__c: Scalars['String']['output'];
  /** Merchant transaction identifier counter. */
  MerchantTxnId__c: Scalars['Int']['output'];
  /** PayPage identifier for hosted payment form. */
  PayPageId__c: Scalars['String']['output'];
  /** Report group for transaction categorization. */
  ReportGroup__c: Scalars['String']['output'];
  /** ACH routing number for bank transfers. */
  RoutingNumber__c: Scalars['String']['output'];
  /** eProtect tokenization service endpoint URL. */
  eProtect_Endpoint__c: Scalars['String']['output'];
  /** eProtect tokenization service password. */
  eProtect_Password__c: Scalars['String']['output'];
  /** eProtect tokenization service username. */
  eProtect_Username__c: Scalars['String']['output'];
};

/** Union of all domain errors that can occur when retrieving Litle settings. */
export type LitleSettingsDomainError = LitleSettingsNotFoundDomainError;

/** Encapsulates all domain errors for the litleSettings operation. */
export type LitleSettingsFailure = {
  __typename?: 'LitleSettingsFailure';
  /** List of domain errors that occurred. */
  errors: Array<LitleSettingsDomainError>;
};

/** Domain error returned when Litle settings are not found. */
export type LitleSettingsNotFoundDomainError = {
  __typename?: 'LitleSettingsNotFoundDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for litleSettings. Returns LitleSettings on success or LitleSettingsFailure on failure. */
export type LitleSettingsResult = LitleSettings | LitleSettingsFailure;

export type McReferralInput = {
  AlternatePhone?: InputMaybe<Scalars['String']['input']>;
  ConfirmationOfReleaseOnFile?: InputMaybe<Scalars['Boolean']['input']>;
  ContactSFID?: InputMaybe<Scalars['String']['input']>;
  Diagnosis?: InputMaybe<Scalars['String']['input']>;
  DoNotSendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  EmployerAddress?: InputMaybe<Scalars['String']['input']>;
  EmployerCity?: InputMaybe<Scalars['String']['input']>;
  EmployerName?: InputMaybe<Scalars['String']['input']>;
  EmployerState?: InputMaybe<Scalars['String']['input']>;
  EmployerZip?: InputMaybe<Scalars['String']['input']>;
  Facility?: InputMaybe<Scalars['String']['input']>;
  GroupNumber?: InputMaybe<Scalars['String']['input']>;
  HealthInsurerName?: InputMaybe<Scalars['String']['input']>;
  InsuranceType?: InputMaybe<Scalars['String']['input']>;
  MDVIPApprovedToSpeakTo?: InputMaybe<Scalars['String']['input']>;
  MaritalStatus?: InputMaybe<Scalars['String']['input']>;
  Notes?: InputMaybe<Scalars['String']['input']>;
  Occupation?: InputMaybe<Scalars['String']['input']>;
  PhysicianSFID?: InputMaybe<Scalars['String']['input']>;
  PolicyHolder?: InputMaybe<Scalars['String']['input']>;
  PolicyHolderDOB?: InputMaybe<Scalars['String']['input']>;
  PolicyHolderName?: InputMaybe<Scalars['String']['input']>;
  PolicyHolderOccupation?: InputMaybe<Scalars['String']['input']>;
  PolicyNumber?: InputMaybe<Scalars['String']['input']>;
  PreferredLanguage?: InputMaybe<Scalars['String']['input']>;
  PrimaryPhone?: InputMaybe<Scalars['String']['input']>;
  Race?: InputMaybe<Scalars['String']['input']>;
  RelationshipToPolicyHolder?: InputMaybe<Scalars['String']['input']>;
  SSN?: InputMaybe<Scalars['String']['input']>;
  SecondaryGroupNumber?: InputMaybe<Scalars['String']['input']>;
  SecondaryHealthInsurerName?: InputMaybe<Scalars['String']['input']>;
  SecondaryInsuranceType?: InputMaybe<Scalars['String']['input']>;
  SecondaryPolicyHolder?: InputMaybe<Scalars['String']['input']>;
  SecondaryPolicyHolderDOB?: InputMaybe<Scalars['String']['input']>;
  SecondaryPolicyHolderName?: InputMaybe<Scalars['String']['input']>;
  SecondaryPolicyHolderOccupation?: InputMaybe<Scalars['String']['input']>;
  SecondaryPolicyNumber?: InputMaybe<Scalars['String']['input']>;
  SecondaryRelationshipToPolicyHolder?: InputMaybe<Scalars['String']['input']>;
  SpecialRequest?: InputMaybe<Scalars['String']['input']>;
  Specialty?: InputMaybe<Scalars['String']['input']>;
  Spouse?: InputMaybe<Scalars['String']['input']>;
  WorkEmailAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a detailed MDVIP user profile from Salesforce. */
export type MdvipUserProfile = {
  __typename?: 'MDVIPUserProfile';
  /** Whether the physician is accepting new patients (Accepting_Patients__c custom field). */
  Accepting_Patients__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce Account ID linked to the user. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Physician's actual website URL (Actual_Website__c custom field). */
  Actual_Website__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact ID linked to the user. */
  ContactId?: Maybe<Scalars['String']['output']>;
  /** Email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** First name of the user. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Unique Salesforce user record ID. */
  Id: Scalars['ID']['output'];
  /** Lab user identifier (Lab_User_ID__c custom field). */
  Lab_User_ID__c?: Maybe<Scalars['String']['output']>;
  /** Last name of the user. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** MDVIP identifier (MDVIPID__c custom field). */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox ID (MFMailboxID__c custom field). */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Office or home phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Physician identifier (PhysicianID__c custom field). */
  PhysicianID__c?: Maybe<Scalars['String']['output']>;
  /** URL of the physician's profile image (Physician_Image_URL__c custom field). */
  Physician_Image_URL__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce profile name associated with the user. */
  ProfileName: Scalars['String']['output'];
  /** Unqualified username (UserNameNotQualified__c custom field). */
  UserNameNotQualified__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce username. */
  Username: Scalars['String']['output'];
};

/** Union of all domain errors that can occur when retrieving an MDVIP user profile. */
export type MdvipUserProfileDomainError = MdvipUserProfileNotFoundError;

/** Encapsulates all domain errors for the mdvipUserProfile operation. */
export type MdvipUserProfileFailure = {
  __typename?: 'MDVIPUserProfileFailure';
  /** All errors associated with required Account. */
  errors: Array<MdvipUserProfileDomainError>;
};

/** Input parameters for the mdvipUserProfile query. */
export type MdvipUserProfileInput = {
  /** Salesforce/Connect user ID to look up the user profile for. */
  Id?: InputMaybe<Scalars['ID']['input']>;
};

/** Domain error returned when an MDVIP user profile is not found for the given ID. */
export type MdvipUserProfileNotFoundError = DomainError & {
  __typename?: 'MDVIPUserProfileNotFoundError';
  /** Id that was included in the query */
  Id: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for mdvipUserProfile. Returns MDVIPUserProfile on success or MDVIPUserProfileFailure on failure. */
export type MdvipUserProfileResult = MdvipUserProfile | MdvipUserProfileFailure;

/** Represents a secure messaging mailbox belonging to a user. */
export type Mailbox = {
  __typename?: 'Mailbox';
  /** Custom away message displayed when away status is enabled. */
  awayMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the mailbox owner has enabled away status. */
  awayStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the mailbox. */
  id: Scalars['ID']['output'];
  /** Display name of the mailbox owner. */
  name: Scalars['String']['output'];
  /** Number of unread messages in the mailbox. */
  unreadMessageCount: Scalars['Int']['output'];
  /** Number of threads containing unread messages. */
  unreadThreadCount: Scalars['Int']['output'];
};

/** Union of all domain errors that can occur when retrieving a mailbox by ID. */
export type MailboxByIdDomainError = MailboxByIdForbiddenError | MailboxByIdInvalidMailboxIdError | MailboxByIdNotFoundError | MailboxByIdUnauthorizedError | MailboxByIdValidateMailboxInternalError;

/** Encapsulates all domain errors for the mailboxById operation. */
export type MailboxByIdFailure = {
  __typename?: 'MailboxByIdFailure';
  /** List of domain errors that occurred during mailbox retrieval. */
  errors: Array<MailboxByIdDomainError>;
};

/** Domain error returned when the user is forbidden from accessing the mailbox. */
export type MailboxByIdForbiddenError = DomainError & {
  __typename?: 'MailboxByIdForbiddenError';
  /** The mailbox ID the user is forbidden from accessing. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Input parameters for the mailboxById query. */
export type MailboxByIdInput = {
  /** Unique identifier of the mailbox to retrieve. */
  id: Scalars['ID']['input'];
};

/** Domain error returned when the provided mailbox ID is invalid. */
export type MailboxByIdInvalidMailboxIdError = DomainError & {
  __typename?: 'MailboxByIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the requested mailbox is not found. */
export type MailboxByIdNotFoundError = DomainError & {
  __typename?: 'MailboxByIdNotFoundError';
  /** The mailbox ID that was not found. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for mailboxById. Returns Mailbox on success or MailboxByIdFailure on failure. */
export type MailboxByIdResult = Mailbox | MailboxByIdFailure;

/** Domain error returned when the user is unauthorized to access the mailbox. */
export type MailboxByIdUnauthorizedError = DomainError & {
  __typename?: 'MailboxByIdUnauthorizedError';
  /** The mailbox ID the user is unauthorized to access. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when an internal error occurs while validating the mailbox. */
export type MailboxByIdValidateMailboxInternalError = DomainError & {
  __typename?: 'MailboxByIdValidateMailboxInternalError';
  /** The mailbox ID that caused the internal validation error. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Represents aggregate metadata counts for a mailbox. */
export type MailboxMetadata = {
  __typename?: 'MailboxMetadata';
  /** Total number of archived messages. */
  totalArchivedMessageCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of draft messages. */
  totalDraftMessageCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of messages in the inbox. */
  totalInboxMessageCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of starred messages. */
  totalStarredMessageCount?: Maybe<Scalars['Int']['output']>;
  /** Number of unread archived messages. */
  unreadArchivedMessageCount?: Maybe<Scalars['Int']['output']>;
  /** Number of unread messages in the inbox. */
  unreadInboxMessageCount?: Maybe<Scalars['Int']['output']>;
  /** Number of unread starred messages. */
  unreadStarredMessageCount?: Maybe<Scalars['Int']['output']>;
};

/** Union of all domain errors that can occur when retrieving mailbox metadata by ID. */
export type MailboxMetadataByIdDomainError = MailboxByIdForbiddenError | MailboxByIdInvalidMailboxIdError | MailboxByIdNotFoundError | MailboxByIdUnauthorizedError | MailboxByIdValidateMailboxInternalError | MailboxMetadataByIdNotFoundError;

/** Encapsulates all domain errors for the mailboxMetadataById operation. */
export type MailboxMetadataByIdFailure = {
  __typename?: 'MailboxMetadataByIdFailure';
  /** All errors associated with the mailbox metadata retrieval. */
  errors: Array<MailboxMetadataByIdDomainError>;
};

/** Domain error returned when mailbox metadata is not found for the given ID. */
export type MailboxMetadataByIdNotFoundError = DomainError & {
  __typename?: 'MailboxMetadataByIdNotFoundError';
  /** The mailbox ID for which metadata was not found. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for mailboxMetadataById. Returns MailboxMetadata on success or MailboxMetadataByIdFailure on failure. */
export type MailboxMetadataByIdResult = MailboxByIdFailure | MailboxMetadata | MailboxMetadataByIdFailure;

export type MailboxType = {
  __typename?: 'MailboxType';
  awayMessage?: Maybe<Scalars['String']['output']>;
  awayStatus?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
  unreadThreadCount?: Maybe<Scalars['Int']['output']>;
};

export type ManageF2FCaseInput = {
  CaseID?: InputMaybe<Scalars['String']['input']>;
  DateofFaceofFace?: InputMaybe<Scalars['String']['input']>;
  MeetingTime?: InputMaybe<Scalars['String']['input']>;
  ProfileName?: InputMaybe<Scalars['String']['input']>;
  Result?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<ManageProspectCaseEnum>;
  UserName?: InputMaybe<Scalars['String']['input']>;
};

export enum ManageProspectCaseEnum {
  AppointmentCancelled = 'AppointmentCancelled',
  AppointmentCompleted = 'AppointmentCompleted',
  AppointmentRefused = 'AppointmentRefused',
  AppointmentScheduled = 'AppointmentScheduled'
}

/** Union of all domain errors that can occur when retrieving maximum payment amount. */
export type MaximumPaymentAmountDomainError = MaximumPaymentAmountNotFoundDomainError;

/** Encapsulates all domain errors for the maximumPaymentAmount operation. */
export type MaximumPaymentAmountFailure = {
  __typename?: 'MaximumPaymentAmountFailure';
  /** List of domain errors that occurred. */
  errors: Array<MaximumPaymentAmountDomainError>;
};

/** Domain error returned when the maximum payment amount setting is not found. */
export type MaximumPaymentAmountNotFoundDomainError = {
  __typename?: 'MaximumPaymentAmountNotFoundDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for maximumPaymentAmount. Returns MaximumPaymentAmountSettings on success or MaximumPaymentAmountFailure on failure. */
export type MaximumPaymentAmountResult = MaximumPaymentAmountFailure | MaximumPaymentAmountSettings;

/** Represents the maximum payment amount configuration setting. */
export type MaximumPaymentAmountSettings = {
  __typename?: 'MaximumPaymentAmountSettings';
  /** Maximum allowed payment amount in dollars. */
  Amount__c?: Maybe<Scalars['Float']['output']>;
  /** Description of the maximum payment amount setting. */
  Description__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce record ID. */
  Id: Scalars['ID']['output'];
  /** Display label for the setting. */
  Label?: Maybe<Scalars['String']['output']>;
};

export type MaximumPaymentAmountType = {
  __typename?: 'MaximumPaymentAmountType';
  Amount__c?: Maybe<Scalars['Float']['output']>;
  Description__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
};

export type Member = Contact & {
  __typename?: 'Member';
  Account?: Maybe<Account>;
  /** AccountId from Contact record */
  AccountId: Scalars['String']['output'];
  AmountMSRP__c?: Maybe<Scalars['Int']['output']>;
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  Best_Method_Of_Communication__c?: Maybe<Scalars['String']['output']>;
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  Billing_Days_Past_Due__c?: Maybe<Scalars['Int']['output']>;
  Cancel_Date__c?: Maybe<Scalars['String']['output']>;
  CancellationStatistics__c?: Maybe<Scalars['Boolean']['output']>;
  /** This field will be only available for Physician and Physician Practice Staff */
  Cancellation_Probability__c?: Maybe<Scalars['Float']['output']>;
  Current_Agreement_Effective_Date__c?: Maybe<Scalars['String']['output']>;
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  Current_Balance__c?: Maybe<Scalars['Float']['output']>;
  Current_Membership_Type__c?: Maybe<Scalars['String']['output']>;
  /**
   * Date_Of_Birth__c from Contact record
   * Format: YYYY-MM-DD
   */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  Date_of_Oldest_Unpaid_Invoice__c?: Maybe<Scalars['String']['output']>;
  /** Disposition_Code__c from Contact record */
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  Do_Not_Sync_EHR__c?: Maybe<Scalars['Boolean']['output']>;
  EID__c?: Maybe<Scalars['String']['output']>;
  /** Email from Contact record */
  Email?: Maybe<Scalars['String']['output']>;
  /**
   * Emergency_Phone__c from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  Employer__c?: Maybe<Scalars['String']['output']>;
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Estimated_Paid_Through__c from Contact record */
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  /**
   * Fax from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Fax?: Maybe<Scalars['String']['output']>;
  /** FirstName from Contact record */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Gender__c from Contact record */
  Gender__c?: Maybe<Scalars['String']['output']>;
  /** Id from Contact record */
  Id: Scalars['ID']['output'];
  Insurance__r?: Maybe<Insurance>;
  Junior_Membership__c?: Maybe<Scalars['Boolean']['output']>;
  /** LastName from Contact record */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Last_App_Login__c from Contact record */
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  Last_Payment_Amount_Text__c?: Maybe<Scalars['String']['output']>;
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  LeadSource?: Maybe<Scalars['String']['output']>;
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** MailingCity from Contact record */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** MailingPostalCode from Contact record */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** MailingState from Contact record */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** MailingStreet from Contact record */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /**
   * MobilePhone from Contact record
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  National_Account__r?: Maybe<NationalAccount>;
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  Next_Renewal_Date__c?: Maybe<Scalars['String']['output']>;
  OtherCity?: Maybe<Scalars['String']['output']>;
  OtherPostalCode?: Maybe<Scalars['String']['output']>;
  OtherState?: Maybe<Scalars['String']['output']>;
  OtherStreet?: Maybe<Scalars['String']['output']>;
  /** This field will be only available for Physician and Physician Practice Staff */
  Outreach_Status?: Maybe<Scalars['String']['output']>;
  /**
   * Phone from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Phone?: Maybe<Scalars['String']['output']>;
  /** This field will be only available for Physician and Physician Practice Staff */
  Promoter__c?: Maybe<Scalars['String']['output']>;
  /** User preference to enable push notifications for new secure messages */
  Push_Notifications__c?: Maybe<Scalars['Boolean']['output']>;
  Referral_Name__c?: Maybe<Scalars['String']['output']>;
  /** User preference to enable email notifications for new secure messages */
  SM_Email_Notification__c?: Maybe<Scalars['Boolean']['output']>;
  /** Salutation from Contact record */
  Salutation?: Maybe<Scalars['String']['output']>;
  Secondary_Insurance__c?: Maybe<Scalars['String']['output']>;
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  Title?: Maybe<Scalars['String']['output']>;
  /**
   * Localized string of Date_Of_Birth__c
   * Format: MM/DD/YYYY
   */
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
  Work_Ext__c?: Maybe<Scalars['String']['output']>;
  Work_Phone__c?: Maybe<Scalars['String']['output']>;
  estimatedNextPaymentAmount?: Maybe<Scalars['Float']['output']>;
};

export type MemberAccountType = {
  __typename?: 'MemberAccountType';
  Credentials__c?: Maybe<Scalars['String']['output']>;
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  Portal_Emergency_Contact__c?: Maybe<Scalars['String']['output']>;
  Sync_EHR__c?: Maybe<Scalars['String']['output']>;
};

export type MemberActivityType = {
  __typename?: 'MemberActivityType';
  CreatedByProfile__c?: Maybe<Scalars['String']['output']>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  WhoId?: Maybe<Scalars['String']['output']>;
};

export type MemberByContactIdDomainError = MemberByContactIdNotFoundError;

export type MemberByContactIdFailure = {
  __typename?: 'MemberByContactIdFailure';
  /** All errors associated with required Member By Id. */
  errors: Array<MemberByContactIdDomainError>;
};

export type MemberByContactIdNotFoundError = DomainError & {
  __typename?: 'MemberByContactIdNotFoundError';
  /** ContactId that was included in the query */
  ContactId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type MemberByContactIdResult = Member | MemberByContactIdFailure;

export type MemberInput = {
  AmountMSRP__c?: InputMaybe<Scalars['Int']['input']>;
  AutoPay__c?: InputMaybe<Scalars['Boolean']['input']>;
  Best_Method_Of_Communication__c?: InputMaybe<Scalars['String']['input']>;
  CancellationStatistics__c?: InputMaybe<Scalars['Boolean']['input']>;
  Connect_User_Status__c?: InputMaybe<Scalars['Boolean']['input']>;
  Current_Agreement_Payment_Schedule__c?: InputMaybe<Scalars['String']['input']>;
  Current_Balance_Formula__c?: InputMaybe<Scalars['String']['input']>;
  Current_Balance__c?: InputMaybe<Scalars['Float']['input']>;
  Current_Membership_Type__c?: InputMaybe<Scalars['String']['input']>;
  Date_Of_Birth__c?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  Emergency_Phone__c?: InputMaybe<Scalars['String']['input']>;
  Employer__c?: InputMaybe<Scalars['String']['input']>;
  Established_Date__c?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  Gender__c?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  Last_App_Login__c?: InputMaybe<Scalars['String']['input']>;
  Last_Payment_Date__c?: InputMaybe<Scalars['String']['input']>;
  Last_Wellness_Exam__c?: InputMaybe<Scalars['String']['input']>;
  LeadSource?: InputMaybe<Scalars['String']['input']>;
  MDVIPID__c?: InputMaybe<Scalars['String']['input']>;
  MDVIP_Connect_User__c?: InputMaybe<Scalars['Boolean']['input']>;
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  MailingState?: InputMaybe<Scalars['String']['input']>;
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  Member_Status__c?: InputMaybe<Scalars['String']['input']>;
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  National_Account__r?: InputMaybe<NationalAccountInput>;
  Next_Renewal_Date_Formula__c?: InputMaybe<Scalars['String']['input']>;
  OtherCity?: InputMaybe<Scalars['String']['input']>;
  OtherPostalCode?: InputMaybe<Scalars['String']['input']>;
  OtherState?: InputMaybe<Scalars['String']['input']>;
  OtherStreet?: InputMaybe<Scalars['String']['input']>;
  Phone?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use MailingCity */
  Primary_City__c?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use MailingState */
  Primary_State__c?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use MailingStreet */
  Primary_Street_Address__c?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use MailingPostalCode */
  Primary_Zip_Postal_Code__c?: InputMaybe<Scalars['String']['input']>;
  Referral_Name__c?: InputMaybe<Scalars['String']['input']>;
  Salutation?: InputMaybe<Scalars['String']['input']>;
  Secondary_Insurance__c?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Unknown_Insurance_Company_Name__c?: InputMaybe<Scalars['String']['input']>;
  Work_Ext__c?: InputMaybe<Scalars['String']['input']>;
  Work_Phone__c?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a single member to-do notification with its display metadata. */
export type MemberToDoNotification = {
  __typename?: 'MemberToDoNotification';
  /** Unique key identifying the notification category. */
  key: Scalars['ID']['output'];
  /** Display metadata for the notification. */
  metadata: ToDoNotificationMetadata;
};

/** Input parameters for the memberToDoNotifications query. */
export type MemberToDoNotificationsInput = {
  /** Salesforce Contact ID of the member. */
  ContactId: Scalars['String']['input'];
};

/** Represents the result of the memberToDoNotifications query containing a list of notifications. */
export type MemberToDoNotificationsResult = {
  __typename?: 'MemberToDoNotificationsResult';
  /** List of member to-do notification items. */
  edges: Array<MemberToDoNotification>;
};

export type MemberType = {
  __typename?: 'MemberType';
  Account?: Maybe<MemberAccountType>;
  AccountId?: Maybe<Scalars['String']['output']>;
  AmountMSRP__c?: Maybe<Scalars['Int']['output']>;
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  Best_Method_Of_Communication__c?: Maybe<Scalars['String']['output']>;
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  Billing_Days_Past_Due__c?: Maybe<Scalars['Int']['output']>;
  Cancel_Date__c?: Maybe<Scalars['String']['output']>;
  CancellationStatistics__c?: Maybe<Scalars['Boolean']['output']>;
  Cancellation_Probability__c?: Maybe<Scalars['String']['output']>;
  Current_Agreement_Effective_Date__c?: Maybe<Scalars['String']['output']>;
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  Current_Balance__c?: Maybe<Scalars['Float']['output']>;
  Current_Membership_Type__c?: Maybe<Scalars['String']['output']>;
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  Date_of_Oldest_Unpaid_Invoice__c?: Maybe<Scalars['String']['output']>;
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  Do_Not_Sync_EHR__c?: Maybe<Scalars['Boolean']['output']>;
  EID__c?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  Employer__c?: Maybe<Scalars['String']['output']>;
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  Fax?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gender__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Insurance__r?: Maybe<InsuranceType>;
  Junior_Membership__c?: Maybe<Scalars['Boolean']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  Last_Payment_Amount_Text__c?: Maybe<Scalars['String']['output']>;
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  LeadSource?: Maybe<Scalars['String']['output']>;
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  MailingCity?: Maybe<Scalars['String']['output']>;
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  MailingState?: Maybe<Scalars['String']['output']>;
  MailingStreet?: Maybe<Scalars['String']['output']>;
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
  National_Account__r?: Maybe<NationalAccountType>;
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  Next_Renewal_Date__c?: Maybe<Scalars['String']['output']>;
  OtherCity?: Maybe<Scalars['String']['output']>;
  OtherPostalCode?: Maybe<Scalars['String']['output']>;
  OtherState?: Maybe<Scalars['String']['output']>;
  OtherStreet?: Maybe<Scalars['String']['output']>;
  Outreach_Status?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingCity */
  Primary_City__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingState */
  Primary_State__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingStreet */
  Primary_Street_Address__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingPostalCode */
  Primary_Zip_Postal_Code__c?: Maybe<Scalars['String']['output']>;
  Promoter__c?: Maybe<Scalars['String']['output']>;
  Referral_Name__c?: Maybe<Scalars['String']['output']>;
  Salutation?: Maybe<Scalars['String']['output']>;
  Secondary_Insurance__c?: Maybe<Scalars['String']['output']>;
  Tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Title?: Maybe<Scalars['String']['output']>;
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
  Work_Ext__c?: Maybe<Scalars['String']['output']>;
  Work_Phone__c?: Maybe<Scalars['String']['output']>;
  campaignIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  campaigns?: Maybe<Array<Maybe<CampaignType>>>;
  physicianIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  physicians?: Maybe<Array<Maybe<PhysicianType>>>;
};

export type MembersByAccountIdInput = {
  Statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  filterStr?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MembersByAccountIdResult = {
  __typename?: 'MembersByAccountIdResult';
  edges: Array<Member>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type MembersByPhysicianIdResult = {
  __typename?: 'MembersByPhysicianIdResult';
  edges: Array<Member>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

/** Represents a single message within a secure messaging thread. */
export type Message = {
  __typename?: 'Message';
  /** File attachments included with the message. */
  attachments?: Maybe<Array<Attachment>>;
  /** Blind carbon copy recipients of the message. */
  bcc?: Maybe<Array<MessageUser>>;
  /** Body content of the message. */
  body?: Maybe<Scalars['String']['output']>;
  /** Carbon copy recipients of the message. */
  cc?: Maybe<Array<MessageUser>>;
  /** Timestamp when the message was created. */
  createdTimestamp: Scalars['String']['output'];
  /** Whether the message is a draft. */
  draft?: Maybe<Scalars['Boolean']['output']>;
  /** User who sent the message. */
  from: MessageUser;
  /** Unique identifier for the message. */
  id: Scalars['ID']['output'];
  /** Whether the message has been read. */
  read?: Maybe<Scalars['Boolean']['output']>;
  /** Subject line of the message. */
  subject?: Maybe<Scalars['String']['output']>;
  /** Identifier of the thread this message belongs to. */
  threadId?: Maybe<Scalars['String']['output']>;
  /** Primary recipients of the message. */
  to: Array<MessageUser>;
};

/** Represents a message thread containing one or more messages. */
export type MessageThread = {
  __typename?: 'MessageThread';
  /** Whether replies are allowed in the thread. */
  allowReply?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the thread has been archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the thread is a broadcast message. */
  broadcast?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the thread contains messages with attachments. */
  hasAttachment?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the thread contains draft messages. */
  hasDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the thread contains unread messages. */
  hasUnread?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the message thread. */
  id: Scalars['ID']['output'];
  /** Total number of messages in the thread. */
  messageCount: Scalars['Int']['output'];
  /** List of messages within the thread. */
  messages: Array<Message>;
  /** Display name of the message thread. */
  name: Scalars['String']['output'];
  /** List of participant identifiers in the thread. */
  participants?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the thread has been starred. */
  starred?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the thread was last updated. */
  updatedTimestamp?: Maybe<Scalars['String']['output']>;
};

/** Union of all domain errors that can occur when retrieving a message thread by ID. */
export type MessageThreadByIdDomainError = MessageThreadByIdInvalidMailboxIdError | MessageThreadByIdInvalidThreadIdError | MessageThreadByIdNotFoundError;

/** Encapsulates all domain errors for the messageThreadById operation. */
export type MessageThreadByIdFailure = {
  __typename?: 'MessageThreadByIdFailure';
  /** List of domain errors that occurred while retrieving the message thread. */
  errors: Array<MessageThreadByIdDomainError>;
};

/** Input parameters for the messageThreadById query. */
export type MessageThreadByIdInput = {
  /** Unique identifier of the mailbox containing the thread. */
  mailboxId: Scalars['ID']['input'];
  /** Unique identifier of the thread to retrieve. */
  threadId: Scalars['ID']['input'];
};

/** Domain error returned when the mailbox ID is invalid for the thread-by-ID request. */
export type MessageThreadByIdInvalidMailboxIdError = DomainError & {
  __typename?: 'MessageThreadByIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the thread ID is invalid for the thread-by-ID request. */
export type MessageThreadByIdInvalidThreadIdError = DomainError & {
  __typename?: 'MessageThreadByIdInvalidThreadIdError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The invalid thread ID that was provided. */
  threadId: Scalars['ID']['output'];
};

/** Domain error returned when the requested message thread is not found. */
export type MessageThreadByIdNotFoundError = DomainError & {
  __typename?: 'MessageThreadByIdNotFoundError';
  /** The mailbox ID that was searched. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The thread ID that was not found. */
  threadId: Scalars['ID']['output'];
};

/** Result type for messageThreadById. Returns MessageThread on success or MessageThreadByIdFailure on failure. */
export type MessageThreadByIdResult = MailboxByIdFailure | MessageThread | MessageThreadByIdFailure;

export type MessageThreadInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentTypeInput>>>;
  bcc?: InputMaybe<Array<InputMaybe<MessageThreadInputFromAndTo>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<InputMaybe<MessageThreadInputFromAndTo>>>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<MessageThreadInputFromAndTo>;
  id?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<InputMaybe<MessageThreadInputFromAndTo>>>;
};

export type MessageThreadInputFromAndTo = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Defines the possible states of a message thread for filtering purposes. */
export enum MessageThreadState {
  /** Thread is currently active and visible in the inbox. */
  Active = 'ACTIVE',
  /** Thread has been archived by the user. */
  Archived = 'ARCHIVED',
  /** Thread contains unsent draft messages. */
  Draft = 'DRAFT',
  /** Thread has been starred by the user. */
  Starred = 'STARRED'
}

/** Union of all domain errors that can occur when retrieving message threads by mailbox ID. */
export type MessageThreadsByMailboxIdDomainError = MessageThreadsByMailboxIdForbiddenError | MessageThreadsByMailboxIdInternalError | MessageThreadsByMailboxIdInvalidMailboxIdError | MessageThreadsByMailboxIdNotFoundError | MessageThreadsByMailboxIdUnauthorizedError;

/** Encapsulates all domain errors for the messageThreadsByMailboxId operation. */
export type MessageThreadsByMailboxIdFailure = {
  __typename?: 'MessageThreadsByMailboxIdFailure';
  /** List of domain errors that occurred while retrieving message threads. */
  errors: Array<MessageThreadsByMailboxIdDomainError>;
};

/** Input parameters for filtering message threads by mailbox ID. */
export type MessageThreadsByMailboxIdFilters = {
  /** Filter threads by their current state. */
  state?: InputMaybe<MessageThreadState>;
  /** Filter threads by recipient mailbox ID. */
  toMailboxId?: InputMaybe<Scalars['String']['input']>;
};

/** Domain error returned when the user is forbidden from accessing threads in the mailbox. */
export type MessageThreadsByMailboxIdForbiddenError = DomainError & {
  __typename?: 'MessageThreadsByMailboxIdForbiddenError';
  /** The mailbox ID the user is forbidden from accessing. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Input parameters for the messageThreadsByMailboxId query. */
export type MessageThreadsByMailboxIdInput = {
  /** Optional filters to apply to the thread results. */
  filters?: InputMaybe<MessageThreadsByMailboxIdFilters>;
  /** Maximum number of threads to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier of the mailbox to retrieve threads from. */
  mailboxId: Scalars['ID']['input'];
  /** Number of threads to skip for pagination. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Domain error returned when an internal error occurs while retrieving threads for the mailbox. */
export type MessageThreadsByMailboxIdInternalError = DomainError & {
  __typename?: 'MessageThreadsByMailboxIdInternalError';
  /** The mailbox ID that caused the internal error. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the mailbox ID is invalid for the threads-by-mailbox request. */
export type MessageThreadsByMailboxIdInvalidMailboxIdError = DomainError & {
  __typename?: 'MessageThreadsByMailboxIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when no message threads are found for the mailbox. */
export type MessageThreadsByMailboxIdNotFoundError = DomainError & {
  __typename?: 'MessageThreadsByMailboxIdNotFoundError';
  /** The mailbox ID for which threads were not found. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for messageThreadsByMailboxId. Returns MessageThreadsByMailboxIdSuccess on success or MessageThreadsByMailboxIdFailure on failure. */
export type MessageThreadsByMailboxIdResult = MailboxByIdFailure | MessageThreadsByMailboxIdFailure | MessageThreadsByMailboxIdSuccess;

/** Represents a successful retrieval of message threads for a mailbox. */
export type MessageThreadsByMailboxIdSuccess = {
  __typename?: 'MessageThreadsByMailboxIdSuccess';
  /** List of message threads matching the query. */
  edges: Array<MessageThread>;
  /** Maximum number of threads returned. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Number of threads skipped for pagination. */
  offset?: Maybe<Scalars['Int']['output']>;
  /** Total number of threads matching the query. */
  total: Scalars['Int']['output'];
};

/** Domain error returned when the user is unauthorized to access threads in the mailbox. */
export type MessageThreadsByMailboxIdUnauthorizedError = DomainError & {
  __typename?: 'MessageThreadsByMailboxIdUnauthorizedError';
  /** The mailbox ID the user is unauthorized to access. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type MessageType = {
  __typename?: 'MessageType';
  attachments?: Maybe<Array<Maybe<AttachmentType>>>;
  bcc?: Maybe<Array<Maybe<MessageUserType>>>;
  body?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Array<Maybe<MessageUserType>>>;
  createdTimestamp?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  from?: Maybe<MessageUserType>;
  id: Scalars['String']['output'];
  read?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Array<Maybe<MessageUserType>>>;
};

/** Represents a user participating in secure messaging. */
export type MessageUser = {
  __typename?: 'MessageUser';
  /** Authentication identifier of the user. */
  authId?: Maybe<Scalars['String']['output']>;
  /** Email address of the user. */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the message user. */
  id: Scalars['ID']['output'];
  /** List of mailbox IDs associated with the user. */
  mailboxIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Mailboxes associated with the user. */
  mailboxes?: Maybe<Array<Mailbox>>;
  /** Display name of the user. */
  name: Scalars['String']['output'];
  /** Number of unread messages for the user. */
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type MessageUserType = {
  __typename?: 'MessageUserType';
  authId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mailboxIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mailboxes?: Maybe<Array<Maybe<MailboxType>>>;
  name?: Maybe<Scalars['String']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

/** Union of all domain errors that can occur when retrieving messages by mailbox thread. */
export type MessagesByMailboxThreadDomainError = MessagesByMailboxThreadInvalidMailboxIdError | MessagesByMailboxThreadInvalidThreadIdError | MessagesByMailboxThreadNotFoundError;

/** Encapsulates all domain errors for the messagesByMailboxThread operation. */
export type MessagesByMailboxThreadFailure = {
  __typename?: 'MessagesByMailboxThreadFailure';
  /** List of domain errors that occurred while retrieving messages by thread. */
  errors: Array<MessagesByMailboxThreadDomainError>;
};

/** Input parameters for the messagesByMailboxThread query. */
export type MessagesByMailboxThreadInput = {
  /** Unique identifier of the mailbox containing the thread. */
  mailboxId: Scalars['ID']['input'];
  /** Unique identifier of the thread to retrieve messages from. */
  threadId: Scalars['ID']['input'];
};

/** Domain error returned when the mailbox ID is invalid for the messages-by-thread request. */
export type MessagesByMailboxThreadInvalidMailboxIdError = DomainError & {
  __typename?: 'MessagesByMailboxThreadInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the thread ID is invalid for the messages-by-thread request. */
export type MessagesByMailboxThreadInvalidThreadIdError = DomainError & {
  __typename?: 'MessagesByMailboxThreadInvalidThreadIdError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The invalid thread ID that was provided. */
  threadId: Scalars['ID']['output'];
};

/** Domain error returned when the requested mailbox thread is not found. */
export type MessagesByMailboxThreadNotFoundError = DomainError & {
  __typename?: 'MessagesByMailboxThreadNotFoundError';
  /** The mailbox ID that was searched. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The thread ID that was not found. */
  threadId: Scalars['ID']['output'];
};

/** Result type for messagesByMailboxThread. Returns MessagesByMailboxThreadSuccess on success or MessagesByMailboxThreadFailure on failure. */
export type MessagesByMailboxThreadResult = MailboxByIdFailure | MessagesByMailboxThreadFailure | MessagesByMailboxThreadSuccess;

/** Represents a successful retrieval of messages within a mailbox thread. */
export type MessagesByMailboxThreadSuccess = {
  __typename?: 'MessagesByMailboxThreadSuccess';
  /** List of messages in the thread. */
  edges: Array<Message>;
};

export type MessagesInput = {
  mailboxId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};

export type MessagingContact = {
  __typename?: 'MessagingContact';
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Id: Scalars['String']['output'];
  LastName?: Maybe<Scalars['String']['output']>;
  MDVIPID?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MDVIPID */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MailboxID */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  MailboxID?: Maybe<Scalars['String']['output']>;
  RecordType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use RecordType */
  RecordTypeId?: Maybe<Scalars['String']['output']>;
};

/** TODO: Deprecating soon */
export enum MessagingContactForType {
  Affiliate = 'AFFILIATE',
  Member = 'MEMBER',
  OfficeStaff = 'OFFICE_STAFF'
}

/** TODO: Deprecating soon */
export type MessagingContactsByContactIdResult = {
  __typename?: 'MessagingContactsByContactIdResult';
  edges: Array<MessagingContact>;
};

export type MessagingContactsForAffiliateInput = {
  AccountId: Scalars['String']['input'];
};

export type MessagingContactsForEmployeeInput = {
  AccountId: Scalars['String']['input'];
  ContactId: Scalars['String']['input'];
};

export type MessagingContactsForMemberInput = {
  ContactId: Scalars['String']['input'];
};

export type MessagingContactsForStaffInput = {
  AccountId: Scalars['String']['input'];
  ContactId: Scalars['String']['input'];
};

export type MessagingContactsListResult = {
  __typename?: 'MessagingContactsListResult';
  edges: Array<MessagingContact>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addNewGuest?: Maybe<CampaignMemberType>;
  case?: Maybe<CaseType>;
  /**
   * Creates a new AWP record.
   * @deprecated use createNewAwp
   */
  createAWP?: Maybe<CreateAwpResponse>;
  /** Creates a new broadcast message thread in the specified mailbox. */
  createBroadcastMessageThread: CreateBroadcastMessageThreadResult;
  /** @deprecated use createProspectF2FCase */
  createF2FCase?: Maybe<StateResponse>;
  /** @deprecated use createNewMessage */
  createMessage?: Maybe<MessageType>;
  /**
   * Feature flags needed:
   * - AWP Create (Upload AWP readonly)
   * - AWP Audit (Approve AWP)
   * - AWP Manage (Edit AWP)
   * - AWP Read (Read AWP)
   * Creates a new Annual Wellness Plan record and returns an upload URL for the document.
   */
  createNewAwp: CreateNewAwpResponse;
  /** Creates a new message in the mailbox thread. */
  createNewMessage: CreateNewMessageResult;
  /** Creates a new payment profile for the authenticated member or guest. */
  createNewPaymentProfile: CreateNewPaymentProfileResult;
  /**
   * Create a new prospect
   * TODO: Rename this to "createProspect" after legacy "createProspect" is removed.
   * TODO: Verify @authorization directive with consumers
   */
  createNewProspect: CreateProspectResult;
  /** Creates a new non-broadcast message thread in the specified mailbox. */
  createNonBroadcastMessageThread: CreateNonBroadcastMessageThreadResult;
  /** Creates a new one-time payment for the authenticated member. */
  createOneTimePayment: CreateOneTimePaymentResult;
  /** @deprecated use createOneTimePayment */
  createPayment?: Maybe<Payment_Old>;
  /** @deprecated use createNewPaymentProfile */
  createPaymentProfile?: Maybe<PaymentProfile_Old>;
  /** Create a new PhysicianPracticestaff */
  createPhysicianPracticeStaff: CreatePhysicianPracticeStaffResult;
  /** @deprecated use createNewProspect */
  createProspect?: Maybe<ProspectType>;
  /** Create a new prospect face-to-face case */
  createProspectF2FCase: CreateProspectF2FCaseResult;
  createReciprocityVisit?: Maybe<ReciprocityVisitType>;
  createReferral?: Maybe<CreateReferralType>;
  /**
   * Id for createStaff and updateConnectStatus can be AccountId or ContactId
   * @deprecated use createPhysicianPracticeStaff
   */
  createStaff?: Maybe<Scalars['String']['output']>;
  /** @deprecated use createMessageThread */
  createThread?: Maybe<ThreadType>;
  createWaitlistEntry: WaitlistResult;
  /** @deprecated use deactivatePaymentProfileById */
  deactivatePaymentProfile?: Maybe<PaymentProfile_Old>;
  /** Deactivates a payment profile by its Salesforce ID. */
  deactivatePaymentProfileById: DeactivatePaymentProfileByIdResult;
  /** @deprecated use deleteMessageById */
  deleteMessage?: Maybe<StateResponse>;
  /** Deletes a message by its unique identifier. */
  deleteMessageById: DeleteMessageByIdResult;
  /** Deletes a message thread by its unique identifier. */
  deleteMessageThreadById: DeleteMessageThreadByIdResult;
  /** @deprecated use deleteMessageThreadById */
  deleteThread?: Maybe<StateResponse>;
  /** @deprecated use enableMemberAutopayByContactId */
  enableAutopay?: Maybe<MemberType>;
  /** Enable members autopay */
  enableMemberAutopayByContactId: EnableMemberAutopayByContactIdResult;
  enroll?: Maybe<InitiativesType>;
  insertDonation?: Maybe<Scalars['String']['output']>;
  /** @deprecated use updateProspectF2FCaseByCaseId */
  manageF2FCase?: Maybe<StateResponse>;
  /** @deprecated use updateMemberByContactId */
  member?: Maybe<MemberType>;
  /**
   * Reinstate a member's MDVIP membership.
   * Use the returned workflowId to poll reinstatementStatus until COMPLETED or FAILED.
   */
  reinstateMember: ReinstateMemberResult;
  root?: Maybe<Scalars['String']['output']>;
  sendDynamicEmail?: Maybe<DynamicEmailType>;
  sendEmail?: Maybe<EmailResponseType>;
  /** Sends a payment receipt email for the given payment ID. */
  sendPaymentReceiptEmailById: SendPaymentReceiptEmailByIdResult;
  /** Sets the specified payment profile as the default for the member. */
  setDefaultPaymentProfile: SetDefaultPaymentProfileResult;
  /** @deprecated use setupMyMailbox */
  setMailboxId?: Maybe<MemberType>;
  /** Creates and initializes a mailbox for the authenticated user. */
  setupMyMailbox: SetupMyMailboxResult;
  /** Transfer Prospect to MDVIP */
  transferProspectToMDVIP: TransferProspectToMdvipResult;
  /** @deprecated use transferProspectToMDVIP */
  transferToMDVIP?: Maybe<StateResponse>;
  /**
   * Updates an existing AWP record.
   * @deprecated use updateAwpByPhrId
   */
  updateAWP?: Maybe<UpdateAwpResponse>;
  updateAccount?: Maybe<StateResponse>;
  /** Updates an existing Annual Wellness Plan record identified by its PHR ID. */
  updateAwpByPhrId: UpdateAwpByPhrIdResponse;
  updateCampaignMember?: Maybe<CampaignMemberType>;
  /** @deprecated use updatePhysicianPracticeStaffAccessByContactId */
  updateConnectUser?: Maybe<Scalars['String']['output']>;
  /**
   * Update contact and account info (email, phone, automated communication, autopay) for reinstatement.
   * Email and MobilePhone update both the Salesforce Contact and Account objects.
   * The ContactId is derived from the auth token.
   */
  updateContactInfoForReinstatement: UpdateContactInfoForReinstatementResult;
  /**
   * Update contact opt-in preferences by ContactId
   * The ContactId is derived from the auth token.
   */
  updateContactOptInPreferences: UpdateContactOptInPreferencesResult;
  /** @deprecated use setDefaultPaymentProfile */
  updateDefaultPaymentProfile?: Maybe<Array<Maybe<PaymentProfile_Old>>>;
  updateDonation?: Maybe<Scalars['String']['output']>;
  /** Updates a feature flag record by its Salesforce ID. */
  updateFeatureFlagById: UpdateFeatureFlagByIdResult;
  /** @deprecated use updateFeatureFlagById */
  updateFlags?: Maybe<Scalars['String']['output']>;
  /** @deprecated use updateMailboxById */
  updateMailbox: MailboxType;
  /** Updates a mailbox's away status and message by its unique identifier. */
  updateMailboxById: UpdateMailboxByIdResult;
  /** Update existing member details by ContactId */
  updateMemberByContactId: UpdateMemberByContactIdResult;
  /** @deprecated use updateMessageById */
  updateMessage?: Maybe<StateResponse>;
  /** Updates a message by its unique identifier. */
  updateMessageById: UpdateMessageByIdResult;
  /** Updates a message thread by its unique identifier. */
  updateMessageThreadById: UpdateMessageThreadByIdResult;
  /** @deprecated use updateUpcomingPaymentById */
  updatePayment?: Maybe<Payment_Old>;
  /** @deprecated use updatePaymentProfileById */
  updatePaymentProfile?: Maybe<PaymentProfile_Old>;
  /** Updates an existing payment profile by its Salesforce ID. */
  updatePaymentProfileById: UpdatePaymentProfileByIdResult;
  /** @deprecated Use 'updatePhysicianByContactId' */
  updatePhysician?: Maybe<PhysicianType>;
  /** Updates physician's demographic information */
  updatePhysicianByContactId: UpdatePhysicianByContactIdResult;
  /** Updates PhysicianPracticestaff's access to portal */
  updatePhysicianPracticeStaffAccessByContactId: UpdatePhysicianPracticeStaffAccessByContactIdResult;
  /** Updates PhysicianPracticestaff contact details */
  updatePhysicianPracticeStaffByContactId: UpdatePhysicianPracticeStaffByContactIdResult;
  /** @deprecated use updateProspectByContactId */
  updateProspect?: Maybe<ProspectType>;
  /** Update existing prospect by ContactId */
  updateProspectByContactId: UpdateProspectByContactIdResult;
  /** Update existing prospect face-to-face case by CaseId */
  updateProspectF2FCaseByCaseId: UpdateProspectF2FCaseByCaseIdResult;
  /** @deprecated use updatePhysicianPracticeStaffByContactId */
  updateStaff?: Maybe<StaffType>;
  /** @deprecated use updateMessageThreadById */
  updateThread?: Maybe<StateResponse>;
  /** Updates an upcoming payment record by its Salesforce ID. */
  updateUpcomingPaymentById: UpdateUpcomingPaymentByIdResult;
  updateWaitlistEntry: WaitlistResult;
  /** Verifies ACH bank account information with the payment gateway. */
  verifyACHInformation: VerifyAchInformationResult;
  /** Verifies credit card information with the payment gateway. */
  verifyCreditCardInformation: VerifyCreditCardInformationResult;
};


export type MutationAddNewGuestArgs = {
  input?: InputMaybe<CreateCampaignMemberInput>;
};


export type MutationCaseArgs = {
  input?: InputMaybe<CaseInput>;
};


export type MutationCreateAwpArgs = {
  input: CreateAwpInput;
};


export type MutationCreateBroadcastMessageThreadArgs = {
  input: CreateBroadcastMessageThreadInput;
};


export type MutationCreateF2FCaseArgs = {
  input?: InputMaybe<CreateF2FCase>;
};


export type MutationCreateMessageArgs = {
  input?: InputMaybe<CreateMessageInput>;
};


export type MutationCreateNewAwpArgs = {
  input: CreateNewAwpInput;
};


export type MutationCreateNewMessageArgs = {
  input: CreateNewMessageInput;
};


export type MutationCreateNewPaymentProfileArgs = {
  input: CreateNewPaymentProfileInput;
};


export type MutationCreateNewProspectArgs = {
  input: CreateProspectInput;
};


export type MutationCreateNonBroadcastMessageThreadArgs = {
  input: CreateNonBroadcastMessageThreadInput;
};


export type MutationCreateOneTimePaymentArgs = {
  input: CreateOneTimePaymentInput;
};


export type MutationCreatePaymentArgs = {
  input?: InputMaybe<CreatePaymentInput>;
};


export type MutationCreatePaymentProfileArgs = {
  input?: InputMaybe<CreatePaymentProfileInput>;
};


export type MutationCreatePhysicianPracticeStaffArgs = {
  input: CreatePhysicianPracticeStaffInput;
};


export type MutationCreateProspectArgs = {
  input?: InputMaybe<ProspectInput>;
};


export type MutationCreateProspectF2FCaseArgs = {
  input: CreateProspectF2FCaseInput;
};


export type MutationCreateReciprocityVisitArgs = {
  data?: InputMaybe<CreateReciprocityVisitInput>;
};


export type MutationCreateReferralArgs = {
  input?: InputMaybe<SubmitReferralInput>;
};


export type MutationCreateStaffArgs = {
  Id: Scalars['ID']['input'];
  data: StaffDataTypeInput;
};


export type MutationCreateThreadArgs = {
  input?: InputMaybe<CreateThreadInput>;
};


export type MutationCreateWaitlistEntryArgs = {
  input: CreateWaitlistEntryInput;
};


export type MutationDeactivatePaymentProfileArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivatePaymentProfileByIdArgs = {
  Id: Scalars['ID']['input'];
};


export type MutationDeleteMessageArgs = {
  input?: InputMaybe<DeleteMessageInput>;
};


export type MutationDeleteMessageByIdArgs = {
  input: DeleteMessageByIdInput;
};


export type MutationDeleteMessageThreadByIdArgs = {
  input: DeleteMessageThreadByIdInput;
};


export type MutationDeleteThreadArgs = {
  mailboxId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};


export type MutationEnableAutopayArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEnableMemberAutopayByContactIdArgs = {
  ContactId: Scalars['String']['input'];
  updateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEnrollArgs = {
  input?: InputMaybe<InitiativesInput>;
};


export type MutationInsertDonationArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<FoundationInput>;
};


export type MutationManageF2FCaseArgs = {
  input?: InputMaybe<ManageF2FCaseInput>;
};


export type MutationMemberArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<MemberInput>;
};


export type MutationReinstateMemberArgs = {
  input: ReinstateMemberInput;
};


export type MutationSendDynamicEmailArgs = {
  input?: InputMaybe<SendDynamicEmailInput>;
};


export type MutationSendEmailArgs = {
  input?: InputMaybe<EmailInput>;
};


export type MutationSendPaymentReceiptEmailByIdArgs = {
  Id: Scalars['ID']['input'];
};


export type MutationSetDefaultPaymentProfileArgs = {
  Id: Scalars['ID']['input'];
};


export type MutationSetMailboxIdArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
  mailboxId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTransferProspectToMdvipArgs = {
  input: TransferProspectToMdvipInput;
};


export type MutationTransferToMdvipArgs = {
  input?: InputMaybe<TransferToMdvipInput>;
};


export type MutationUpdateAwpArgs = {
  input: UpdateAwpInput;
};


export type MutationUpdateAccountArgs = {
  input?: InputMaybe<UpdateAccountInput>;
};


export type MutationUpdateAwpByPhrIdArgs = {
  input: UpdateAwpByPhrIdInput;
  phrId: Scalars['ID']['input'];
};


export type MutationUpdateCampaignMemberArgs = {
  input?: InputMaybe<UpdateCampaignMemberInput>;
};


export type MutationUpdateConnectUserArgs = {
  Id: Scalars['ID']['input'];
  staffId: Scalars['ID']['input'];
  type: ConnectUserEnum;
};


export type MutationUpdateContactInfoForReinstatementArgs = {
  input: UpdateContactInfoForReinstatementInput;
};


export type MutationUpdateContactOptInPreferencesArgs = {
  input: UpdateContactOptInPreferencesInput;
};


export type MutationUpdateDefaultPaymentProfileArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDonationArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<FoundationInput>;
  rollOutId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFeatureFlagByIdArgs = {
  Id: Scalars['ID']['input'];
  input: UpdateFeatureFlagByIdInput;
};


export type MutationUpdateFlagsArgs = {
  input?: InputMaybe<UpdateFeatureFlagsInput>;
};


export type MutationUpdateMailboxArgs = {
  mailboxData: UpdateMailboxInput;
};


export type MutationUpdateMailboxByIdArgs = {
  input: UpdateMailboxByIdInput;
};


export type MutationUpdateMemberByContactIdArgs = {
  ContactId: Scalars['String']['input'];
  input: UpdateMemberByContactIdInput;
};


export type MutationUpdateMessageArgs = {
  input?: InputMaybe<UpdateMessageInput>;
};


export type MutationUpdateMessageByIdArgs = {
  input: UpdateMessageByIdInput;
};


export type MutationUpdateMessageThreadByIdArgs = {
  input: UpdateMessageThreadByIdInput;
};


export type MutationUpdatePaymentArgs = {
  input?: InputMaybe<UpdatePaymentInput>;
};


export type MutationUpdatePaymentProfileArgs = {
  input?: InputMaybe<UpdatePaymentProfileInput>;
};


export type MutationUpdatePaymentProfileByIdArgs = {
  Id: Scalars['ID']['input'];
  input: UpdatePaymentProfileByIdInput;
};


export type MutationUpdatePhysicianArgs = {
  Id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePhysicianByContactIdArgs = {
  ContactId: Scalars['ID']['input'];
  input: UpdatePhysicianByContactIdInput;
};


export type MutationUpdatePhysicianPracticeStaffAccessByContactIdArgs = {
  ContactId: Scalars['ID']['input'];
  input: UpdatePhysicianPracticeStaffAccessByContactIdInput;
};


export type MutationUpdatePhysicianPracticeStaffByContactIdArgs = {
  ContactId: Scalars['ID']['input'];
  input: UpdatePhysicianPracticeStaffByContactIdInput;
};


export type MutationUpdateProspectArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<ProspectInput>;
};


export type MutationUpdateProspectByContactIdArgs = {
  ContactId: Scalars['ID']['input'];
  input: UpdateProspectByContactIdInput;
};


export type MutationUpdateProspectF2FCaseByCaseIdArgs = {
  CaseId: Scalars['ID']['input'];
  input: UpdateProspectF2FCaseByCaseIdInput;
};


export type MutationUpdateStaffArgs = {
  Id: Scalars['ID']['input'];
  data: StaffDataTypeInput;
};


export type MutationUpdateThreadArgs = {
  input?: InputMaybe<UpdateThreadInput>;
};


export type MutationUpdateUpcomingPaymentByIdArgs = {
  Id: Scalars['ID']['input'];
  input: UpdateUpcomingPaymentByIdInput;
};


export type MutationUpdateWaitlistEntryArgs = {
  input: UpdateWaitlistEntryInput;
};


export type MutationVerifyAchInformationArgs = {
  input: VerifyAchInformationInput;
};


export type MutationVerifyCreditCardInformationArgs = {
  input: VerifyCreditCardInformationInput;
};

/** Union of all domain errors that can occur when retrieving the user's mailbox ID. */
export type MyMailboxIdDomainError = MyMailboxIdNotFoundError;

/** Encapsulates all domain errors for the myMailboxId operation. */
export type MyMailboxIdFailure = {
  __typename?: 'MyMailboxIdFailure';
  /** List of domain errors that occurred while retrieving the user's mailbox ID. */
  errors: Array<MyMailboxIdDomainError>;
};

/** Input parameters for the myMailboxId query. */
export type MyMailboxIdInput = {
  /** Email address of the mailbox owner. */
  email: Scalars['String']['input'];
  /** First name of the mailbox owner. */
  firstName: Scalars['String']['input'];
  /** Last name of the mailbox owner. */
  lastName: Scalars['String']['input'];
};

/** Domain error returned when the authenticated user's mailbox is not found. */
export type MyMailboxIdNotFoundError = DomainError & {
  __typename?: 'MyMailboxIdNotFoundError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for myMailboxId. Returns MyMailboxIdSuccess on success or MyMailboxIdFailure on failure. */
export type MyMailboxIdResult = MyMailboxIdFailure | MyMailboxIdSuccess;

/** Represents a successful retrieval of the authenticated user's mailbox ID. */
export type MyMailboxIdSuccess = {
  __typename?: 'MyMailboxIdSuccess';
  /** Unique identifier of the authenticated user's mailbox. */
  id: Scalars['ID']['output'];
};

/** Represents the national account associated with a member. */
export type NationalAccount = {
  __typename?: 'NationalAccount';
  /** National account name. */
  Name?: Maybe<Scalars['String']['output']>;
};

export type NationalAccountInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
};

export type NationalAccountType = {
  __typename?: 'NationalAccountType';
  Name?: Maybe<Scalars['String']['output']>;
};

/** Response for the NextPaymentDue Jitterbit endpoint. */
export type NextPaymentDueResponse = {
  __typename?: 'NextPaymentDueResponse';
  /** Amount due for the next payment. */
  Amount?: Maybe<Scalars['Float']['output']>;
  /** Current outstanding balance on the account. */
  CurrentBalance?: Maybe<Scalars['Float']['output']>;
  /** Due date of the next payment. */
  DueDate?: Maybe<Scalars['String']['output']>;
  /** MDVIP member ID. */
  MemberId: Scalars['String']['output'];
};

export enum NonAcceptedPaymentPlan {
  Complimentary = 'COMPLIMENTARY',
  Employee = 'EMPLOYEE',
  EmploySpouse = 'EMPLOY_SPOUSE',
  FullPay = 'FULL_PAY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Scholarship = 'SCHOLARSHIP',
  SemiAnnual = 'SEMI_ANNUAL'
}

export type PartialFeatureFlagsInput = {
  AWPCreate__c?: InputMaybe<Scalars['Boolean']['input']>;
  AWPManage__c?: InputMaybe<Scalars['Boolean']['input']>;
  AWPRead__c?: InputMaybe<Scalars['Boolean']['input']>;
  FinancialReports__c?: InputMaybe<Scalars['Boolean']['input']>;
  MCEReferrals__c?: InputMaybe<Scalars['Boolean']['input']>;
  ManageCHL__c?: InputMaybe<Scalars['Boolean']['input']>;
  ManagePortalUser__c?: InputMaybe<Scalars['Boolean']['input']>;
  SecureMessaging__c?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the patient activity report containing a list of activity edges. */
export type PatientActivityReport = {
  __typename?: 'PatientActivityReport';
  /** List of patient activity report records. */
  edges: Array<PatientActivityReportEdge>;
};

/** Represents a single patient edge in the activity report containing member details and activities. */
export type PatientActivityReportEdge = {
  __typename?: 'PatientActivityReportEdge';
  /** Patient date of birth. */
  DOB?: Maybe<Scalars['String']['output']>;
  /** Patient email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Patient first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Patient last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** List of activity records for the member. */
  MemberActivity: Array<PatientMemberActivity>;
  /** Patient mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Patient primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Record type name of the contact. */
  RecordTypeName?: Maybe<Scalars['String']['output']>;
};

/** Input parameters for the patientActivityReport query. */
export type PatientActivityReportInput = {
  /** Salesforce Account identifier for the physician practice. */
  AccountId: Scalars['String']['input'];
  /** Number of days to look back for activity records. */
  Range: Scalars['Int']['input'];
};

/** Domain error returned when the AccountId provided to the patient activity report query is invalid. */
export type PatientActivityReportInvalidAccountIdError = DomainError & {
  __typename?: 'PatientActivityReportInvalidAccountIdError';
  /** AccountId that was included in the query */
  AccountId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for patientActivityReport. Returns PatientActivityReport on success or PatientActivityReportInvalidAccountIdError on failure. */
export type PatientActivityReportResult = PatientActivityReport | PatientActivityReportInvalidAccountIdError;

/** Represents the patient case report containing a list of case edges. */
export type PatientCaseReport = {
  __typename?: 'PatientCaseReport';
  /** List of patient case report records. */
  edges: Array<PatientCaseReportEdge>;
};

/** Represents a single case record in the patient case report. */
export type PatientCaseReportEdge = {
  __typename?: 'PatientCaseReportEdge';
  /** Date the case was closed. */
  ClosedDate?: Maybe<Scalars['String']['output']>;
  /** Date the case was created. */
  CreatedDate?: Maybe<Scalars['String']['output']>;
  /** Patient date of birth. */
  DOB?: Maybe<Scalars['String']['output']>;
  /** Date of the face-to-face encounter. */
  DateOfFacetoFace?: Maybe<Scalars['String']['output']>;
  /** Patient email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Patient first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Patient last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Patient mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Patient primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Record type name of the case. */
  RecordTypeName?: Maybe<Scalars['String']['output']>;
  /** Outcome or result of the case. */
  Result?: Maybe<Scalars['String']['output']>;
  /** Current status of the case. */
  Status?: Maybe<Scalars['String']['output']>;
};

/** Domain error returned when the AccountId provided to the patient case report query is invalid. */
export type PatientCaseReportInvalidAccountIdError = DomainError & {
  __typename?: 'PatientCaseReportInvalidAccountIdError';
  /** AccountId that was included in the query */
  AccountId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for patientCaseReport. Returns PatientCaseReport on success or PatientCaseReportInvalidAccountIdError on failure. */
export type PatientCaseReportResult = PatientCaseReport | PatientCaseReportInvalidAccountIdError;

/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQuery = {
  __typename?: 'PatientDirectoryReportQuery';
  /**
   * Patient Directory Report for All Active Members
   * Validate that the All Members report delivers all the attributes defined in the acceptance criteria.
   */
  pdrAllActiveMembers: PdrAllActiveMembersResult;
  /**
   * Patient Directory Report for Cancelled Members
   * Members whose memberships have been terminated in the prior 12 months.
   */
  pdrCancelledMembers: PdrCancelledMembersResult;
  /**
   * Patient Directory Report for Future Cancellation members
   * Members scheduled to cancel at a future date.
   */
  pdrFutureCancellationMembers: PdrFutureCancellationMembersResult;
  /**
   * Patient Directory Report for IPPE Calculation
   * As Staff, I want to see which Members are becoming eligible for Medicare in the coming year so that I can schedule the physical.
   */
  pdrIPPECalculation: PdrIppeCalculationResult;
  /**
   * Patient Directory Report for New Members
   * Individuals who have enrolled in your practice within the 12 Months.
   */
  pdrNewMembers: PdrNewMembersResult;
  /**
   * Patient Directory Report for Outstanding Wellness Exam
   * Members who have not had a Wellness Exam performed in over 1 year.
   */
  pdrOutstandingWellnessExam: PdrOutstandingWellnessExamResult;
  /**
   * Patient Directory Report for Past Due Members
   * Members whose payments are overdue (1 thru 61 days overdue).
   * Members greater than 61 days past due are Suspended
   */
  pdrPastDueMembers: PdrPastDueMembersResult;
  /**
   * Patient Directory Report for Past Patient List (Transition Prospects)
   * All pre-MDVIP Practice Patients that have not enrolled.
   * This list will only be available during the first 18 months of practice affiliation.
   */
  pdrPastPatientList: PdrPastPatientListResult;
  /**
   * Patient Directory Report for Pending Wellness Exams
   * Members with a Wellness Exam uploaded that's awaiting review and approval.
   */
  pdrPendingWellnessExams: PdrPendingWellnessExamsResult;
  /**
   * Patient Directory Report for Recommended Outreach members
   * Members who should be contacted by the office prior to their upcoming renewal
   * to ensure their satisfaction with the program. (Use Member's preferred contact method.)
   */
  pdrRecommendedOutreachMembers: PdrRecommendedOutreachMembersResult;
  /**
   * Patient Directory Report for Re-instated Members
   * Any prior members of your practice whose memberships have returned to active status.
   */
  pdrReinstatedMembers: PdrReinstatedMembersResult;
  /**
   * Patient Directory Report for Scholarship Members
   * Members whose annual fees have been waived for 1 year as approved by the Physician.
   */
  pdrScholarshipMembers: PdrScholarshipMembersResult;
  /**
   * Patient Directory Report for Suspended Members
   * Members whose payments are overdue by 62 days or greater.
   * Members less than 62 days past due are not yet Suspended but Past Due
   */
  pdrSuspendedMembers: PdrSuspendedMembersResult;
  /**
   * Patient Directory Report for Upcoming Renewals
   * Members whose memberships are scheduled to renew within the next two months.
   */
  pdrUpcomingRenewals: PdrUpcomingRenewalsResult;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrAllActiveMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrCancelledMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrFutureCancellationMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrIppeCalculationArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrNewMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrOutstandingWellnessExamArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrPastDueMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrPastPatientListArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrPendingWellnessExamsArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrRecommendedOutreachMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrReinstatedMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrScholarshipMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrSuspendedMembersArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the namespace for all patient directory report queries. */
export type PatientDirectoryReportQueryPdrUpcomingRenewalsArgs = {
  AccountId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a single member activity record such as a task or event. */
export type PatientMemberActivity = {
  __typename?: 'PatientMemberActivity';
  /** Profile of the user who created the activity. */
  CreatedByProfile__c?: Maybe<Scalars['String']['output']>;
  /** Date the activity was created. */
  CreatedDate?: Maybe<Scalars['String']['output']>;
  /** Unique activity identifier. */
  Id?: Maybe<Scalars['String']['output']>;
  /** Subject line of the activity. */
  Subject?: Maybe<Scalars['String']['output']>;
  /** Salesforce WhoId linking the activity to a contact. */
  WhoId?: Maybe<Scalars['String']['output']>;
};

/** Encapsulates all domain errors for the patientReceiptByDocumentId operation. */
export type PatientReceiptByDocumentIdFailure = {
  __typename?: 'PatientReceiptByDocumentIdFailure';
  /** All errors associated with required Invoice. */
  errors: Array<PatientReceiptByDocumentIdFailureError>;
};

/** Domain error returned when retrieving a patient receipt by document ID fails. */
export type PatientReceiptByDocumentIdFailureError = DomainError & {
  __typename?: 'PatientReceiptByDocumentIdFailureError';
  /** Id that was included in the query */
  contactId: Scalars['String']['output'];
  /** Document ID that was included in the query. */
  documentId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** HTTP status code from the upstream service. */
  statusCode?: Maybe<Scalars['Int']['output']>;
};

/** Input parameters for the patientReceiptByDocumentId query. */
export type PatientReceiptByDocumentIdInput = {
  /** Salesforce Contact ID of the patient. */
  contactId: Scalars['String']['input'];
  /** Document ID of the invoice to retrieve. */
  documentId: Scalars['String']['input'];
};

/** Represents the result of a patient receipt document query. */
export type PatientReceiptByDocumentIdQueryResult = {
  __typename?: 'PatientReceiptByDocumentIdQueryResult';
  /** Base64-encoded document content. */
  document?: Maybe<Scalars['String']['output']>;
  /** Outstanding balance on the document. */
  documentBalance?: Maybe<Scalars['Float']['output']>;
  /** Response message from the server. */
  message?: Maybe<Scalars['String']['output']>;
  /** HTTP status code from the upstream service. */
  statusCode?: Maybe<Scalars['Int']['output']>;
};

/** Result type for patientReceiptByDocumentId. Returns PatientReceiptByDocumentIdQueryResult on success or PatientReceiptByDocumentIdFailure on failure. */
export type PatientReceiptByDocumentIdResult = PatientReceiptByDocumentIdFailure | PatientReceiptByDocumentIdQueryResult;

/** Represents a completed payment transaction record from Salesforce. */
export type Payment = {
  __typename?: 'Payment';
  /** Payment amount in dollars (Amount__c custom field). */
  Amount__c?: Maybe<Scalars['Float']['output']>;
  /** Date the payment was applied (Apply_Date__c custom field). */
  Apply_Date__c?: Maybe<Scalars['String']['output']>;
  /** Check number if payment was by check (Check__c custom field). */
  Check__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce record ID of the payment. */
  Id: Scalars['ID']['output'];
  /** Last 4 digits of the payment method (Last_4_Digits__c custom field). */
  Last_4_Digits__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP member ID (MDVIPID__c custom field). */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** Display name of the payment record. */
  Name?: Maybe<Scalars['String']['output']>;
  /** Salesforce Payment Profile ID (Payment_Profile__c custom field). */
  Payment_Profile__c?: Maybe<Scalars['String']['output']>;
  /** Reference to the associated payment profile entity. */
  Payment_Profile__r?: Maybe<PaymentProfile>;
  /** Payment method type used for this transaction. */
  Payment_Type__c?: Maybe<PaymentPaymentType>;
  /** Transaction type of the payment. */
  Type__c?: Maybe<TransactionType>;
};

/** Union of all domain errors that can occur when retrieving a payment by ID. */
export type PaymentByIdDomainError = PaymentByIdNotFoundDomainError;

/** Encapsulates all domain errors for the paymentById operation. */
export type PaymentByIdFailure = {
  __typename?: 'PaymentByIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<PaymentByIdDomainError>;
};

/** Domain error returned when a payment record is not found by the given ID. */
export type PaymentByIdNotFoundDomainError = {
  __typename?: 'PaymentByIdNotFoundDomainError';
  /** The payment ID that was not found. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for paymentById. Returns Payment on success or PaymentByIdFailure on failure. */
export type PaymentByIdResult = Payment | PaymentByIdFailure;

/** Defines the payment method types used in payment history records. */
export enum PaymentPaymentType {
  /** ACH bank account transfer (inactive). */
  Ach = 'ACH',
  /** American Express (legacy code) */
  Amex = 'AMEX',
  /** American Express */
  AmericanExpress = 'American_Express',
  /** Cash payment */
  Cash = 'Cash',
  /** Check payment */
  Check = 'Check',
  /** Credit Memo */
  CreditMemo = 'Credit_Memo',
  /** Discover (legacy code) */
  Disc = 'DISC',
  /** Discover credit or debit card */
  Discover = 'Discover',
  /** Mastercard (legacy code) */
  Mc = 'MC',
  /** Mastercard credit or debit card */
  Mastercard = 'Mastercard',
  /** Visa credit or debit card */
  Visa = 'Visa'
}

/** Represents the namespace for payment preference queries. */
export type PaymentPreferencesQuery = {
  __typename?: 'PaymentPreferencesQuery';
  /** Retrieves a Litle gateway error message by its response code. */
  litleErrorByCode: LitleErrorByCodeResult;
  /** Retrieves the current Litle payment gateway settings. */
  litleSettings: LitleSettingsResult;
  /** Retrieves the maximum allowed payment amount setting. */
  maximumPaymentAmount: MaximumPaymentAmountResult;
};


/** Represents the namespace for payment preference queries. */
export type PaymentPreferencesQueryLitleErrorByCodeArgs = {
  code: Scalars['ID']['input'];
};

/** Represents a federated PaymentProfile entity stub used for payment references. */
export type PaymentProfile = {
  __typename?: 'PaymentProfile';
  /** ACH bank name (ACHBankName__c custom field). */
  ACHBankName__c?: Maybe<Scalars['String']['output']>;
  /** Last 6 digits of the ACH account number (ACHLast6__c custom field). */
  ACHLast6__c?: Maybe<Scalars['String']['output']>;
  /** Last 9 digits of the ACH routing number (ACHRoutingLast9__c custom field). */
  ACHRoutingLast9__c?: Maybe<Scalars['String']['output']>;
  /** Name on the ACH account (ACH_Name_of_Account__c custom field). */
  ACH_Name_of_Account__c?: Maybe<Scalars['String']['output']>;
  /** Whether this payment profile is active. */
  Active__c?: Maybe<Scalars['Boolean']['output']>;
  /** Billing address line 1. */
  Address_1__c?: Maybe<Scalars['String']['output']>;
  /** Billing address line 2. */
  Address_2__c?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of the credit card number (CCLast4__c custom field). */
  CCLast4__c?: Maybe<Scalars['String']['output']>;
  /** Card type classification (e.g., COMMERCIAL, CONSUMER). */
  Card_Type__c?: Maybe<Scalars['String']['output']>;
  /** Billing address city. */
  City__c?: Maybe<Scalars['String']['output']>;
  /** Whether this is the default payment profile. */
  Default__c?: Maybe<Scalars['Boolean']['output']>;
  /** Expiration month of the credit card. */
  Expiration_Month__c?: Maybe<Scalars['String']['output']>;
  /** Expiration year of the credit card. */
  Expiration_Year__c?: Maybe<Scalars['String']['output']>;
  /** Whether the payment method has expired. */
  Expired__c?: Maybe<Scalars['String']['output']>;
  /** Whether this is an HSA (Health Savings Account) card. */
  HSACard__c?: Maybe<PaymentProfileHsaCard>;
  /** Salesforce record ID of the payment profile. */
  Id: Scalars['ID']['output'];
  /** Country of the card issuer. */
  Issuer_Country__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP member ID associated with this profile (Member_ID__c custom field). */
  Member_ID__c?: Maybe<Scalars['String']['output']>;
  /** Name on the credit card (Name_on_Card__c custom field). */
  Name_on_Card__c?: Maybe<Scalars['String']['output']>;
  /** Payment method type of this profile. */
  PaymentType__c?: Maybe<ExtendedPaymentProfilePaymentType>;
  /** Billing address state. */
  States__c?: Maybe<Scalars['String']['output']>;
  /** Billing address ZIP code. */
  Zipcode__c?: Maybe<Scalars['String']['output']>;
};

/** Defines the ACH bank account types for payment profiles. */
export enum PaymentProfileAchAccountType {
  /** Checking account */
  Checking = 'Checking',
  /** Other account type */
  Other = 'Other',
  /** Savings account */
  Savings = 'Savings'
}

/** Union of all domain errors that can occur when retrieving a payment profile by ID. */
export type PaymentProfileByIdDomainError = PaymentProfileByIdNotFoundDomainError;

/** Encapsulates all domain errors for the paymentProfileById operation. */
export type PaymentProfileByIdFailure = {
  __typename?: 'PaymentProfileByIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<PaymentProfileByIdDomainError>;
};

/** Domain error returned when a payment profile is not found by the given ID. */
export type PaymentProfileByIdNotFoundDomainError = DomainError & {
  __typename?: 'PaymentProfileByIdNotFoundDomainError';
  /** The payment profile ID that was not found. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for paymentProfileById. Returns PaymentProfile on success or PaymentProfileByIdFailure on failure. */
export type PaymentProfileByIdResult = PaymentProfile | PaymentProfileByIdFailure;

/** Defines the card type classifications. */
export enum PaymentProfileCardType {
  /** Commercial/business card */
  Commercial = 'COMMERCIAL',
  /** Consumer/personal card */
  Consumer = 'CONSUMER',
  /** Unknown card type */
  Unknown = 'UNKNOWN'
}

/** Defines whether a payment profile card is an HSA card. */
export enum PaymentProfileHsaCard {
  /** Card is not an HSA card */
  No = 'No',
  /** Card is an HSA card */
  Yes = 'Yes'
}

/** Defines the supported payment card and account types returned by the payment gateway. */
export enum PaymentProfilePaymentType {
  /** ACH bank account transfer */
  Ach = 'ACH',
  /** American Express credit card */
  Amex = 'AMEX',
  /** Discover credit or debit card */
  Disc = 'DISC',
  /** Mastercard credit or debit card */
  Mc = 'MC',
  /** Visa credit or debit card */
  Visa = 'VISA'
}

/** Defines the record types for payment profiles. */
export enum PaymentProfileType {
  /** Guest/default payment profile record type */
  Guest = 'Guest',
  /** Payment/autopay profile record type */
  Payment = 'Payment'
}

/** Defines the payment profile type filter options for listing. */
export enum PaymentProfileTypeFilter {
  /** Filter for ACH bank account profiles */
  BankAccount = 'BANK_ACCOUNT',
  /** Filter for credit card profiles */
  CreditCard = 'CREDIT_CARD'
}

export type PaymentProfile_Old = {
  __typename?: 'PaymentProfile_Old';
  ACHBankName__c?: Maybe<Scalars['String']['output']>;
  ACHLast6__c?: Maybe<Scalars['String']['output']>;
  ACHRoutingLast9__c?: Maybe<Scalars['String']['output']>;
  ACH_Account_Type__c?: Maybe<Scalars['String']['output']>;
  ACH_Name_of_Account__c?: Maybe<Scalars['String']['output']>;
  Active__c?: Maybe<Scalars['Boolean']['output']>;
  Address_1__c?: Maybe<Scalars['String']['output']>;
  Address_2__c?: Maybe<Scalars['String']['output']>;
  CCLast4__c?: Maybe<Scalars['String']['output']>;
  Card_Type__c?: Maybe<Scalars['String']['output']>;
  City__c?: Maybe<Scalars['String']['output']>;
  Default__c?: Maybe<Scalars['Boolean']['output']>;
  Expiration_Month__c?: Maybe<Scalars['String']['output']>;
  Expiration_Year__c?: Maybe<Scalars['String']['output']>;
  Expired__c?: Maybe<Scalars['String']['output']>;
  HSACard__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Issuer_Country__c?: Maybe<Scalars['String']['output']>;
  Member_ID__c?: Maybe<Scalars['String']['output']>;
  Name_on_Card__c?: Maybe<Scalars['String']['output']>;
  PaymentType__c?: Maybe<PaymentTypeEnum>;
  States__c?: Maybe<Scalars['String']['output']>;
  Zipcode__c?: Maybe<Scalars['String']['output']>;
};

/** Filter criteria for the paymentProfilesList query. */
export type PaymentProfilesFilters = {
  /** Filter by active status. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by MDVIP member ID. */
  mdvipId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by payment method type (bank account or credit card). */
  type?: InputMaybe<PaymentProfileTypeFilter>;
};

/** Input parameters for the paymentProfilesList query. */
export type PaymentProfilesInput = {
  /** Optional filter criteria for payment profiles. */
  filters?: InputMaybe<PaymentProfilesFilters>;
  /** Maximum number of records to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records to skip for pagination. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the paginated result of the paymentProfilesList query. */
export type PaymentProfilesResult = {
  __typename?: 'PaymentProfilesResult';
  /** List of payment profile records. */
  edges: Array<PaymentProfile>;
  /** Current pagination limit. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Current pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

export type PaymentSettingsInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RequestTypeEnum>;
};

export type PaymentSettingsType = {
  __typename?: 'PaymentSettingsType';
  LitleInterfaceDetails?: Maybe<LitleInterfaceDetailsType>;
  MaximumPaymentAmount?: Maybe<MaximumPaymentAmountType>;
  ResponseCodeMessage?: Maybe<ResponseCodeMessageType>;
};

/** Defines the payment creation types. */
export enum PaymentType {
  /** Credit card payment */
  CreditCardPayment = 'CreditCardPayment',
  /** General payment */
  Payment = 'Payment'
}

export enum PaymentTypeEnum {
  Ach = 'ACH',
  Amex = 'AMEX',
  Check = 'Check',
  Disc = 'DISC',
  Discover = 'Discover',
  Mc = 'MC',
  Mastercard = 'Mastercard',
  Visa = 'VISA'
}

export type Payment_Old = {
  __typename?: 'Payment_Old';
  ACHBankName__c?: Maybe<Scalars['String']['output']>;
  ACHLast6__c?: Maybe<Scalars['String']['output']>;
  Amount__c?: Maybe<Scalars['String']['output']>;
  Apply_Date__c?: Maybe<Scalars['String']['output']>;
  CCLast4__c?: Maybe<Scalars['String']['output']>;
  Check__c?: Maybe<Scalars['String']['output']>;
  Date_Processed__c?: Maybe<Scalars['String']['output']>;
  Expiration_Month__c?: Maybe<Scalars['String']['output']>;
  Expiration_Year__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  PaymentType__c?: Maybe<Scalars['String']['output']>;
  Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  Payment_Profile__c?: Maybe<Scalars['String']['output']>;
  Payment_Profile__r?: Maybe<PaymentProfile_Old>;
  Payment_Type__c?: Maybe<Scalars['String']['output']>;
  Schedule_Date__c?: Maybe<Scalars['String']['output']>;
};

/** Filter criteria for the paymentsList query. */
export type PaymentsFilters = {
  /** Transaction types to include in results. Defaults to Payment only. */
  Type__c?: InputMaybe<Array<TransactionType>>;
};

/** Input parameters for the paymentsList query. */
export type PaymentsInput = {
  /** Optional filter criteria for payments. */
  filters?: InputMaybe<PaymentsFilters>;
  /** Maximum number of records to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records to skip for pagination. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the paginated result of the paymentsList query. */
export type PaymentsResult = {
  __typename?: 'PaymentsResult';
  /** List of payment records. */
  edges: Array<Payment>;
  /** Current pagination limit. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Current pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Patient Directory Report - Active Member
 * Validate that the All Members report delivers all the attributes defined in the acceptance criteria.
 */
export type PdrActiveMember = {
  __typename?: 'PdrActiveMember';
  /** Salesforce Account identifier. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Member age. */
  Age__c?: Maybe<Scalars['String']['output']>;
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Number of days the member's billing is past due. */
  Billing_Days_Past_Due__c?: Maybe<Scalars['String']['output']>;
  /** Member birth date. */
  BirthDate?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Whether to suppress EHR synchronization. */
  Do_Not_Sync_EHR__c?: Maybe<Scalars['Boolean']['output']>;
  /** EHR external identifier. */
  EID__c?: Maybe<Scalars['String']['output']>;
  /** Member email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Employer name. */
  Employer__c?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Related insurance record. */
  Insurance__r?: Maybe<Insurance>;
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Date of last mobile app login. */
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of last portal login. */
  Last_Portal_Login__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** Source through which the member was acquired. */
  LeadSource?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Date of the member's next birthday. */
  Next_Birthday__c?: Maybe<Scalars['String']['output']>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Name of the referring member. */
  Referral_Name__c?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
  /** Name of insurance company when not found in reference data. */
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
};

/** Patient Directory Report - All Active Members */
export type PdrAllActiveMembersResult = {
  __typename?: 'PdrAllActiveMembersResult';
  /** List of active member records. */
  edges: Array<PdrActiveMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/** Cancelled Member - Patient Directory Report */
export type PdrCancelledMember = {
  __typename?: 'PdrCancelledMember';
  /** Reason for cancellation. */
  Cancel_Reason__c?: Maybe<Scalars['String']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance. */
  Current_Balance__c?: Maybe<Scalars['Float']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Whether to suppress EHR synchronization. */
  Do_Not_Sync_EHR__c?: Maybe<Scalars['Boolean']['output']>;
  /** EHR external identifier. */
  EID__c?: Maybe<Scalars['String']['output']>;
  /** Email address of the member. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the key event log entry. */
  Event_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Related insurance record. */
  Insurance__r?: Maybe<Insurance>;
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last cancellation. */
  Last_Cancel_Date__c?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Audience the portal event targets. */
  Portal_Audience__c?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Status of the key event log entry. */
  Status__c?: Maybe<Scalars['String']['output']>;
  /** Subject of the key event log entry. */
  Subject__c?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
};

/** Patient Directory Report - Cancelled Members */
export type PdrCancelledMembersResult = {
  __typename?: 'PdrCancelledMembersResult';
  /** List of cancelled member records. */
  edges: Array<PdrCancelledMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Patient Directory Report for Future Cancellation members
 * Member scheduled to cancel at a future date.
 */
export type PdrFutureCancellationMember = {
  __typename?: 'PdrFutureCancellationMember';
  /** Salesforce Account identifier. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Reason for cancellation. */
  Cancel_Reason__c?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Member email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last cancellation. */
  Last_Cancel_Date__c?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
};

/** Patient Directory Report - Future Cancellations */
export type PdrFutureCancellationMembersResult = {
  __typename?: 'PdrFutureCancellationMembersResult';
  /** List of future cancellation member records. */
  edges: Array<PdrFutureCancellationMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * IPPE Calculation Member - Patient Directory Report
 * Member becoming eligible for Medicare in the coming year.
 */
export type PdrIppeCalculationMember = {
  __typename?: 'PdrIPPECalculationMember';
  /** Salesforce Account identifier. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Member age. */
  Age__c?: Maybe<Scalars['String']['output']>;
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** EHR external identifier. */
  EID__c?: Maybe<Scalars['String']['output']>;
  /** Member email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Unique member identifier. */
  Id: Scalars['ID']['output'];
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Date of the member's next birthday. */
  Next_Birthday__c?: Maybe<Scalars['String']['output']>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Date MDVIP Member turn 66 years of age */
  SuggestedEndDate?: Maybe<Scalars['String']['output']>;
  /** Date MDVIP Member turn 65 years of age */
  SuggestedStartDate?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
  /** Name of insurance company when not found in reference data. */
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
};

/** Patient Directory Report - IPPE calculation */
export type PdrIppeCalculationResult = {
  __typename?: 'PdrIPPECalculationResult';
  /** List of IPPE calculation member records. */
  edges: Array<PdrIppeCalculationMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/** New Member - Patient Directory Report */
export type PdrNewMember = {
  __typename?: 'PdrNewMember';
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Reason for cancellation. */
  Cancel_Reason__c?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Email address of the member. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the key event log entry. */
  Event_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Related insurance record. */
  Insurance__r?: Maybe<Insurance>;
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** Source through which the member was acquired. */
  LeadSource?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Audience the portal event targets. */
  Portal_Audience__c?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Status of the key event log entry. */
  Status__c?: Maybe<Scalars['String']['output']>;
  /** Subject of the key event log entry. */
  Subject__c?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
  /** Name of insurance company when not found in reference data. */
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
};

/** Patient Directory Report - New Members */
export type PdrNewMembersResult = {
  __typename?: 'PdrNewMembersResult';
  /** List of new member records. */
  edges: Array<PdrNewMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Outstanding Wellness Exam Member
 * Member who have not had a Wellness Exam performed in over 1 year.
 */
export type PdrOutstandingWellnessExamMember = {
  __typename?: 'PdrOutstandingWellnessExamMember';
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Number of days the member's billing is past due. */
  Billing_Days_Past_Due__c?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Email address of the member. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
};

/** Patient Directory Report - Outstanding Wellness Exam */
export type PdrOutstandingWellnessExamResult = {
  __typename?: 'PdrOutstandingWellnessExamResult';
  /** List of outstanding wellness exam member records. */
  edges: Array<PdrOutstandingWellnessExamMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Patient Directory Report - Past Due Member
 * Members whose payments are overdue (1 thru 61 days overdue).
 * Members greater than 61 days past due are Suspended
 */
export type PdrPastDueMember = {
  __typename?: 'PdrPastDueMember';
  /** Salesforce Account identifier. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Related bill-to national account name. */
  Bill_to_National_Account__r?: Maybe<Scalars['String']['output']>;
  /** Number of days the member's billing is past due. */
  Billing_Days_Past_Due__c?: Maybe<Scalars['Int']['output']>;
  /** Date of credit card decline call. */
  CC_Decline_Call__c?: Maybe<Scalars['String']['output']>;
  /** Date of credit card decline letter. */
  CC_Decline_Letter__c?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance. */
  Current_Balance__c?: Maybe<Scalars['Float']['output']>;
  /** Dunning call 1 date. */
  DUN_Call_1__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 2 date. */
  DUN_Call_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 3 date. */
  DUN_Call_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 4 date. */
  DUN_Call_4__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 2 sent date. */
  DUN_Email_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 3 sent date. */
  DUN_Email_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 4 sent date. */
  DUN_Email_4__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 1 sent date. */
  DUN_Letter_1__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 2 sent date. */
  DUN_Letter_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 3 sent date. */
  DUN_Letter_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 4 sent date. */
  DUN_Letter_4__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 1 sent date. */
  Dun_Email_1__c?: Maybe<Scalars['String']['output']>;
  /** Member email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Reason for the member's last cancellation. */
  Last_Cancel_Reason__c?: Maybe<Scalars['String']['output']>;
  /** Last payment amount as text. */
  Last_Payment_Amount_Text__c?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
  /** Amount 30 days past due. */
  X30_Days__c?: Maybe<Scalars['String']['output']>;
  /** Amount 60 days past due. */
  X60_Days__c?: Maybe<Scalars['String']['output']>;
  /** Amount 90 days past due. */
  X90_Days__c?: Maybe<Scalars['String']['output']>;
  /** Amount 120 days past due. */
  X120_Days__c?: Maybe<Scalars['String']['output']>;
};

/** Patient Directory Report - Past Due Members */
export type PdrPastDueMembersResult = {
  __typename?: 'PdrPastDueMembersResult';
  /** List of past due member records. */
  edges: Array<PdrPastDueMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/** Past Patient (Transition Prospect) */
export type PdrPastPatient = {
  __typename?: 'PdrPastPatient';
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Email address of the member. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
};

/** Patient Directory Report - Past Patient List (Transition Prospects) */
export type PdrPastPatientListResult = {
  __typename?: 'PdrPastPatientListResult';
  /** List of past patient records. */
  edges: Array<PdrPastPatient>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Patient Directory Report for Pending Wellness Exams
 * Members with a Wellness Exam uploaded that's awaiting review and approval.
 */
export type PdrPendingWellnessExam = {
  __typename?: 'PdrPendingWellnessExam';
  /** Salesforce Account identifier. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Number of days the member's billing is past due. */
  Billing_Days_Past_Due__c?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Email address of the member. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date the wellness exam was performed. */
  Exam_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Related insurance record. */
  Insurance__r?: Maybe<Insurance>;
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
  /** Date the wellness exam was uploaded. */
  Upload_Date__c?: Maybe<Scalars['String']['output']>;
  /** Upload status of the wellness exam. */
  Upload_Status__c?: Maybe<Scalars['String']['output']>;
};

/** Patient Directory Report - Pending Wellness Exams */
export type PdrPendingWellnessExamsResult = {
  __typename?: 'PdrPendingWellnessExamsResult';
  /** List of pending wellness exam records. */
  edges: Array<PdrPendingWellnessExam>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Patient Directory Report for Recommended Outreach members
 * Members who should be contacted by the office prior to their upcoming renewal
 * to ensure their satisfaction with the program. (Use Member's preferred contact method.)
 */
export type PdrRecommendedOutreachMember = {
  __typename?: 'PdrRecommendedOutreachMember';
  /** Salesforce Account identifier. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Number of days the member's billing is past due. */
  Billing_Days_Past_Due__c?: Maybe<Scalars['Int']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Member email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
};

/** Patient Directory Report - Recommended Outreach */
export type PdrRecommendedOutreachMembersResult = {
  __typename?: 'PdrRecommendedOutreachMembersResult';
  /** List of recommended outreach member records. */
  edges: Array<PdrRecommendedOutreachMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/** Reinstated Member - Patient Directory Report */
export type PdrReinstatedMember = {
  __typename?: 'PdrReinstatedMember';
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Reason for cancellation. */
  Cancel_Reason__c?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Email address of the member. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the key event log entry. */
  Event_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Related insurance record. */
  Insurance__r?: Maybe<Insurance>;
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** Source through which the member was acquired. */
  LeadSource?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Date of the member's next birthday. */
  Next_Birthday__c?: Maybe<Scalars['String']['output']>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Audience the portal event targets. */
  Portal_Audience__c?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Status of the key event log entry. */
  Status__c?: Maybe<Scalars['String']['output']>;
  /** Subject of the key event log entry. */
  Subject__c?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
  /** Name of insurance company when not found in reference data. */
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
};

/** Patient Directory Report - Re-instated Members */
export type PdrReinstatedMembersResult = {
  __typename?: 'PdrReinstatedMembersResult';
  /** List of reinstated member records. */
  edges: Array<PdrReinstatedMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Patient Directory Report - Scholarship Member
 * Member whose annual fees have been waived for 1 year as approved by the Physician.
 */
export type PdrScholarshipMember = {
  __typename?: 'PdrScholarshipMember';
  /** Salesforce Account identifier. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance. */
  Current_Balance__c?: Maybe<Scalars['Float']['output']>;
  /** Dunning call 1 date. */
  DUN_Call_1__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 2 date. */
  DUN_Call_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 3 date. */
  DUN_Call_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 4 date. */
  DUN_Call_4__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 2 sent date. */
  DUN_Email_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 3 sent date. */
  DUN_Email_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 4 sent date. */
  DUN_Email_4__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 1 sent date. */
  DUN_Letter_1__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 2 sent date. */
  DUN_Letter_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 3 sent date. */
  DUN_Letter_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 4 sent date. */
  DUN_Letter_4__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 1 sent date. */
  Dun_Email_1__c?: Maybe<Scalars['String']['output']>;
  /** Email address of the member. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Related insurance record. */
  Insurance__r?: Maybe<Insurance>;
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** Source through which the member was acquired. */
  LeadSource?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Date of the member's next birthday. */
  Next_Birthday__c?: Maybe<Scalars['String']['output']>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Date the scholarship period ends. */
  Scholarship_End_Date__c?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
  /** Name of insurance company when not found in reference data. */
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
};

/** Patient Directory Report - Scholarship Members */
export type PdrScholarshipMembersResult = {
  __typename?: 'PdrScholarshipMembersResult';
  /** List of scholarship member records. */
  edges: Array<PdrScholarshipMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Patient Directory Report - Suspended Member
 * Member whose payments are overdue by 62 days or greater.
 * Member less than 62 days past due are not yet Suspended but Past Due
 */
export type PdrSuspendedMember = {
  __typename?: 'PdrSuspendedMember';
  /** Salesforce Account identifier. */
  AccountId?: Maybe<Scalars['String']['output']>;
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Related bill-to national account name. */
  Bill_to_National_Account__r?: Maybe<Scalars['String']['output']>;
  /** Number of days the member's billing is past due. */
  Billing_Days_Past_Due__c?: Maybe<Scalars['Int']['output']>;
  /** Date of credit card decline call. */
  CC_Decline_Call__c?: Maybe<Scalars['String']['output']>;
  /** Date of credit card decline letter. */
  CC_Decline_Letter__c?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance formula field. */
  Current_Balance_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Current outstanding balance. */
  Current_Balance__c?: Maybe<Scalars['Float']['output']>;
  /** Current billing amount. */
  Current__c?: Maybe<Scalars['Float']['output']>;
  /** Dunning call 1 date. */
  DUN_Call_1__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 2 date. */
  DUN_Call_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 3 date. */
  DUN_Call_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning call 4 date. */
  DUN_Call_4__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 2 sent date. */
  DUN_Email_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 3 sent date. */
  DUN_Email_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 4 sent date. */
  DUN_Email_4__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 1 sent date. */
  DUN_Letter_1__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 2 sent date. */
  DUN_Letter_2__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 3 sent date. */
  DUN_Letter_3__c?: Maybe<Scalars['String']['output']>;
  /** Dunning letter 4 sent date. */
  DUN_Letter_4__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Dunning email 1 sent date. */
  Dun_Email_1__c?: Maybe<Scalars['String']['output']>;
  /** Member email address. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Related insurance record. */
  Insurance__r?: Maybe<Insurance>;
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
  /** Amount 30 days past due. */
  X30_Days__c?: Maybe<Scalars['String']['output']>;
  /** Amount 60 days past due. */
  X60_Days__c?: Maybe<Scalars['String']['output']>;
  /** Amount 90 days past due. */
  X90_Days__c?: Maybe<Scalars['String']['output']>;
  /** Amount 120 days past due. */
  X120_Days__c?: Maybe<Scalars['String']['output']>;
};

/** Patient Directory Report - Suspended Members */
export type PdrSuspendedMembersResult = {
  __typename?: 'PdrSuspendedMembersResult';
  /** List of suspended member records. */
  edges: Array<PdrSuspendedMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**
 * Upcoming Renewal Member - Patient Directory Report
 * Member whose memberships are scheduled to renew within the next two months.
 */
export type PdrUpcomingRenewalMember = {
  __typename?: 'PdrUpcomingRenewalMember';
  /** Whether the member is enrolled in automatic payments. */
  AutoPay__c?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the member is billed to a national account. */
  Bill_to_National_Account__c?: Maybe<Scalars['String']['output']>;
  /** Manufacturer's suggested retail price for the current agreement. */
  Current_Agreement_MSRP__c?: Maybe<Scalars['Float']['output']>;
  /** Payment schedule for the current agreement. */
  Current_Agreement_Payment_Schedule__c?: Maybe<Scalars['String']['output']>;
  /** Member date of birth. */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Whether to suppress EHR synchronization. */
  Do_Not_Sync_EHR__c?: Maybe<Scalars['Boolean']['output']>;
  /** EHR external identifier. */
  EID__c?: Maybe<Scalars['String']['output']>;
  /** Email address of the member. */
  Email?: Maybe<Scalars['String']['output']>;
  /** Date the member was established in the practice. */
  Established_Date__c?: Maybe<Scalars['String']['output']>;
  /** Member first name. */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact record ID. */
  Id: Scalars['ID']['output'];
  /** Related insurance record. */
  Insurance__r?: Maybe<Insurance>;
  /** Member last name. */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last cancellation. */
  Last_Cancel_Date__c?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  Last_Payment_Amount__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last payment. */
  Last_Payment_Date__c?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam. */
  Last_Wellness_Exam__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP unique member identifier. */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** MemberFuse mailbox identifier. */
  MFMailboxID__c?: Maybe<Scalars['String']['output']>;
  /** Member mailing city. */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** Member mailing postal code. */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Member mailing state. */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** Member mailing street address. */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /** Current membership status. */
  Member_Status__c?: Maybe<Scalars['String']['output']>;
  /** Member mobile phone number. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Related national account record. */
  National_Account__r?: Maybe<NationalAccount>;
  /** Next renewal date formula field. */
  Next_Renewal_Date_Formula__c?: Maybe<Scalars['String']['output']>;
  /** Member primary phone number. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Member salutation (e.g., Mr., Mrs., Dr.). */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Tags associated with the member. */
  Tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of outstanding to-do items for the member. */
  TodoCount: Scalars['Int']['output'];
};

/** Patient Directory Report - Upcoming Renewals */
export type PdrUpcomingRenewalsResult = {
  __typename?: 'PdrUpcomingRenewalsResult';
  /** List of upcoming renewal member records. */
  edges: Array<PdrUpcomingRenewalMember>;
  /** Maximum number of records to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

export type Physician = Contact & {
  __typename?: 'Physician';
  /** Account information of Physician */
  Account?: Maybe<Account>;
  /** AccountId of Physician */
  AccountId: Scalars['String']['output'];
  AmountMSRP__c?: Maybe<Scalars['Int']['output']>;
  /** Date_Of_Birth__c of Physician */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Disposition_Code__c of Physician */
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  /** Email of Physician */
  Email?: Maybe<Scalars['String']['output']>;
  /**
   * Emergency_Phone__c of Physician
   * Format: (XXX) XXX-XXXX
   */
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  /** Estimated_Paid_Through__c of Physician */
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  /**
   * Fax from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Fax?: Maybe<Scalars['String']['output']>;
  /** FirstName of Physician */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Gender__c of Physician */
  Gender__c?: Maybe<Scalars['String']['output']>;
  /** AccountId of Physician */
  Id: Scalars['ID']['output'];
  /** LastName of Physician */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Last_App_Login__c of Physician */
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  /** MailingCity of Physician */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** MailingPostalCode of Physician */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** MailingState of Physician */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** MailingStreet of Physician */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /**
   * MobilePhone of Physician
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /**
   * Phone of Physician
   * Format: (XXX) XXX-XXXX
   */
  Phone?: Maybe<Scalars['String']['output']>;
  /** User preference to enable push notifications for new secure messages */
  Push_Notifications__c?: Maybe<Scalars['Boolean']['output']>;
  /** User preference to enable email notifications for new secure messages */
  SM_Email_Notification__c?: Maybe<Scalars['Boolean']['output']>;
  /** Salutation of Physician */
  Salutation?: Maybe<Scalars['String']['output']>;
  /** Localized string of Date_Of_Birth__c */
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
};

export type PhysicianByAccountIdDomainError = PhysicianByAccountIdNotFoundError;

/** A domain-specific failure to retrieve a physician by AccountId. */
export type PhysicianByAccountIdFailure = {
  __typename?: 'PhysicianByAccountIdFailure';
  /** All errors associated with required Physician. */
  errors: Array<PhysicianByAccountIdDomainError>;
};

export type PhysicianByAccountIdNotFoundError = DomainError & {
  __typename?: 'PhysicianByAccountIdNotFoundError';
  /** AccountId that was included in the query */
  AccountId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type PhysicianByAccountIdResult = Physician | PhysicianByAccountIdFailure;

export type PhysicianByContactIdDomainError = PhysicianByContactIdNotFoundError;

/** A domain-specific failure to retrieve a physician by ContactId. */
export type PhysicianByContactIdFailure = {
  __typename?: 'PhysicianByContactIdFailure';
  /** All errors associated with required Physician. */
  errors: Array<PhysicianByContactIdDomainError>;
};

export type PhysicianByContactIdNotFoundError = DomainError & {
  __typename?: 'PhysicianByContactIdNotFoundError';
  /** ContactId that was included in the query */
  ContactId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type PhysicianByContactIdResult = Physician | PhysicianByContactIdFailure;

export type PhysicianPracticeStaff = Contact & {
  __typename?: 'PhysicianPracticeStaff';
  /** AccountId from Contact record */
  AccountId: Scalars['String']['output'];
  /** Connect_User_Status__c from Contact record */
  Connect_User_Status__c?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Date_Of_Birth__c from Contact record
   * Format: YYYY-MM-DD
   */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Disposition_Code__c from Contact record */
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  /** Email from Contact record */
  Email?: Maybe<Scalars['String']['output']>;
  /**
   * Emergency_Phone__c from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  /** Estimated_Paid_Through__c from Contact record */
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  /**
   * Fax from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Fax?: Maybe<Scalars['String']['output']>;
  /** FirstName from Contact record */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Gender__c from Contact record */
  Gender__c?: Maybe<Scalars['String']['output']>;
  /** Id from Contact record */
  Id: Scalars['ID']['output'];
  /** LastName from Contact record */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Last_App_Login__c from Contact record */
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  /** MDVIP_Connect_User__c from Contact record */
  MDVIP_Connect_User__c?: Maybe<Scalars['Boolean']['output']>;
  /** MailingCity from Contact record */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** MailingPostalCode from Contact record */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** MailingState from Contact record */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** MailingStreet from Contact record */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /**
   * MobilePhone from Contact record
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /**
   * Phone from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Phone?: Maybe<Scalars['String']['output']>;
  /** User preference to enable push notifications for new secure messages */
  Push_Notifications__c?: Maybe<Scalars['Boolean']['output']>;
  /** User preference to enable email notifications for new secure messages */
  SM_Email_Notification__c?: Maybe<Scalars['Boolean']['output']>;
  /** Salutation from Contact record */
  Salutation?: Maybe<Scalars['String']['output']>;
  /**
   * Localized string of Date_Of_Birth__c
   * Format: MM/DD/YYYY
   */
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
  /** UserNameNotQualified__c from Contact record */
  UserNameNotQualified__c?: Maybe<Scalars['String']['output']>;
  /** The PhysicianPracticeStaff's corresponding Physician. */
  physician?: Maybe<Physician>;
};

export type PhysicianPracticeStaffByContactIdDomainError = PhysicianPracticeStaffByContactIdNotFoundError;

/** A domain-specific failure to retrieve a PhysicianPracticestaff by Id. */
export type PhysicianPracticeStaffByContactIdFailure = {
  __typename?: 'PhysicianPracticeStaffByContactIdFailure';
  /** All errors associated with required PhysicianPracticeStaff. */
  errors: Array<PhysicianPracticeStaffByContactIdDomainError>;
};

export type PhysicianPracticeStaffByContactIdNotFoundError = DomainError & {
  __typename?: 'PhysicianPracticeStaffByContactIdNotFoundError';
  /** ContactId that was included in the query */
  ContactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type PhysicianPracticeStaffByContactIdResult = PhysicianPracticeStaff | PhysicianPracticeStaffByContactIdFailure;

export type PhysicianPracticeStaffsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PhysicianPracticeStaffsResult = {
  __typename?: 'PhysicianPracticeStaffsResult';
  edges: Array<PhysicianPracticeStaff>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type PhysicianType = ContactType & {
  __typename?: 'PhysicianType';
  Account?: Maybe<AccountInfoType>;
  AccountId?: Maybe<Scalars['String']['output']>;
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  Fax?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gender__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  MailingCity?: Maybe<Scalars['String']['output']>;
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  MailingState?: Maybe<Scalars['String']['output']>;
  MailingStreet?: Maybe<Scalars['String']['output']>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingCity */
  Primary_City__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingState */
  Primary_State__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingStreet */
  Primary_Street_Address__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingPostalCode */
  Primary_Zip_Postal_Code__c?: Maybe<Scalars['String']['output']>;
  Salutation?: Maybe<Scalars['String']['output']>;
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
  memberIds?: Maybe<Array<Scalars['String']['output']>>;
  members?: Maybe<Array<Maybe<MemberType>>>;
  staff?: Maybe<Array<StaffType>>;
};

export type PhysiciansInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PhysiciansResult = {
  __typename?: 'PhysiciansResult';
  edges: Array<Physician>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

/** Represents the payload returned when a practice report is retrieved by file path. */
export type PracticeReportByFilePathPayload = {
  __typename?: 'PracticeReportByFilePathPayload';
  /** Base64-encoded content of the Personal Health Record (PHR) file. */
  PHR?: Maybe<Scalars['String']['output']>;
};

/** Result type for practiceReportByFilePath. Returns the report payload on success. */
export type PracticeReportByFilePathResult = PracticeReportByFilePathPayload;

export type Prospect = Contact & {
  __typename?: 'Prospect';
  /** AccountId of Prospect */
  AccountId: Scalars['String']['output'];
  /** CreatedDate of Prospect */
  CreatedDate?: Maybe<Scalars['String']['output']>;
  /**
   * Date_Of_Birth__c of Prospect
   * Format: YYYY-MM-DD
   */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Disposition_Code__c of Prospect */
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  /** Email of Prospect */
  Email?: Maybe<Scalars['String']['output']>;
  /**
   * Emergency_Phone__c of Prospect
   * Format: (XXX) XXX-XXXX
   */
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  /** Estimated_Paid_Through__c of Prospect */
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  /**
   * Fax from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Fax?: Maybe<Scalars['String']['output']>;
  /** FirstName of Prospect */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** Gender__c of Prospect */
  Gender__c?: Maybe<Scalars['String']['output']>;
  /** Id of Prospect */
  Id: Scalars['ID']['output'];
  /** Joiner_Type__c of Prospect */
  Joiner_Type__c?: Maybe<Scalars['String']['output']>;
  /** LastName of Prospect */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Last_App_Login__c of Prospect */
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  /** LeadSource of Prospect */
  LeadSource?: Maybe<Scalars['String']['output']>;
  /** MailingCity of Prospect */
  MailingCity?: Maybe<Scalars['String']['output']>;
  /** MailingPostalCode of Prospect */
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** MailingState of Prospect */
  MailingState?: Maybe<Scalars['String']['output']>;
  /** MailingStreet of Prospect */
  MailingStreet?: Maybe<Scalars['String']['output']>;
  /**
   * MobilePhone of Prospect
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /**
   * Phone of Prospect
   * Format: (XXX) XXX-XXXX
   */
  Phone?: Maybe<Scalars['String']['output']>;
  /** User preference to enable push notifications for new secure messages */
  Push_Notifications__c?: Maybe<Scalars['Boolean']['output']>;
  /** User preference to enable email notifications for new secure messages */
  SM_Email_Notification__c?: Maybe<Scalars['Boolean']['output']>;
  /** Salutation of Prospect */
  Salutation?: Maybe<Scalars['String']['output']>;
  /**
   * Localized string of Date_Of_Birth__c
   * Format: MM/DD/YYYY
   */
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Unknown_Insurance_Company_Name__c of Prospect */
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
  /** Prospect case */
  case?: Maybe<ProspectF2FCase>;
  /** Physician for this Prospect */
  physician?: Maybe<Physician>;
};

export type ProspectByContactIdDomainError = ProspectByContactIdNotFoundError;

/** A domain-specific failure to retrieve a prospect by Id. */
export type ProspectByContactIdFailure = {
  __typename?: 'ProspectByContactIdFailure';
  /** All errors associated with required Physician. */
  errors: Array<ProspectByContactIdDomainError>;
};

export type ProspectByContactIdNotFoundError = DomainError & {
  __typename?: 'ProspectByContactIdNotFoundError';
  /** ContactId that was included in the query */
  ContactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type ProspectByContactIdResult = Prospect | ProspectByContactIdFailure;

export type ProspectCase = {
  __typename?: 'ProspectCase';
  AccountId?: Maybe<Scalars['String']['output']>;
  ContactId?: Maybe<Scalars['String']['output']>;
  Date_of_Face_to_Face__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Meeting_Time__c?: Maybe<Scalars['String']['output']>;
  Result__c?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

/** Represents a prospect face-to-face case record from Salesforce. */
export type ProspectF2FCase = {
  __typename?: 'ProspectF2FCase';
  /** AccountId of the prospect case */
  AccountId: Scalars['String']['output'];
  /** ContactId of the prospect case */
  ContactId: Scalars['String']['output'];
  /** Date of the face-to-face appointment (MM/DD/YYYY format). */
  Date_of_Face_to_Face__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce record ID of the prospect case. */
  Id: Scalars['String']['output'];
  /** Scheduled time of the face-to-face meeting. */
  Meeting_Time__c?: Maybe<Scalars['String']['output']>;
  /** Outcome or result of the face-to-face appointment. */
  Result__c?: Maybe<Scalars['String']['output']>;
  /** Status of the prospect case */
  Status?: Maybe<ProspectF2FCaseStatus>;
};

/** Defines the possible statuses for a prospect face-to-face case. */
export enum ProspectF2FCaseStatus {
  /** Appointment has been cancelled. */
  AppointmentCancelled = 'AppointmentCancelled',
  /** Appointment has been completed. */
  AppointmentCompleted = 'AppointmentCompleted',
  /** Appointment is pending confirmation. */
  AppointmentPending = 'AppointmentPending',
  /** Appointment has been refused. */
  AppointmentRefused = 'AppointmentRefused',
  /** Appointment has been scheduled. */
  AppointmentScheduled = 'AppointmentScheduled'
}

export type ProspectInput = {
  AccountID?: InputMaybe<Scalars['String']['input']>;
  AcquisitionChannel?: InputMaybe<Scalars['String']['input']>;
  AcquisitionSubChannel?: InputMaybe<Scalars['String']['input']>;
  CampaignID?: InputMaybe<Scalars['String']['input']>;
  ContactID: Scalars['String']['input'];
  Date_Of_Birth__c?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  Gender__c?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  LeadID?: InputMaybe<Scalars['String']['input']>;
  LeadSource?: InputMaybe<Scalars['String']['input']>;
  MDVIPCanContact?: InputMaybe<Scalars['Boolean']['input']>;
  MDVIPID?: InputMaybe<Scalars['String']['input']>;
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  MailingState?: InputMaybe<Scalars['String']['input']>;
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  Phone?: InputMaybe<Scalars['String']['input']>;
  PhysicianName?: InputMaybe<Scalars['String']['input']>;
  Primary_City__c?: InputMaybe<Scalars['String']['input']>;
  Primary_State__c?: InputMaybe<Scalars['String']['input']>;
  Primary_Street_Address__c?: InputMaybe<Scalars['String']['input']>;
  Primary_Zip_Postal_Code__c?: InputMaybe<Scalars['String']['input']>;
  ProfileName?: InputMaybe<Scalars['String']['input']>;
  Referral_Name__c?: InputMaybe<Scalars['String']['input']>;
  Salutation?: InputMaybe<Scalars['String']['input']>;
  USLocalizedDateOfBirth?: InputMaybe<Scalars['String']['input']>;
  Unknown_Insurance_Company_Name__c?: InputMaybe<Scalars['String']['input']>;
  UserName?: InputMaybe<Scalars['String']['input']>;
  UserNameNotQualified?: InputMaybe<Scalars['String']['input']>;
};

export type ProspectType = ContactType & {
  __typename?: 'ProspectType';
  AccountId?: Maybe<Scalars['String']['output']>;
  Case?: Maybe<ProspectCase>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  Fax?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gender__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Joiner_Type__c?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  LeadSource?: Maybe<Scalars['String']['output']>;
  MailingCity?: Maybe<Scalars['String']['output']>;
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  MailingState?: Maybe<Scalars['String']['output']>;
  MailingStreet?: Maybe<Scalars['String']['output']>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingCity */
  Primary_City__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingState */
  Primary_State__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingStreet */
  Primary_Street_Address__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingPostalCode */
  Primary_Zip_Postal_Code__c?: Maybe<Scalars['String']['output']>;
  Salutation?: Maybe<Scalars['String']['output']>;
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
  Unknown_Insurance_Company_Name__c?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<PhysicianType>;
};

export type ProspectsByAccountIdInput = {
  filterStr?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProspectsByAccountIdResult = {
  __typename?: 'ProspectsByAccountIdResult';
  edges: Array<Prospect>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieves AWP records by account ID with optional filters. */
  AWPByAccountId?: Maybe<Array<Awp>>;
  /**
   * Retrieves an AWP file by its PHR ID.
   * @deprecated use awpByPhrId
   */
  AWPById?: Maybe<AwpFile>;
  account?: Maybe<AccountType>;
  /**
   * Account by Id field
   * This query is designed for only member to query Physician information.
   */
  accountById: AccountByIdResult;
  accounts?: Maybe<Array<Maybe<AccountType>>>;
  activeAffiliates?: Maybe<Array<Maybe<AffiliateWithContacts>>>;
  /** @deprecated use membersByAccountId */
  activeMembers?: Maybe<Array<Maybe<MemberType>>>;
  /** @deprecated use paymentProfilesList */
  activePaymentProfiles?: Maybe<Array<Maybe<PaymentProfile_Old>>>;
  /** @deprecated use patientActivityReport */
  activityReport?: Maybe<Array<Maybe<ReportActivityType>>>;
  /** @deprecated use physicianByContactId or physicianByAccountId */
  affiliateDetails?: Maybe<Array<Maybe<AffiliateType>>>;
  affiliateMembers?: Maybe<Array<Maybe<AffiliateType>>>;
  affiliateMessagingContactList?: Maybe<Array<Maybe<AffiliateContact>>>;
  /** Retrieves all physician accounts in the platform. */
  allAccounts: AccountsResult;
  /** @deprecated use paymentProfilesList */
  allPaymentProfiles?: Maybe<Array<Maybe<PaymentProfile_Old>>>;
  /**
   * All physicians in the platform
   * TODO: The name is not following conventions - should be `physicians` after removing old one.
   * @deprecated use allAccounts
   */
  allPhysicians: PhysiciansResult;
  /** Retrieves all practice reports for the given physician. */
  allPracticeReport: AllPracticeReportResult;
  announcement?: Maybe<Announcements>;
  announcements?: Maybe<Array<Maybe<Announcements>>>;
  /** @deprecated use attachmentDataById */
  attachmentById?: Maybe<Scalars['String']['output']>;
  /** Retrieves attachment data by attachment, message, thread, and mailbox IDs. */
  attachmentDataById: AttachmentDataByIdResult;
  /** @deprecated this service will be deleted because it doesn't exist in Secure Messaging backend */
  attachmentsByMessageId?: Maybe<Array<Maybe<AttachmentType>>>;
  /**
   * Feature flags needed:
   * - AWP Create (Upload AWP readonly)
   * AWP Audit (Approve AWP)
   * AWP Manage (Edit AWP)
   * AWP Read (Read AWP)
   * Retrieves an AWP record and associated upload/download URLs by PHR ID.
   */
  awpByPhrId: AwpByPhrIdResult;
  /** @deprecated use paymentProfilesList */
  bankAccountPaymentProfiles?: Maybe<Array<Maybe<PaymentProfile_Old>>>;
  /** @deprecated use membersByAccountId */
  byPhysicianId?: Maybe<Array<Maybe<MemberType>>>;
  campaignMembers?: Maybe<Array<Maybe<CampaignMemberType>>>;
  case?: Maybe<CaseType>;
  /** @deprecated use patientCaseReport */
  caseReport?: Maybe<Array<Maybe<ReportCaseType>>>;
  cases?: Maybe<Array<Maybe<CaseType>>>;
  /**
   * Get contact opt-in preferences by ContactId
   * The ContactId is derived from the auth token.
   */
  contactOptInPreferences?: Maybe<ContactOptInPreferencesResult>;
  /** @deprecated use paymentProfilesList */
  creditCardPaymentProfiles?: Maybe<Array<Maybe<PaymentProfile_Old>>>;
  /** @deprecated use defaultPaymentProfileForContact */
  defaultPaymentProfile?: Maybe<PaymentProfile_Old>;
  /** Retrieves the default payment profile for the authenticated member. */
  defaultPaymentProfileForContact: DefaultPaymentProfileResult;
  donations?: Maybe<Array<Maybe<FoundationType>>>;
  event?: Maybe<CampaignType>;
  events?: Maybe<Array<Maybe<CampaignType>>>;
  f2FCasesByContactId?: Maybe<Array<Maybe<F2FCaseType>>>;
  faq?: Maybe<FaqType>;
  faqs?: Maybe<Array<Maybe<FaqType>>>;
  /** Retrieves feature flags for a user by their Connect user ID. */
  featureFlagByConnectUserId: FeatureFlagByConnectUserIdResult;
  /** Retrieves feature flags for a user by their Salesforce contact ID. */
  featureFlagByContactId: FeatureFlagByContactIdResult;
  /** @deprecated use featureFlagByContactId */
  flagsByContactId?: Maybe<FeatureFlags>;
  /** @deprecated use featureFlagByConnectUserId */
  flagsByUserId?: Maybe<FeatureFlags>;
  /** @deprecated use myMailboxId */
  getMailboxId: Scalars['Int']['output'];
  /** Retrieves the PDM (Physician Data Manager) user associated with the given account ID. */
  getPDMByAccountId?: Maybe<User>;
  initiatives?: Maybe<Array<Maybe<InitiativesType>>>;
  /** @deprecated use mailboxById */
  mailbox: MailboxType;
  /** Retrieves a mailbox by its unique identifier. */
  mailboxById: MailboxByIdResult;
  /** Retrieves mailbox metadata counts by mailbox ID. */
  mailboxMetadataById: MailboxMetadataByIdResult;
  /** Retrieves the MDVIP user profile by the provided input criteria. */
  mdvipUserProfile: MdvipUserProfileResult;
  /** @deprecated use memberByContactId */
  member?: Maybe<MemberType>;
  /** Returns the existing member by ContactId */
  memberByContactId: MemberByContactIdResult;
  /** Retrieves to-do notifications for a member by contact ID. */
  memberToDoNotifications: MemberToDoNotificationsResult;
  /** @deprecated use membersByAccountId */
  members?: Maybe<Array<Maybe<MemberType>>>;
  /** Returns all the existing members by AccountId with filters applied */
  membersByAccountId: MembersByAccountIdResult;
  /** Retrieves a message thread by its thread and mailbox IDs. */
  messageThreadById: MessageThreadByIdResult;
  /** Retrieves message threads by mailbox ID with optional filtering and pagination. */
  messageThreadsByMailboxId: MessageThreadsByMailboxIdResult;
  /** @deprecated this service will be deleted because it doesn't exist in Secure Messaging backend */
  messageUser: MessageUserType;
  /** @deprecated use messagesByMailboxThread */
  messages?: Maybe<Array<Maybe<MessageType>>>;
  /** Retrieves messages by mailbox and thread IDs. */
  messagesByMailboxThread: MessagesByMailboxThreadResult;
  /** @deprecated Use messagingContactsByContactId */
  messagingContactListForAffiliate?: Maybe<Array<Maybe<ContactListMember>>>;
  /** @deprecated Use messagingContactsByContactId */
  messagingContactListForMembers?: Maybe<Array<Maybe<ContactListMember>>>;
  /** @deprecated Use messagingContactsByContactId */
  messagingContactListOfficeStaff?: Maybe<Array<Maybe<ContactListMember>>>;
  /**
   * Returns all messaging contacts by ContactId and Type
   * @deprecated use messagingContactsForAffiliate or messagingContactsForAffiliate or messagingContactsForMember
   */
  messagingContactsByContactId: MessagingContactsByContactIdResult;
  /**
   * Returns the list of members and practice staff
   * who have active user record and access to SecureMessaging
   * of the affiliates in the same practice.
   */
  messagingContactsForAffiliate: MessagingContactsListResult;
  /**
   * Returns physician and the list of practice staff of affiliate
   * who have active user record and access to SecureMessaging
   * in the practice of the affiliate.
   */
  messagingContactsForEmployee: MessagingContactsListResult;
  /**
   * Returns the list of practice staff and affiliate
   * who have active user record and access to SecureMessaging
   * related to affiliate.
   */
  messagingContactsForMember: MessagingContactsListResult;
  /**
   * Returns the list of affiliates
   * who have active user record and access to SecureMesssaging
   * excluding the physician calling the api.
   */
  messagingContactsForPhysician: MessagingContactsListResult;
  /**
   * Returns the list of member, practice staff and affiliate
   * who have active user record and access to SecureMessaging
   * in the practice of the affiliate.
   */
  messagingContactsForStaff: MessagingContactsListResult;
  /** Retrieves the authenticated user's mailbox ID by name and email. */
  myMailboxId: MyMailboxIdResult;
  /**
   * Retrieves the next payment due for a given member.
   * MemberId is the MDVIPID of the member.
   */
  nextPaymentDue: NextPaymentDueResponse;
  /** Retrieves patient activity report by AccountId and date range. */
  patientActivityReport: PatientActivityReportResult;
  /** Retrieves patient case report by AccountId. */
  patientCaseReport: PatientCaseReportResult;
  /** Retrieves patient directory report queries by report category. */
  patientDirectoryReport: PatientDirectoryReportQuery;
  /** Retrieves a patient account invoice receipt by its document ID. */
  patientReceiptByDocumentId: PatientReceiptByDocumentIdResult;
  /** @deprecated use paymentById */
  payment?: Maybe<Payment_Old>;
  /** Retrieves a single payment record by its Salesforce ID. */
  paymentById: PaymentByIdResult;
  /** Retrieves payment preference settings including Litle gateway configuration. */
  paymentPreferences: PaymentPreferencesQuery;
  /** @deprecated use paymentProfileById */
  paymentProfile?: Maybe<PaymentProfile_Old>;
  /** Retrieves a payment profile by its Salesforce ID. */
  paymentProfileById: PaymentProfileByIdResult;
  /** @deprecated use paymentProfilesList */
  paymentProfiles?: Maybe<Array<Maybe<PaymentProfile_Old>>>;
  /** Retrieves a paginated list of payment profiles for the authenticated member. */
  paymentProfilesList: PaymentProfilesResult;
  /** @deprecated use litleErrorByCode, litleSettings or maximumPaymentAmount */
  paymentSettings?: Maybe<PaymentSettingsType>;
  /** @deprecated use paymentsList */
  payments?: Maybe<Array<Maybe<Payment_Old>>>;
  /** Retrieves a paginated list of payments for the authenticated member. */
  paymentsList: PaymentsResult;
  /** @deprecated Use 'accountById' or 'physicianByContactId' */
  physician?: Maybe<PhysicianType>;
  physicianAccounts?: Maybe<Array<Maybe<AccountType>>>;
  /**
   * Physician by AccountId field
   * TODO: Verify @authorization directive with consumers
   */
  physicianByAccountId: PhysicianByAccountIdResult;
  /**
   * Physician by ContactId field
   * TODO: Verify @authorization directive with consumers
   */
  physicianByContactId: PhysicianByContactIdResult;
  /** Get Physician Practice Staff by contactId */
  physicianPracticeStaffByContactId: PhysicianPracticeStaffByContactIdResult;
  /** Get all Physician Practice Staffs */
  physicianPracticeStaffs: PhysicianPracticeStaffsResult;
  /** @deprecated Use 'allAccounts' */
  physicians?: Maybe<Array<Maybe<PhysicianType>>>;
  /** @deprecated use practiceReportByFilePath */
  practiceReport?: Maybe<ReportPracticeType>;
  /** Retrieves the content of a specific practice report by its file path. */
  practiceReportByFilePath: PracticeReportByFilePathResult;
  /** @deprecated use prospectByContactId */
  prospect?: Maybe<ProspectType>;
  /** Propsect by Id field */
  prospectByContactId: ProspectByContactIdResult;
  /** @deprecated use prospectsByAccountId */
  prospects?: Maybe<Array<Maybe<ProspectType>>>;
  /** Prospects by AccountId field */
  prospectsByAccountId: ProspectsByAccountIdResult;
  recipe?: Maybe<RecipeType>;
  recipeList?: Maybe<RecipeListType>;
  reciprocityVisit?: Maybe<ReciprocityVisitType>;
  reciprocityVisits?: Maybe<Array<Maybe<ReciprocityVisitType>>>;
  /** Retrieves all referral facilities associated with the given account. */
  referralFacilities: ReferralFacilitiesResult;
  referrals?: Maybe<Array<Maybe<ReferralType>>>;
  /** Returns contact and account data needed for the Payment Information page */
  reinstatementContactInformation: ReinstatementContactInformationResult;
  /** Returns reinstatement eligibility for a member */
  reinstatementEligibility: ReinstatementEligibilityResult;
  /**
   * Returns the current status of a reinstatement workflow.
   * Poll every 2-3 seconds until status is COMPLETED or FAILED.
   */
  reinstatementStatus: ReinstatementStatus;
  /** @deprecated use allPracticeReport */
  reportList?: Maybe<Array<Maybe<ReportList>>>;
  /**
   * Get an individual Staff by ID.
   * @deprecated use physicianPracticeStaffByContactId
   */
  staff?: Maybe<StaffType>;
  /**
   * Get all Staff.
   * @deprecated use physicianPracticeStaffs
   */
  staffs?: Maybe<Array<Maybe<StaffType>>>;
  /** @deprecated use messageThreadById */
  thread?: Maybe<ThreadType>;
  /** @deprecated use messageThreadsByMailboxId */
  threads?: Maybe<Array<Maybe<ThreadType>>>;
  /** Retrieves to-do notifications for a physician or practice staff by account. */
  todoNotifications: ToDoNotificationsResult;
  /** @deprecated use upcomingPaymentById */
  upcomingPayment?: Maybe<Payment_Old>;
  /** Retrieves a single upcoming payment record by its Salesforce ID. */
  upcomingPaymentById: UpcomingPaymentByIdResult;
  /** @deprecated use upcomingPaymentsList */
  upcomingPayments?: Maybe<Array<Maybe<Payment_Old>>>;
  /** Retrieves a paginated list of upcoming payments for the authenticated member. */
  upcomingPaymentsList: UpcomingPaymentsResult;
  waitlist?: Maybe<Array<Maybe<CaseType>>>;
};


export type QueryAwpByAccountIdArgs = {
  input: AwpByAccountIdInput;
};


export type QueryAwpByIdArgs = {
  PHR_ID: Scalars['String']['input'];
};


export type QueryAccountArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountByIdArgs = {
  Id: Scalars['String']['input'];
};


export type QueryActiveMembersArgs = {
  AccountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActivePaymentProfilesArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActivityReportArgs = {
  input?: InputMaybe<ActivityReportInput>;
};


export type QueryAffiliateDetailsArgs = {
  AccountID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAffiliateMembersArgs = {
  AccountID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAffiliateMessagingContactListArgs = {
  ContactID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAccountsArgs = {
  input: AccountsInput;
};


export type QueryAllPhysiciansArgs = {
  input: PhysiciansInput;
};


export type QueryAllPracticeReportArgs = {
  physicianId: Scalars['String']['input'];
};


export type QueryAnnouncementArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnnouncementsArgs = {
  type?: InputMaybe<Scalars['AnnouncementTypeScalar']['input']>;
};


export type QueryAttachmentByIdArgs = {
  input?: InputMaybe<AttachmentsByIdInput>;
};


export type QueryAttachmentDataByIdArgs = {
  input: AttachmentDataByIdInput;
};


export type QueryAttachmentsByMessageIdArgs = {
  input?: InputMaybe<AttachmentsByMessageIdInput>;
};


export type QueryAwpByPhrIdArgs = {
  phrId: Scalars['ID']['input'];
};


export type QueryByPhysicianIdArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignMembersArgs = {
  AccountId?: InputMaybe<Scalars['String']['input']>;
  CampaignId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaseArgs = {
  Id: Scalars['String']['input'];
};


export type QueryCaseReportArgs = {
  Id: Scalars['String']['input'];
};


export type QueryDonationsArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEventsArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  filterStr?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryF2FCasesByContactIdArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryFaqArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFaqsArgs = {
  category?: InputMaybe<Scalars['CategoryScalar']['input']>;
};


export type QueryFeatureFlagByConnectUserIdArgs = {
  connectUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFeatureFlagByContactIdArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFlagsByContactIdArgs = {
  contactId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFlagsByUserIdArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPdmByAccountIdArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryInitiativesArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMailboxArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMailboxByIdArgs = {
  input: MailboxByIdInput;
};


export type QueryMailboxMetadataByIdArgs = {
  input: MailboxByIdInput;
};


export type QueryMdvipUserProfileArgs = {
  input: MdvipUserProfileInput;
};


export type QueryMemberArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMemberByContactIdArgs = {
  ContactId: Scalars['String']['input'];
};


export type QueryMemberToDoNotificationsArgs = {
  input: MemberToDoNotificationsInput;
};


export type QueryMembersArgs = {
  AccountId?: InputMaybe<Scalars['String']['input']>;
  Statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMembersByAccountIdArgs = {
  AccountId: Scalars['String']['input'];
  input: MembersByAccountIdInput;
};


export type QueryMessageThreadByIdArgs = {
  input: MessageThreadByIdInput;
};


export type QueryMessageThreadsByMailboxIdArgs = {
  input: MessageThreadsByMailboxIdInput;
};


export type QueryMessageUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessagesArgs = {
  input?: InputMaybe<MessagesInput>;
};


export type QueryMessagesByMailboxThreadArgs = {
  input: MessagesByMailboxThreadInput;
};


export type QueryMessagingContactListForAffiliateArgs = {
  ContactID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessagingContactListForMembersArgs = {
  ContactID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessagingContactListOfficeStaffArgs = {
  ContactID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessagingContactsByContactIdArgs = {
  ContactId: Scalars['String']['input'];
  Type: MessagingContactForType;
};


export type QueryMessagingContactsForAffiliateArgs = {
  input: MessagingContactsForAffiliateInput;
};


export type QueryMessagingContactsForEmployeeArgs = {
  input: MessagingContactsForEmployeeInput;
};


export type QueryMessagingContactsForMemberArgs = {
  input: MessagingContactsForMemberInput;
};


export type QueryMessagingContactsForPhysicianArgs = {
  input: MessagingContactsForPhysicianInput;
};


export type QueryMessagingContactsForStaffArgs = {
  input: MessagingContactsForStaffInput;
};


export type QueryMyMailboxIdArgs = {
  input?: InputMaybe<MyMailboxIdInput>;
};


export type QueryNextPaymentDueArgs = {
  memberId: Scalars['String']['input'];
};


export type QueryPatientActivityReportArgs = {
  input: PatientActivityReportInput;
};


export type QueryPatientCaseReportArgs = {
  AccountId: Scalars['String']['input'];
};


export type QueryPatientReceiptByDocumentIdArgs = {
  input: PatientReceiptByDocumentIdInput;
};


export type QueryPaymentArgs = {
  Id: Scalars['String']['input'];
};


export type QueryPaymentByIdArgs = {
  Id: Scalars['ID']['input'];
};


export type QueryPaymentProfileArgs = {
  Id: Scalars['ID']['input'];
};


export type QueryPaymentProfileByIdArgs = {
  Id: Scalars['ID']['input'];
};


export type QueryPaymentProfilesArgs = {
  mdvipId: Scalars['ID']['input'];
};


export type QueryPaymentProfilesListArgs = {
  input: PaymentProfilesInput;
};


export type QueryPaymentSettingsArgs = {
  input?: InputMaybe<PaymentSettingsInput>;
};


export type QueryPaymentsListArgs = {
  input: PaymentsInput;
};


export type QueryPhysicianArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPhysicianByAccountIdArgs = {
  AccountId: Scalars['String']['input'];
};


export type QueryPhysicianByContactIdArgs = {
  ContactId: Scalars['String']['input'];
};


export type QueryPhysicianPracticeStaffByContactIdArgs = {
  ContactId: Scalars['String']['input'];
};


export type QueryPhysicianPracticeStaffsArgs = {
  input: PhysicianPracticeStaffsInput;
};


export type QueryPracticeReportArgs = {
  filepath: Scalars['String']['input'];
};


export type QueryPracticeReportByFilePathArgs = {
  filepath: Scalars['String']['input'];
};


export type QueryProspectArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProspectByContactIdArgs = {
  ContactId: Scalars['ID']['input'];
};


export type QueryProspectsArgs = {
  AccountId: Scalars['String']['input'];
};


export type QueryProspectsByAccountIdArgs = {
  AccountId: Scalars['String']['input'];
  input: ProspectsByAccountIdInput;
};


export type QueryRecipeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecipeListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReciprocityVisitArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReciprocityVisitsArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferralFacilitiesArgs = {
  input: ReferralFacilitiesInput;
};


export type QueryReferralsArgs = {
  input?: InputMaybe<ReferralInput>;
};


export type QueryReinstatementStatusArgs = {
  workflowId: Scalars['String']['input'];
};


export type QueryReportListArgs = {
  physicianId: Scalars['String']['input'];
};


export type QueryStaffArgs = {
  Id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStaffsArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryThreadArgs = {
  mailboxId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};


export type QueryThreadsArgs = {
  input?: InputMaybe<GetAllThreadsInput>;
};


export type QueryTodoNotificationsArgs = {
  input: TodoNotificationsInput;
};


export type QueryUpcomingPaymentArgs = {
  Id: Scalars['String']['input'];
};


export type QueryUpcomingPaymentByIdArgs = {
  Id: Scalars['ID']['input'];
};


export type QueryUpcomingPaymentsListArgs = {
  input: UpcomingPaymentsInput;
};


export type QueryWaitlistArgs = {
  accountId: Scalars['String']['input'];
};

export type RecipeListType = {
  __typename?: 'RecipeListType';
  count?: Maybe<Scalars['Int']['output']>;
  recipes?: Maybe<Array<Maybe<RecipeType>>>;
};

export type RecipeType = {
  __typename?: 'RecipeType';
  field_dietary_restrictions?: Maybe<Array<Maybe<Scalars['RecipeCategory']['output']>>>;
  field_health_diet_considerations?: Maybe<Array<Maybe<Scalars['RecipeCategory']['output']>>>;
  field_main_ingredient?: Maybe<Array<Maybe<Scalars['RecipeCategory']['output']>>>;
  field_meal_course?: Maybe<Array<Maybe<Scalars['RecipeCategory']['output']>>>;
  field_preparation_technique?: Maybe<Array<Maybe<Scalars['RecipeCategory']['output']>>>;
  field_recipe_body?: Maybe<Scalars['String']['output']>;
  field_recipe_description_value?: Maybe<Scalars['String']['output']>;
  field_recipe_ingredients?: Maybe<Scalars['String']['output']>;
  field_recipe_nutrition?: Maybe<Scalars['String']['output']>;
  field_recipe_nutrition_bonus?: Maybe<Scalars['String']['output']>;
  field_recipe_prep_time?: Maybe<Scalars['String']['output']>;
  field_recipe_preparation?: Maybe<Scalars['String']['output']>;
  field_recipe_total_time?: Maybe<Scalars['String']['output']>;
  field_recipe_yield?: Maybe<Scalars['Int']['output']>;
  field_season_occasion?: Maybe<Array<Maybe<Scalars['RecipeCategory']['output']>>>;
  field_type_of_cuisine?: Maybe<Array<Maybe<Scalars['RecipeCategory']['output']>>>;
  field_type_of_dish?: Maybe<Array<Maybe<Scalars['RecipeCategory']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReciprocityVisitType = {
  __typename?: 'ReciprocityVisitType';
  Account__c?: Maybe<Scalars['String']['output']>;
  DOB_Provided__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Patient_First_Name__c?: Maybe<Scalars['String']['output']>;
  Patient_Home_Phone_Provided__c?: Maybe<Scalars['String']['output']>;
  Patient_Last_Name__c?: Maybe<Scalars['String']['output']>;
  Reason_for_Visit__c?: Maybe<Scalars['String']['output']>;
  Referring_Physician__r?: Maybe<ReferringPhysicianType>;
  Visit_Date__c?: Maybe<Scalars['String']['output']>;
  formattedDob?: Maybe<Scalars['String']['output']>;
  formattedVisitDate?: Maybe<Scalars['String']['output']>;
};

/** Input parameters for the referralFacilities query. */
export type ReferralFacilitiesInput = {
  /** Salesforce Account ID to retrieve referral facilities for. */
  AccountId: Scalars['String']['input'];
};

/** Represents the result of the referralFacilities query containing a list of facilities. */
export type ReferralFacilitiesResult = {
  __typename?: 'ReferralFacilitiesResult';
  /** List of referral facility records. */
  edges: Array<ReferralFacility>;
};

/** Represents a referral facility associated with a physician's account. */
export type ReferralFacility = {
  __typename?: 'ReferralFacility';
  /** Salesforce Account ID of the referral facility. */
  AccountId: Scalars['String']['output'];
  /** Display name of the referral facility account. */
  AccountName: Scalars['String']['output'];
};

export type ReferralInput = {
  AccountID?: InputMaybe<Scalars['String']['input']>;
};

export type ReferralType = {
  __typename?: 'ReferralType';
  AppointmentDate?: Maybe<Scalars['String']['output']>;
  ContactMobilePhone?: Maybe<Scalars['String']['output']>;
  ContactPhone?: Maybe<Scalars['String']['output']>;
  ContactSFID?: Maybe<Scalars['String']['output']>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  FacilityName?: Maybe<Scalars['String']['output']>;
  PatientName?: Maybe<Scalars['String']['output']>;
  ReferralSFId?: Maybe<Scalars['String']['output']>;
  ReferralSpecialty?: Maybe<Scalars['String']['output']>;
  SpecialistReferrals?: Maybe<Array<SpecialistReferralType>>;
  Status?: Maybe<Scalars['String']['output']>;
};

export type ReferringPhysicianInput = {
  Id?: InputMaybe<Scalars['String']['input']>;
};

export type ReferringPhysicianType = {
  __typename?: 'ReferringPhysicianType';
  Name?: Maybe<Scalars['String']['output']>;
};

export type ReinstateMemberError = {
  __typename?: 'ReinstateMemberError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type ReinstateMemberInput = {
  /** Whether to enable autopay for the reinstated membership. */
  autoPay: Scalars['Boolean']['input'];
  scheduleId: ReinstatementPaymentScheduleInput;
};

export type ReinstateMemberResponse = {
  __typename?: 'ReinstateMemberResponse';
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type ReinstateMemberResult = ReinstateMemberError | ReinstateMemberResponse;

export type ReinstatementActiveAgreement = {
  __typename?: 'ReinstatementActiveAgreement';
  agreementId: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
};

export type ReinstatementContactInformation = {
  __typename?: 'ReinstatementContactInformation';
  /** Account.Name from the Contact's Account record */
  Account_Name?: Maybe<Scalars['String']['output']>;
  /** Non-accepted payment plans from the Contact's Account record (multi-select picklist). */
  Account_Non_Accepted_Payment_Plans__c?: Maybe<Array<NonAcceptedPaymentPlan>>;
  /**
   * Date_Of_Birth__c from Contact record
   * Format: YYYY-MM-DD
   */
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  /** Email from Contact record */
  Email?: Maybe<Scalars['String']['output']>;
  /** FirstName from Contact record */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** LastName from Contact record */
  LastName?: Maybe<Scalars['String']['output']>;
  /** MDVIPID__c (Member ID) from Contact record */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /**
   * Manufacturer's Suggested Retail Price for the member's active Standard Membership agreement.
   * Null when no active agreement is found.
   */
  MSRP_Amount__c?: Maybe<Scalars['Float']['output']>;
  /**
   * MobilePhone from Contact record
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Salutation from Contact record */
  Salutation?: Maybe<Scalars['String']['output']>;
  /**
   * Agreement_Plan_ID__c from the active Agreement_Schedule__c record.
   * Used as agreementPlanId input for reinstateMember.
   */
  agreementPlanId?: Maybe<Scalars['Int']['output']>;
};

export type ReinstatementContactInformationDomainError = ReinstatementContactInformationNotFoundError;

/** A domain-specific failure to retrieve payment information contact data. */
export type ReinstatementContactInformationFailure = {
  __typename?: 'ReinstatementContactInformationFailure';
  /** All errors associated with retrieving payment information contact data. */
  errors: Array<ReinstatementContactInformationDomainError>;
};

export type ReinstatementContactInformationNotFoundError = DomainError & {
  __typename?: 'ReinstatementContactInformationNotFoundError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type ReinstatementContactInformationResult = ReinstatementContactInformation | ReinstatementContactInformationFailure;

export type ReinstatementEligibilityResult = ReinstatementActiveAgreement | ReinstatementEligible | ReinstatementIneligible | ReinstatementPending;

export type ReinstatementEligible = {
  __typename?: 'ReinstatementEligible';
  eligible: Scalars['Boolean']['output'];
};

export type ReinstatementIneligible = {
  __typename?: 'ReinstatementIneligible';
  eligible: Scalars['Boolean']['output'];
  reasonCode: Scalars['String']['output'];
};

/** Payment schedule options for reinstating a member's MDVIP membership. */
export enum ReinstatementPaymentScheduleInput {
  /** Single full payment. */
  FullPay = 'FULL_PAY',
  /** Quarterly payment schedule. */
  Quarterly = 'QUARTERLY',
  /** Semi-annual payment schedule. */
  SemiAnnual = 'SEMI_ANNUAL'
}

export type ReinstatementPending = {
  __typename?: 'ReinstatementPending';
  eligible: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type ReinstatementStatus = {
  __typename?: 'ReinstatementStatus';
  agreementId?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  completedSteps: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  currentStep?: Maybe<Scalars['String']['output']>;
  elapsedMs: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorStep?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['String']['output'];
  remainingSteps: Scalars['Int']['output'];
  status: ReinstatementWorkflowStatus;
  steps: Array<ReinstatementStatusStep>;
  totalSteps: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type ReinstatementStatusStep = {
  __typename?: 'ReinstatementStatusStep';
  attemptNumber: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stepName: Scalars['String']['output'];
};

export enum ReinstatementWorkflowStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type ReportActivityType = {
  __typename?: 'ReportActivityType';
  DOB?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MemberActivity?: Maybe<Array<Maybe<MemberActivityType>>>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  RecordTypeName?: Maybe<Scalars['String']['output']>;
};

export type ReportCaseType = {
  __typename?: 'ReportCaseType';
  ClosedDate?: Maybe<Scalars['String']['output']>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  DOB?: Maybe<Scalars['String']['output']>;
  DateOfFacetoFace?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  RecordTypeName?: Maybe<Scalars['String']['output']>;
  Result?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

export type ReportList = {
  __typename?: 'ReportList';
  Created?: Maybe<Scalars['String']['output']>;
  File_Name?: Maybe<Scalars['String']['output']>;
  File_Type?: Maybe<Scalars['String']['output']>;
  Path?: Maybe<Scalars['String']['output']>;
  Physician_ID?: Maybe<Scalars['String']['output']>;
};

export type ReportPracticeType = {
  __typename?: 'ReportPracticeType';
  PHR?: Maybe<Scalars['String']['output']>;
};

export enum RequestTypeEnum {
  LitleInterfaceDetails = 'LitleInterfaceDetails',
  MaximumPaymentAmount = 'MaximumPaymentAmount',
  ResponseCodeMessage = 'ResponseCodeMessage'
}

export type ResponseCodeMessageType = {
  __typename?: 'ResponseCodeMessageType';
  PortalReponseMessage__c?: Maybe<Scalars['String']['output']>;
};

export type SendDynamicEmailInput = {
  bccAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ccAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confEmail?: InputMaybe<Scalars['String']['input']>;
  confEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  confEmailHtmlBody?: InputMaybe<Scalars['String']['input']>;
  confEmailPlainTextBody?: InputMaybe<Scalars['String']['input']>;
  confEmailSubject?: InputMaybe<Scalars['String']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  htmlBody?: InputMaybe<Scalars['String']['input']>;
  plainTextBody?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toEmail?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Union of all domain errors that can occur when sending a payment receipt email. */
export type SendPaymentReceiptEmailByIdDomainError = SendPaymentReceiptEmailByIdFailedDomainError | SendPaymentReceiptEmailByIdNotFoundDomainError;

/** Domain error returned when sending a payment receipt email fails. */
export type SendPaymentReceiptEmailByIdFailedDomainError = {
  __typename?: 'SendPaymentReceiptEmailByIdFailedDomainError';
  /** The payment ID for which the email failed. */
  Id: Scalars['ID']['output'];
  /** The contact ID associated with the request. */
  contactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Encapsulates all domain errors for the sendPaymentReceiptEmailById operation. */
export type SendPaymentReceiptEmailByIdFailure = {
  __typename?: 'SendPaymentReceiptEmailByIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<SendPaymentReceiptEmailByIdDomainError>;
};

/** Domain error returned when a payment is not found when sending a receipt email. */
export type SendPaymentReceiptEmailByIdNotFoundDomainError = {
  __typename?: 'SendPaymentReceiptEmailByIdNotFoundDomainError';
  /** The payment ID that was not found. */
  Id: Scalars['ID']['output'];
  /** The contact ID associated with the request. */
  contactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for sendPaymentReceiptEmailById. Returns SendPaymentReceiptEmailByIdSuccess on success or SendPaymentReceiptEmailByIdFailure on failure. */
export type SendPaymentReceiptEmailByIdResult = SendPaymentReceiptEmailByIdFailure | SendPaymentReceiptEmailByIdSuccess;

/** Represents a successful payment receipt email send. */
export type SendPaymentReceiptEmailByIdSuccess = {
  __typename?: 'SendPaymentReceiptEmailByIdSuccess';
  /** Salesforce record ID of the payment. */
  Id: Scalars['ID']['output'];
  /** Email address the receipt was sent to. */
  email: Scalars['String']['output'];
};

/** Union of all domain errors that can occur when setting a default payment profile. */
export type SetDefaultPaymentProfileDomainError = SetDefaultPaymentProfileNotFoundDomainError;

/** Encapsulates all domain errors for the setDefaultPaymentProfile operation. */
export type SetDefaultPaymentProfileFailure = {
  __typename?: 'SetDefaultPaymentProfileFailure';
  /** List of domain errors that occurred. */
  errors: Array<SetDefaultPaymentProfileDomainError>;
};

/** Domain error returned when a payment profile is not found when setting as default. */
export type SetDefaultPaymentProfileNotFoundDomainError = {
  __typename?: 'SetDefaultPaymentProfileNotFoundDomainError';
  /** The payment profile ID that was not found. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for setDefaultPaymentProfile. Returns PaymentProfile on success or SetDefaultPaymentProfileFailure on failure. */
export type SetDefaultPaymentProfileResult = PaymentProfile | SetDefaultPaymentProfileFailure;

/** Domain error returned when the contact is not found during mailbox setup. */
export type SetupMyMailboxContactNotFoundError = DomainError & {
  __typename?: 'SetupMyMailboxContactNotFoundError';
  /** The contact ID that was not found. */
  ContactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Union of all domain errors that can occur when setting up a mailbox. */
export type SetupMyMailboxDomainError = SetupMyMailboxContactNotFoundError | SetupMyMailboxMailboxNotFoundError;

/** Encapsulates all domain errors for the setupMyMailbox operation. */
export type SetupMyMailboxFailure = {
  __typename?: 'SetupMyMailboxFailure';
  /** List of domain errors that occurred during mailbox setup. */
  errors: Array<SetupMyMailboxDomainError>;
};

/** Domain error returned when the mailbox is not found during mailbox setup. */
export type SetupMyMailboxMailboxNotFoundError = DomainError & {
  __typename?: 'SetupMyMailboxMailboxNotFoundError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for setupMyMailbox. Returns SetupMyMailboxSuccess on success or SetupMyMailboxFailure on failure. */
export type SetupMyMailboxResult = SetupMyMailboxFailure | SetupMyMailboxSuccess;

/** Represents a successful mailbox setup for the authenticated user. */
export type SetupMyMailboxSuccess = {
  __typename?: 'SetupMyMailboxSuccess';
  /** Unique identifier of the newly set up mailbox. */
  mailboxId: Scalars['ID']['output'];
};

export type SpecialistReferralInput = {
  Diagnosis__c?: InputMaybe<Scalars['String']['input']>;
  ICD10__c?: InputMaybe<Scalars['String']['input']>;
  Notes__c?: InputMaybe<Scalars['String']['input']>;
  Physician_Requested__c?: InputMaybe<Scalars['String']['input']>;
  Specialty__c?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialistReferralType = {
  __typename?: 'SpecialistReferralType';
  AppointmentDate?: Maybe<Scalars['String']['output']>;
  AppointmentTime?: Maybe<Scalars['String']['output']>;
  SpecialistName?: Maybe<Scalars['String']['output']>;
  SpecialistPhone?: Maybe<Scalars['String']['output']>;
  SpecialistReferralSFId?: Maybe<Scalars['String']['output']>;
  SpecialistWebsite?: Maybe<Scalars['String']['output']>;
  Specialty?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

export type StaffDataTypeInput = {
  Connect_User_Status__c?: InputMaybe<Scalars['Boolean']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  MDVIP_Connect_User__c?: InputMaybe<Scalars['Boolean']['input']>;
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  Phone?: InputMaybe<Scalars['String']['input']>;
  Salutation?: InputMaybe<Scalars['String']['input']>;
};

export type StaffType = ContactType & {
  __typename?: 'StaffType';
  AccountId: Scalars['String']['output'];
  Connect_User_Status__c?: Maybe<Scalars['Boolean']['output']>;
  Date_Of_Birth__c?: Maybe<Scalars['String']['output']>;
  Disposition_Code__c?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Emergency_Phone__c?: Maybe<Scalars['String']['output']>;
  Estimated_Paid_Through__c?: Maybe<Scalars['String']['output']>;
  Fax?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Gender__c?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  IsActive?: Maybe<Scalars['Boolean']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Last_App_Login__c?: Maybe<Scalars['String']['output']>;
  MDVIP_Connect_User__c?: Maybe<Scalars['Boolean']['output']>;
  MailingCity?: Maybe<Scalars['String']['output']>;
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  MailingState?: Maybe<Scalars['String']['output']>;
  MailingStreet?: Maybe<Scalars['String']['output']>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingCity */
  Primary_City__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingState */
  Primary_State__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingStreet */
  Primary_Street_Address__c?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MailingPostalCode */
  Primary_Zip_Postal_Code__c?: Maybe<Scalars['String']['output']>;
  Salutation?: Maybe<Scalars['String']['output']>;
  USLocalizedDateOfBirth?: Maybe<Scalars['String']['output']>;
  UserNameNotQualified__c?: Maybe<Scalars['String']['output']>;
  /** The Staff's corresponding Physician. */
  physician: PhysicianType;
  /** The ID of the Staff's corresponding Physician. */
  physicianId: Scalars['ID']['output'];
};

export type StateResponse = {
  __typename?: 'StateResponse';
  state?: Maybe<Scalars['String']['output']>;
};

export type SubmitReferralInput = {
  MCReferral?: InputMaybe<McReferralInput>;
  SpecialistReferral?: InputMaybe<Array<InputMaybe<SpecialistReferralInput>>>;
};

export type ThreadType = {
  __typename?: 'ThreadType';
  allowReply?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  broadcast?: Maybe<Scalars['Boolean']['output']>;
  hasAttachment?: Maybe<Scalars['Boolean']['output']>;
  hasDraft?: Maybe<Scalars['Boolean']['output']>;
  hasUnread?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  messages?: Maybe<Array<Maybe<MessageType>>>;
  name?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  starred?: Maybe<Scalars['Boolean']['output']>;
  updatedTimestamp?: Maybe<Scalars['String']['output']>;
};

/** Represents a single to-do notification with its count and display metadata. */
export type ToDoNotification = {
  __typename?: 'ToDoNotification';
  /** Number of items in this notification category. */
  count: Scalars['Int']['output'];
  /** Unique key identifying the notification category. */
  key: Scalars['ID']['output'];
  /** Display metadata for the notification. */
  metadata: ToDoNotificationMetadata;
};

/** Represents display metadata for a to-do notification item. */
export type ToDoNotificationMetadata = {
  __typename?: 'ToDoNotificationMetadata';
  /** Color code used for rendering the notification badge. */
  color: Scalars['String']['output'];
  /** Display label for the notification. */
  label: Scalars['String']['output'];
};

/** Represents the result of the todoNotifications query containing a list of notifications. */
export type ToDoNotificationsResult = {
  __typename?: 'ToDoNotificationsResult';
  /** List of to-do notification items. */
  edges: Array<ToDoNotification>;
};

/** Input parameters for the todoNotifications query. */
export type TodoNotificationsInput = {
  /** Salesforce Account ID for the physician's practice. */
  AccountId: Scalars['String']['input'];
  /** Salesforce Contact ID to filter notifications for a specific contact. */
  ContactId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Supported Keys:
   * - newMembers
   * - cancelledMembers
   * - reinstatedMembers
   * - futureCancellations
   * - recommendedOutreach
   * - pendingWellnessExams
   */
  keys?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Defines the types of payment transactions. */
export enum TransactionType {
  /** Credit memo applied to the account */
  CreditMemo = 'Credit_Memo',
  /** Standard payment transaction */
  Payment = 'Payment',
  /** Reversal of a previous payment */
  PaymentReversal = 'Payment_Reversal',
  /** Refund issued to the member */
  Refund = 'Refund'
}

/** Union of all domain errors that can occur when transferring a prospect to MDVIP. */
export type TransferProspectToMdvipDomainError = TransferProspectToMdvipInvalidDataError;

/** Encapsulates all domain errors for the transferProspectToMDVIP operation. */
export type TransferProspectToMdvipFailure = {
  __typename?: 'TransferProspectToMDVIPFailure';
  /** All errors associated while transferring a prospect to MDVIP. */
  errors: Array<TransferProspectToMdvipDomainError>;
};

/** Input parameters for the transferProspectToMDVIP mutation. */
export type TransferProspectToMdvipInput = {
  /** AccountID of prospect */
  AccountID: Scalars['String']['input'];
  /** ContactID of prospect */
  ContactID: Scalars['String']['input'];
  /** Date of face to face appointment - Should follow 'MM/DD/YYYY' format */
  DateofFaceofFace?: InputMaybe<Scalars['String']['input']>;
  /** MeetingTime of prospect case */
  MeetingTime?: InputMaybe<Scalars['String']['input']>;
  /** PhysicianName of prospect */
  PhysicianName: Scalars['String']['input'];
  /** ProfileName of prospect */
  ProfileName: Scalars['String']['input'];
  /** Result of prospect case */
  Result?: InputMaybe<Scalars['String']['input']>;
  /** Status of prospect case */
  Status?: InputMaybe<ProspectF2FCaseStatus>;
  /** UserName of prospect */
  UserName: Scalars['String']['input'];
};

/** Domain error returned when the input data for transferring a prospect to MDVIP is invalid. */
export type TransferProspectToMdvipInvalidDataError = DomainError & {
  __typename?: 'TransferProspectToMDVIPInvalidDataError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for transferProspectToMDVIP. Returns TransferProspectToMDVIPSuccess on success or TransferProspectToMDVIPFailure on failure. */
export type TransferProspectToMdvipResult = TransferProspectToMdvipFailure | TransferProspectToMdvipSuccess;

/** Represents a successful prospect transfer to MDVIP. */
export type TransferProspectToMdvipSuccess = {
  __typename?: 'TransferProspectToMDVIPSuccess';
  /** Success status of transfer result */
  status?: Maybe<TransferProspectToMdvipSuccessStatus>;
};

/** Defines the success status values for transferring a prospect to MDVIP. */
export enum TransferProspectToMdvipSuccessStatus {
  /** Means that Prospect has been successfully transferred to MDVIP */
  Success = 'SUCCESS'
}

export type TransferToMdvipInput = {
  AccountID?: InputMaybe<Scalars['String']['input']>;
  CaseID?: InputMaybe<Scalars['String']['input']>;
  ContactID?: InputMaybe<Scalars['String']['input']>;
  DateofFaceofFace?: InputMaybe<Scalars['String']['input']>;
  MeetingTime?: InputMaybe<Scalars['String']['input']>;
  PhysicianName?: InputMaybe<Scalars['String']['input']>;
  ProfileName?: InputMaybe<Scalars['String']['input']>;
  Result?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<ManageProspectCaseEnum>;
  UserName?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a scheduled or processed upcoming payment record from Salesforce. */
export type UpcomingPayment = {
  __typename?: 'UpcomingPayment';
  /** Payment amount in dollars (Amount__c custom field). */
  Amount__c?: Maybe<Scalars['Float']['output']>;
  /** Date the payment was processed (Date_Processed__c custom field). */
  Date_Processed__c?: Maybe<Scalars['String']['output']>;
  /** Salesforce record ID of the upcoming payment. */
  Id: Scalars['ID']['output'];
  /** MDVIP member ID (MDVIPID__c custom field). */
  MDVIPID__c?: Maybe<Scalars['String']['output']>;
  /** Display name of the upcoming payment record. */
  Name?: Maybe<Scalars['String']['output']>;
  /** Salesforce Payment Profile ID (Payment_Profile__c custom field). */
  Payment_Profile__c?: Maybe<Scalars['String']['output']>;
  /** Reference to the associated payment profile entity. */
  Payment_Profile__r?: Maybe<PaymentProfile>;
  /** Payment method type description. */
  Payment_Type__c?: Maybe<Scalars['String']['output']>;
  /** Refund amount in dollars if applicable (Refund_Amount__c custom field). */
  Refund_Amount__c?: Maybe<Scalars['Float']['output']>;
  /** Current refund status if applicable. */
  Refund_Status__c?: Maybe<UpcomingPaymentRefundStatus>;
  /** Scheduled date for the payment (Schedule_Date__c custom field). */
  Schedule_Date__c?: Maybe<Scalars['String']['output']>;
  /** Current status of the upcoming payment. */
  Status__c?: Maybe<UpcomingPaymentStatus>;
};

/** Union of all domain errors that can occur when retrieving an upcoming payment by ID. */
export type UpcomingPaymentByIdDomainError = UpcomingPaymentByIdNotFoundDomainError;

/** Encapsulates all domain errors for the upcomingPaymentById operation. */
export type UpcomingPaymentByIdFailure = {
  __typename?: 'UpcomingPaymentByIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<UpcomingPaymentByIdDomainError>;
};

/** Domain error returned when an upcoming payment record is not found by the given ID. */
export type UpcomingPaymentByIdNotFoundDomainError = {
  __typename?: 'UpcomingPaymentByIdNotFoundDomainError';
  /** The upcoming payment ID that was not found. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for upcomingPaymentById. Returns UpcomingPayment on success or UpcomingPaymentByIdFailure on failure. */
export type UpcomingPaymentByIdResult = UpcomingPayment | UpcomingPaymentByIdFailure;

/** Defines the possible refund statuses for an upcoming payment. */
export enum UpcomingPaymentRefundStatus {
  /** Refund has been cleared. */
  Cleared = 'Cleared',
  /** Refund is outstanding and not yet processed. */
  Outstanding = 'Outstanding',
  /** Refund is currently processing. */
  Processing = 'Processing',
  /** Refund has been voided. */
  Void = 'Void'
}

/** Defines the possible statuses for an upcoming payment record. */
export enum UpcomingPaymentStatus {
  /** Canceled */
  Canceled = 'Canceled',
  /** Cancelled */
  Cancelled = 'Cancelled',
  /** ERROR! */
  Error = 'Error',
  /** Future Scheduled One Time Payment */
  FutureScheduledOneTimePayment = 'Future_Scheduled_One_Time_Payment',
  /** Processed - Charge Rejected */
  ProcessedChargeRejected = 'Processed_Charge_Rejected',
  /** Processed - Credit Card Declined */
  ProcessedCreditCardDeclined = 'Processed_Credit_Card_Declined',
  /** Processed - Successful */
  ProcessedSuccessful = 'Processed_Successful',
  /** Rescheduled - Charge Rejected */
  RescheduledChargeRejected = 'Rescheduled_Charge_Rejected',
  /** Set to be Processed */
  SetToBeProcessed = 'Set_To_Be_Processed'
}

/** Defines the allowed statuses when updating an upcoming payment. */
export enum UpcomingPaymentStatusForUpdate {
  /** Canceled */
  Canceled = 'Canceled',
  /** Set to be Processed */
  SetToBeProcessed = 'Set_To_Be_Processed'
}

/** Input parameters for the upcomingPaymentsList query. */
export type UpcomingPaymentsInput = {
  /** Maximum number of records to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records to skip for pagination. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the paginated result of the upcomingPaymentsList query. */
export type UpcomingPaymentsResult = {
  __typename?: 'UpcomingPaymentsResult';
  /** List of upcoming payment records. */
  edges: Array<UpcomingPayment>;
  /** Current pagination limit. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Current pagination offset. */
  offset?: Maybe<Scalars['Int']['output']>;
};

/** Input parameters for the deprecated updateAWP mutation. */
export type UpdateAwpInput = {
  /** Formatted exam date string. */
  Date_of_Physical?: InputMaybe<Scalars['String']['input']>;
  /** MPower ID for the AWP record. */
  MPower_ID?: InputMaybe<Scalars['String']['input']>;
  /** MDVIP member ID. */
  Member_ID?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded PHR file content (null if unchanged). */
  PHR?: InputMaybe<Scalars['String']['input']>;
  /** Personal Health Record ID. */
  PHR_ID?: InputMaybe<Scalars['String']['input']>;
  /** PHR upload status. */
  PHR_Status?: InputMaybe<Scalars['String']['input']>;
  /** Physician ID. */
  Physician_ID?: InputMaybe<Scalars['String']['input']>;
  /** Reason for rejection when status is Rejected. */
  Rejected_Reason?: InputMaybe<Scalars['String']['input']>;
  /** Username of the user updating the AWP. */
  User?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the response from the deprecated updateAWP mutation. */
export type UpdateAwpResponse = {
  __typename?: 'UpdateAWPResponse';
  /** Result state of the update operation. */
  state?: Maybe<Scalars['String']['output']>;
};

export type UpdateAccountInput = {
  AccountID?: InputMaybe<Scalars['String']['input']>;
  Friday_End_Time__c?: InputMaybe<Scalars['String']['input']>;
  Friday_Start_Time__c?: InputMaybe<Scalars['String']['input']>;
  Monday_End_Time__c?: InputMaybe<Scalars['String']['input']>;
  Monday_Start_Time__c?: InputMaybe<Scalars['String']['input']>;
  Saturday_End_Time__c?: InputMaybe<Scalars['String']['input']>;
  Saturday_Start_Time__c?: InputMaybe<Scalars['String']['input']>;
  Sunday_End_Time__c?: InputMaybe<Scalars['String']['input']>;
  Sunday_Start_Time__c?: InputMaybe<Scalars['String']['input']>;
  Thursday_End_Time__c?: InputMaybe<Scalars['String']['input']>;
  Thursday_Start_Time__c?: InputMaybe<Scalars['String']['input']>;
  Tuesday_End_Time__c?: InputMaybe<Scalars['String']['input']>;
  Tuesday_Start_Time__c?: InputMaybe<Scalars['String']['input']>;
  Wednesday_End_Time__c?: InputMaybe<Scalars['String']['input']>;
  Wednesday_Start_Time__c?: InputMaybe<Scalars['String']['input']>;
};

/** Union of all domain errors that can occur when updating an AWP by PHR ID. */
export type UpdateAwpByPhrIdDomainError = UpdateAwpByPhrIdFailedError | UpdateAwpByPhrIdFileNotFoundError;

/** Domain error returned when updating an AWP by PHR ID fails. */
export type UpdateAwpByPhrIdFailedError = DomainError & {
  __typename?: 'UpdateAwpByPhrIdFailedError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Encapsulates all domain errors for the updateAwpByPhrId operation. */
export type UpdateAwpByPhrIdFailure = {
  __typename?: 'UpdateAwpByPhrIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<UpdateAwpByPhrIdDomainError>;
};

/** Domain error returned when the AWP file is not found during update. */
export type UpdateAwpByPhrIdFileNotFoundError = DomainError & {
  __typename?: 'UpdateAwpByPhrIdFileNotFoundError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Input parameters for the updateAwpByPhrId mutation. */
export type UpdateAwpByPhrIdInput = {
  /** Display name of the person updating the AWP (typically the physician's full name). */
  createdByName: Scalars['String']['input'];
  /** Formatted exam date string - 08/10/2023 or 2023-08-10 */
  examDate: Scalars['String']['input'];
  /** Member MDVIP Id */
  memberMdvipId: Scalars['ID']['input'];
  /** Physician id */
  physicianId: Scalars['ID']['input'];
  /** Rejected reason - This should be provided when uploadStatus is "Rejected" */
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  /** PHR status or AWP upload status */
  uploadStatus: WellnessExamUploadStatus;
  /** Salesforce Wellness Exam ID of the AWP to update. */
  wellnessExamId: Scalars['ID']['input'];
};

/** Result type for updateAwpByPhrId. Returns UpdateAwpByPhrIdSuccess on success or UpdateAwpByPhrIdFailure on failure. */
export type UpdateAwpByPhrIdResponse = UpdateAwpByPhrIdFailure | UpdateAwpByPhrIdSuccess;

/** Represents a successful response from the updateAwpByPhrId mutation. */
export type UpdateAwpByPhrIdSuccess = {
  __typename?: 'UpdateAwpByPhrIdSuccess';
  /** MDVIP member ID associated with the updated AWP. */
  memberMdvipId: Scalars['ID']['output'];
  /** Personal Health Record ID of the updated AWP. */
  phrId: Scalars['ID']['output'];
  /** Salesforce Wellness Exam ID of the updated AWP. */
  wellnessExamId: Scalars['ID']['output'];
};

export type UpdateCampaignMemberInput = {
  CampaignId?: InputMaybe<Scalars['String']['input']>;
  ContactId?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInfoForReinstatementFailure = {
  __typename?: 'UpdateContactInfoForReinstatementFailure';
  errors: Array<DomainError>;
};

export type UpdateContactInfoForReinstatementInput = {
  Automated_Communication_Opt_In__c?: InputMaybe<Scalars['Boolean']['input']>;
  Autopay__c?: InputMaybe<Scalars['Boolean']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInfoForReinstatementResult = UpdateContactInfoForReinstatementFailure | UpdateContactInfoForReinstatementSuccess;

export type UpdateContactInfoForReinstatementSuccess = {
  __typename?: 'UpdateContactInfoForReinstatementSuccess';
  success: Scalars['Boolean']['output'];
};

export type UpdateContactOptInPreferencesFailure = {
  __typename?: 'UpdateContactOptInPreferencesFailure';
  errors: Array<DomainError>;
};

export type UpdateContactOptInPreferencesInput = {
  Automated_Communication_Opt_In__c?: InputMaybe<Scalars['Boolean']['input']>;
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactOptInPreferencesResult = UpdateContactOptInPreferencesFailure | UpdateContactOptInPreferencesSuccess;

export type UpdateContactOptInPreferencesSuccess = {
  __typename?: 'UpdateContactOptInPreferencesSuccess';
  success: Scalars['Boolean']['output'];
};

/** Union of all domain errors that can occur when updating a feature flag by ID. */
export type UpdateFeatureFlagByIdDomainError = UpdateFeatureFlagByIdNotFoundError | UpdateFeatureFlagByIdUnauthorizedError;

/** Encapsulates all domain errors for the updateFeatureFlagById operation. */
export type UpdateFeatureFlagByIdFailure = {
  __typename?: 'UpdateFeatureFlagByIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<UpdateFeatureFlagByIdDomainError>;
};

/** Input parameters for the updateFeatureFlagById mutation. */
export type UpdateFeatureFlagByIdInput = {
  /** Whether the AWP Audit feature is enabled. */
  AWPAudit__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the AWP Create feature is enabled. */
  AWPCreate__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the AWP Manage feature is enabled. */
  AWPManage__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the AWP Plus feature is enabled. */
  AWPPlus__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the AWP Read feature is enabled. */
  AWPRead__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the physician is accepting junior members. */
  AcceptingJuniorMembers__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Analytics Report feature is enabled. */
  AnalyticsReport__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Apparel and Merchandise feature is enabled. */
  ApparelandMerchandise__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Collateral and Stationery feature is enabled. */
  CollateralandStationary__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Events and Marketing Materials feature is enabled. */
  EventsandMarketingMaterials__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Financial Reports feature is enabled. */
  FinancialReports__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Foundation feature is enabled. */
  Foundation__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the MCE Referrals feature is enabled. */
  MCEReferrals__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the MDVIP Webmail feature is enabled. */
  MDVIPWebmail__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Manage CHL feature is enabled. */
  ManageCHL__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Manage Group Practice feature is enabled. */
  ManageGroupPractice__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Manage Office Hours feature is enabled. */
  ManageOfficeHours__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Manage Payments feature is enabled. */
  ManagePayments__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Manage Portal User feature is enabled. */
  ManagePortalUser__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Medical Resources feature is enabled. */
  MedicalResources__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Member Satisfaction feature is enabled. */
  MemberSatisfaction__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the My Events feature is enabled. */
  MyEvents__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the My Initiatives feature is enabled. */
  MyInitiatives__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the My Waiting List feature is enabled. */
  MyWaitinglist__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Notifications feature is enabled. */
  Notifications__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Office Depot / Office Max feature is enabled. */
  OfficeDepotOfficeMax__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Patients feature is enabled. */
  Patients__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Programs feature is enabled. */
  Programs__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Prospects feature is enabled. */
  Prospects__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Reciprocity Visit feature is enabled. */
  ReciprocityVisit__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Secure Messaging feature is enabled. */
  SecureMessaging__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Staples.com feature is enabled. */
  Staplesdotcom__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the To-Dos feature is enabled. */
  ToDos__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Value-Based Care feature is enabled. */
  ValueBasedCare__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Women's Health feature is enabled. */
  WomensHealth__c?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Domain error returned when a feature flag record is not found for the given ID during update. */
export type UpdateFeatureFlagByIdNotFoundError = DomainError & {
  __typename?: 'UpdateFeatureFlagByIdNotFoundError';
  /** The feature flag ID that was not found. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for updateFeatureFlagById. Returns FeatureFlag on success or UpdateFeatureFlagByIdFailure on failure. */
export type UpdateFeatureFlagByIdResult = FeatureFlag | UpdateFeatureFlagByIdFailure;

/** Domain error returned when the user is not authorized to update the feature flag. */
export type UpdateFeatureFlagByIdUnauthorizedError = DomainError & {
  __typename?: 'UpdateFeatureFlagByIdUnauthorizedError';
  /** The feature flag ID the user attempted to update. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type UpdateFeatureFlagsInput = {
  flags?: InputMaybe<PartialFeatureFlagsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Domain error returned when away status is enabled but the away message is missing. */
export type UpdateMailboxByIdAwayMessageMissingError = DomainError & {
  __typename?: 'UpdateMailboxByIdAwayMessageMissingError';
  /** The away message that was provided (null when missing). */
  awayMessage?: Maybe<Scalars['String']['output']>;
  /** The away status that was provided. */
  awayStatus: Scalars['Boolean']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Union of all domain errors that can occur when updating a mailbox by ID. */
export type UpdateMailboxByIdDomainError = UpdateMailboxByIdAwayMessageMissingError | UpdateMailboxByIdInvalidMailboxIdError | UpdateMailboxByIdNotFoundError;

/** Encapsulates all domain errors for the updateMailboxById operation. */
export type UpdateMailboxByIdFailure = {
  __typename?: 'UpdateMailboxByIdFailure';
  /** List of domain errors that occurred during mailbox update. */
  errors: Array<UpdateMailboxByIdDomainError>;
};

/** Input parameters for the updateMailboxById mutation. */
export type UpdateMailboxByIdInput = {
  /** Custom away message to display when away status is enabled. */
  awayMessage?: InputMaybe<Scalars['String']['input']>;
  /** Whether the mailbox owner's away status should be enabled. */
  awayStatus: Scalars['Boolean']['input'];
  /** Unique identifier of the mailbox to update. */
  id: Scalars['ID']['input'];
};

/** Domain error returned when the provided mailbox ID is invalid for the update operation. */
export type UpdateMailboxByIdInvalidMailboxIdError = DomainError & {
  __typename?: 'UpdateMailboxByIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the mailbox to update is not found. */
export type UpdateMailboxByIdNotFoundError = DomainError & {
  __typename?: 'UpdateMailboxByIdNotFoundError';
  /** The mailbox ID that was not found. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for updateMailboxById. Returns Mailbox on success or UpdateMailboxByIdFailure on failure. */
export type UpdateMailboxByIdResult = Mailbox | MailboxByIdFailure | UpdateMailboxByIdFailure;

export type UpdateMailboxInput = {
  awayMessage?: InputMaybe<Scalars['String']['input']>;
  awayStatus?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateMemberByContactIdDomainError = UpdateMemberByContactIdInvalidContactIdError;

export type UpdateMemberByContactIdFailure = {
  __typename?: 'UpdateMemberByContactIdFailure';
  /** All errors associated with required Member By Id. */
  errors: Array<UpdateMemberByContactIdDomainError>;
};

export type UpdateMemberByContactIdInput = {
  AmountMSRP__c?: InputMaybe<Scalars['Int']['input']>;
  AutoPay__c?: InputMaybe<Scalars['Boolean']['input']>;
  Best_Method_Of_Communication__c?: InputMaybe<Scalars['String']['input']>;
  CancellationStatistics__c?: InputMaybe<Scalars['Boolean']['input']>;
  Connect_User_Status__c?: InputMaybe<Scalars['Boolean']['input']>;
  Current_Agreement_Payment_Schedule__c?: InputMaybe<Scalars['String']['input']>;
  Current_Balance_Formula__c?: InputMaybe<Scalars['String']['input']>;
  Current_Balance__c?: InputMaybe<Scalars['Float']['input']>;
  Current_Membership_Type__c?: InputMaybe<Scalars['String']['input']>;
  /**
   * Date_Of_Birth__c of a member
   * Format: YYYY-MM-DD
   */
  Date_Of_Birth__c?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Emergency_Phone__c of a member
   * Format: (XXX) XXX-XXXX
   */
  Emergency_Phone__c?: InputMaybe<Scalars['String']['input']>;
  Employer__c?: InputMaybe<Scalars['String']['input']>;
  Established_Date__c?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fax of a member
   * Format: (XXX) XXX-XXXX
   */
  Fax?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  Gender__c?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  Last_App_Login__c?: InputMaybe<Scalars['String']['input']>;
  Last_Payment_Date__c?: InputMaybe<Scalars['String']['input']>;
  Last_Wellness_Exam__c?: InputMaybe<Scalars['String']['input']>;
  LeadSource?: InputMaybe<Scalars['String']['input']>;
  MDVIPID__c?: InputMaybe<Scalars['String']['input']>;
  MDVIP_Connect_User__c?: InputMaybe<Scalars['Boolean']['input']>;
  MFMailboxID__c?: InputMaybe<Scalars['String']['input']>;
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  MailingState?: InputMaybe<Scalars['String']['input']>;
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  Member_Status__c?: InputMaybe<Scalars['String']['input']>;
  /**
   * MobilePhone of a member
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  Next_Renewal_Date_Formula__c?: InputMaybe<Scalars['String']['input']>;
  OtherCity?: InputMaybe<Scalars['String']['input']>;
  OtherPostalCode?: InputMaybe<Scalars['String']['input']>;
  OtherState?: InputMaybe<Scalars['String']['input']>;
  OtherStreet?: InputMaybe<Scalars['String']['input']>;
  /**
   * Phone of a member
   * Format: (XXX) XXX-XXXX
   */
  Phone?: InputMaybe<Scalars['String']['input']>;
  /** User preference to enable push notifications for new secure messages */
  Push_Notifications__c?: InputMaybe<Scalars['Boolean']['input']>;
  Referral_Name__c?: InputMaybe<Scalars['String']['input']>;
  /** User preference to enable email notifications for new secure messages */
  SM_Email_Notification__c?: InputMaybe<Scalars['Boolean']['input']>;
  Salutation?: InputMaybe<Scalars['String']['input']>;
  Secondary_Insurance__c?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Unknown_Insurance_Company_Name__c?: InputMaybe<Scalars['String']['input']>;
  Work_Ext__c?: InputMaybe<Scalars['String']['input']>;
  Work_Phone__c?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMemberByContactIdInvalidContactIdError = DomainError & {
  __typename?: 'UpdateMemberByContactIdInvalidContactIdError';
  /** ContactId that was included in the query */
  ContactId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type UpdateMemberByContactIdResult = Member | UpdateMemberByContactIdFailure;

/** Union of all domain errors that can occur when updating a message by ID. */
export type UpdateMessageByIdDomainError = UpdateMessageByIdInvalidIdError | UpdateMessageByIdInvalidMailboxIdError | UpdateMessageByIdInvalidThreadIdError | UpdateMessageByIdNotFoundError;

/** Encapsulates all domain errors for the updateMessageById operation. */
export type UpdateMessageByIdFailure = {
  __typename?: 'UpdateMessageByIdFailure';
  /** List of domain errors that occurred during message update. */
  errors: Array<UpdateMessageByIdDomainError>;
};

/** Input parameters for the updateMessageById mutation. */
export type UpdateMessageByIdInput = {
  /** Updated file attachments for the message. */
  attachments: Array<UpdateMessageByIdInputAttachment>;
  /** Updated blind carbon copy recipients of the message. */
  bcc?: InputMaybe<Array<UpdateMessageByIdInputRecipient>>;
  /** Updated body content of the message. */
  body: Scalars['String']['input'];
  /** Updated carbon copy recipients of the message. */
  cc?: InputMaybe<Array<UpdateMessageByIdInputRecipient>>;
  /** Whether the message is a draft. */
  draft: Scalars['Boolean']['input'];
  /** Updated sender of the message. */
  from: UpdateMessageByIdInputSender;
  /** Unique identifier of the message to update. */
  id: Scalars['ID']['input'];
  /** Unique identifier of the mailbox containing the message. */
  mailboxId: Scalars['ID']['input'];
  /** Whether the message has been read. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated subject line of the message. */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the thread containing the message. */
  threadId: Scalars['ID']['input'];
  /** Updated primary recipients of the message. */
  to: Array<UpdateMessageByIdInputRecipient>;
};

/** Input parameters for an attachment when updating a message. */
export type UpdateMessageByIdInputAttachment = {
  /** Timestamp when the attachment was created. */
  createdTimestamp: Scalars['String']['input'];
  /** Unique identifier of the attachment. */
  id: Scalars['ID']['input'];
  /** MIME type of the attachment content. */
  mimeType: Scalars['String']['input'];
  /** Original file name of the attachment. */
  name: Scalars['String']['input'];
};

/** Input parameters for a recipient when updating a message. */
export type UpdateMessageByIdInputRecipient = {
  /** Email address of the recipient. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the recipient. */
  id: Scalars['ID']['input'];
  /** Display name of the recipient. */
  name: Scalars['String']['input'];
};

/** Input parameters for the sender when updating a message. */
export type UpdateMessageByIdInputSender = {
  /** Unique identifier of the sender. */
  id: Scalars['ID']['input'];
  /** Display name of the sender. */
  name: Scalars['String']['input'];
};

/** Domain error returned when the message ID is invalid for the update request. */
export type UpdateMessageByIdInvalidIdError = DomainError & {
  __typename?: 'UpdateMessageByIdInvalidIdError';
  /** The invalid message ID that was provided. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the mailbox ID is invalid for the update message request. */
export type UpdateMessageByIdInvalidMailboxIdError = DomainError & {
  __typename?: 'UpdateMessageByIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the thread ID is invalid for the update message request. */
export type UpdateMessageByIdInvalidThreadIdError = DomainError & {
  __typename?: 'UpdateMessageByIdInvalidThreadIdError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The invalid thread ID that was provided. */
  threadId: Scalars['ID']['output'];
};

/** Domain error returned when the message to update is not found. */
export type UpdateMessageByIdNotFoundError = DomainError & {
  __typename?: 'UpdateMessageByIdNotFoundError';
  /** The message ID that was not found. */
  id: Scalars['ID']['output'];
  /** The mailbox ID that was searched. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** The thread ID that was searched. */
  threadId: Scalars['ID']['output'];
};

/** Result type for updateMessageById. Returns UpdateMessageByIdSuccess on success or UpdateMessageByIdFailure on failure. */
export type UpdateMessageByIdResult = MailboxByIdFailure | UpdateMessageByIdFailure | UpdateMessageByIdSuccess;

/** Represents a successful update of a message. */
export type UpdateMessageByIdSuccess = {
  __typename?: 'UpdateMessageByIdSuccess';
  /** Unique identifier of the updated message. */
  id: Scalars['ID']['output'];
  /** Unique identifier of the mailbox containing the updated message. */
  mailboxId: Scalars['ID']['output'];
  /** Unique identifier of the thread containing the updated message. */
  threadId: Scalars['ID']['output'];
};

export type UpdateMessageInput = {
  attachments?: InputMaybe<Array<InputMaybe<CreateMessageAttachmentInput>>>;
  bcc?: InputMaybe<Array<InputMaybe<CreateMessageUserInput>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<InputMaybe<CreateMessageUserInput>>>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<CreateMessageUserInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailboxId?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<InputMaybe<CreateMessageUserInput>>>;
};

/** Union of all domain errors that can occur when updating a message thread by ID. */
export type UpdateMessageThreadByIdDomainError = UpdateMessageThreadByIdInvalidIdError | UpdateMessageThreadByIdInvalidMailboxIdError | UpdateMessageThreadByIdNotFoundError;

/** Encapsulates all domain errors for the updateMessageThreadById operation. */
export type UpdateMessageThreadByIdFailure = {
  __typename?: 'UpdateMessageThreadByIdFailure';
  /** List of domain errors that occurred during message thread update. */
  errors: Array<UpdateMessageThreadByIdDomainError>;
};

/** Input parameters for the updateMessageThreadById mutation. */
export type UpdateMessageThreadByIdInput = {
  /** Whether replies are allowed in the thread. */
  allowReply: Scalars['Boolean']['input'];
  /** Whether the thread should be archived. */
  archived: Scalars['Boolean']['input'];
  /** Whether the thread is a broadcast message. */
  broadcast: Scalars['Boolean']['input'];
  /** Whether the thread contains messages with attachments. */
  hasAttachment: Scalars['Boolean']['input'];
  /** Whether the thread contains draft messages. */
  hasDraft: Scalars['Boolean']['input'];
  /** Whether the thread contains unread messages. */
  hasUnread: Scalars['Boolean']['input'];
  /** Unique identifier of the thread to update. */
  id: Scalars['ID']['input'];
  /** Unique identifier of the mailbox containing the thread. */
  mailboxId: Scalars['ID']['input'];
  /** Total number of messages in the thread. */
  messageCount: Scalars['Int']['input'];
  /** Display name of the thread. */
  name: Scalars['String']['input'];
  /** List of participant identifiers in the thread. */
  participants: Array<Scalars['String']['input']>;
  /** Whether the thread should be starred. */
  starred: Scalars['Boolean']['input'];
};

/** Domain error returned when the thread ID is invalid for the update thread request. */
export type UpdateMessageThreadByIdInvalidIdError = DomainError & {
  __typename?: 'UpdateMessageThreadByIdInvalidIdError';
  /** The invalid thread ID that was provided. */
  id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the mailbox ID is invalid for the update thread request. */
export type UpdateMessageThreadByIdInvalidMailboxIdError = DomainError & {
  __typename?: 'UpdateMessageThreadByIdInvalidMailboxIdError';
  /** The invalid mailbox ID that was provided. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when the message thread to update is not found. */
export type UpdateMessageThreadByIdNotFoundError = DomainError & {
  __typename?: 'UpdateMessageThreadByIdNotFoundError';
  /** The thread ID that was not found. */
  id: Scalars['ID']['output'];
  /** The mailbox ID that was searched. */
  mailboxId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for updateMessageThreadById. Returns UpdateMessageThreadByIdSuccess on success or UpdateMessageThreadByIdFailure on failure. */
export type UpdateMessageThreadByIdResult = MailboxByIdFailure | UpdateMessageThreadByIdFailure | UpdateMessageThreadByIdSuccess;

/** Represents a successful update of a message thread. */
export type UpdateMessageThreadByIdSuccess = {
  __typename?: 'UpdateMessageThreadByIdSuccess';
  /** The updated message thread. */
  thread: MessageThread;
};

export type UpdatePaymentInput = {
  Amount__c: Scalars['String']['input'];
  Id: Scalars['String']['input'];
  Payment_Profile__c: Scalars['String']['input'];
  Schedule_Date__c: Scalars['String']['input'];
  Type__c: Scalars['String']['input'];
};

/** Input for ACH bank account information when updating a payment profile. */
export type UpdatePaymentProfileByIdAchInput = {
  /** Updated ACH bank name. */
  ACHBankName__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated ACH account type. */
  ACH_Name_of_Account__c?: InputMaybe<PaymentProfileAchAccountType>;
  /** Updated name on the bank account. */
  Name_on_Card__c?: InputMaybe<Scalars['String']['input']>;
};

/** Input for credit card information when updating a payment profile. */
export type UpdatePaymentProfileByIdCreditCardInput = {
  /** Updated card type classification. */
  Card_Type__c?: InputMaybe<PaymentProfileCardType>;
  /** Updated expiration month. */
  Expiration_Month__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated expiration year. */
  Expiration_Year__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated name on the credit card. */
  Name_on_Card__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated payment method type. */
  PaymentType__c?: InputMaybe<PaymentProfilePaymentType>;
};

/** Union of all domain errors that can occur when updating a payment profile by ID. */
export type UpdatePaymentProfileByIdDomainError = UpdatePaymentProfileByIdInvalidInputDomainError | UpdatePaymentProfileByIdNotFoundDomainError;

/** Encapsulates all domain errors for the updatePaymentProfileById operation. */
export type UpdatePaymentProfileByIdFailure = {
  __typename?: 'UpdatePaymentProfileByIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<UpdatePaymentProfileByIdDomainError>;
};

/** Input parameters for the updatePaymentProfileById mutation. */
export type UpdatePaymentProfileByIdInput = {
  /** ACH information to update existing payment profile */
  ACHInfo?: InputMaybe<UpdatePaymentProfileByIdAchInput>;
  /** Updated billing address line 1. */
  Address_1__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated billing address line 2. */
  Address_2__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated billing address city. */
  City__c?: InputMaybe<Scalars['String']['input']>;
  /** Credit Card information to update existing payment profile */
  CreditCardInfo?: InputMaybe<UpdatePaymentProfileByIdCreditCardInput>;
  /** Updated default status. */
  Default__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated expiration status. */
  Expired__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated HSA card status. */
  HSACard__c?: InputMaybe<PaymentProfileHsaCard>;
  /** Updated billing address state. */
  States__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated billing address ZIP code. */
  Zipcode__c?: InputMaybe<Scalars['String']['input']>;
};

/** Domain error returned when the update input for a payment profile is invalid. */
export type UpdatePaymentProfileByIdInvalidInputDomainError = {
  __typename?: 'UpdatePaymentProfileByIdInvalidInputDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Domain error returned when a payment profile is not found during update. */
export type UpdatePaymentProfileByIdNotFoundDomainError = {
  __typename?: 'UpdatePaymentProfileByIdNotFoundDomainError';
  /** The payment profile ID that was not found. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for updatePaymentProfileById. Returns PaymentProfile on success or UpdatePaymentProfileByIdFailure on failure. */
export type UpdatePaymentProfileByIdResult = PaymentProfile | UpdatePaymentProfileByIdFailure;

export type UpdatePaymentProfileInput = {
  ACHBankName__c?: InputMaybe<Scalars['String']['input']>;
  ACH_Account_Type__c?: InputMaybe<Scalars['String']['input']>;
  ACH_Name_of_Account__c?: InputMaybe<Scalars['String']['input']>;
  Address_1__c?: InputMaybe<Scalars['String']['input']>;
  Address_2__c?: InputMaybe<Scalars['String']['input']>;
  City__c?: InputMaybe<Scalars['String']['input']>;
  Default__c?: InputMaybe<Scalars['Boolean']['input']>;
  Expiration_Month__c?: InputMaybe<Scalars['String']['input']>;
  Expiration_Year__c?: InputMaybe<Scalars['String']['input']>;
  Expired__c?: InputMaybe<Scalars['String']['input']>;
  HSACard__c?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['String']['input'];
  Name_on_Card__c?: InputMaybe<Scalars['String']['input']>;
  PaymentType__c?: InputMaybe<PaymentTypeEnum>;
  States__c?: InputMaybe<Scalars['String']['input']>;
  Zipcode__c?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhysicianByContactIdDomainError = UpdatePhysicianByContactIdInvalidContactIdError;

/** A domain-specific failure to update an existing physician by contactId */
export type UpdatePhysicianByContactIdFailure = {
  __typename?: 'UpdatePhysicianByContactIdFailure';
  /** All errors associated while updating an existing physician by contactId */
  errors: Array<UpdatePhysicianByContactIdDomainError>;
};

export type UpdatePhysicianByContactIdInput = {
  /**
   * Date of Birth of a physician
   * Format: YYYY-MM-DD
   */
  Date_Of_Birth__c?: InputMaybe<Scalars['String']['input']>;
  /** Email of a physician */
  Email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Emergency Phone of a physician
   * Format: (XXX) XXX-XXXX
   */
  Emergency_Phone__c?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fax of a physician
   * Format: (XXX) XXX-XXXX
   */
  Fax?: InputMaybe<Scalars['String']['input']>;
  /** First name of a physician */
  FirstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender of a physician */
  Gender__c?: InputMaybe<Scalars['String']['input']>;
  /** Last name of a physician */
  LastName?: InputMaybe<Scalars['String']['input']>;
  /** Mailing city of a physician */
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  /** Mailing postal code of a physician */
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Mailing state of a physician */
  MailingState?: InputMaybe<Scalars['String']['input']>;
  /** Mailing street of a physician */
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mobile phone of a physician
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Phone number of a physician
   * Format: (XXX) XXX-XXXX
   */
  Phone?: InputMaybe<Scalars['String']['input']>;
  /** User preference to enable push notifications for new secure messages */
  Push_Notifications__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** User preference to enable email notifications for new secure messages */
  SM_Email_Notification__c?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Salutation of a physician
   * i.e. Mr, Mrs, ...
   */
  Salutation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhysicianByContactIdInvalidContactIdError = DomainError & {
  __typename?: 'UpdatePhysicianByContactIdInvalidContactIdError';
  /** ContactId field that was in the input */
  ContactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type UpdatePhysicianByContactIdResult = Physician | UpdatePhysicianByContactIdFailure;

export enum UpdatePhysicianPracticeStaffAccessActionType {
  /** Toggle PhysicianPracticestaff's portal access */
  DeactivateUser = 'DEACTIVATE_USER',
  /** Re-activates */
  ReactivateUser = 'REACTIVATE_USER',
  /**
   * Toggle PhysicianPracticestaff's portal access
   * - If it's enabled, this mutation disables its access.
   * - If it's disabled, this mutation enables its access.
   */
  TogglePortalAccess = 'TOGGLE_PORTAL_ACCESS'
}

export type UpdatePhysicianPracticeStaffAccessByContactIdDomainError = UpdatePhysicianPracticeStaffAccessByContactIdInvalidDataError;

export type UpdatePhysicianPracticeStaffAccessByContactIdFailure = {
  __typename?: 'UpdatePhysicianPracticeStaffAccessByContactIdFailure';
  /** All errors associated with failure. */
  errors: Array<UpdatePhysicianPracticeStaffAccessByContactIdDomainError>;
};

export type UpdatePhysicianPracticeStaffAccessByContactIdInput = {
  /** Access type of PhysicianPracticeStaff to update to */
  Type: UpdatePhysicianPracticeStaffAccessActionType;
  /** AccountId or ContactId of Super Admin */
  UserId: Scalars['String']['input'];
};

/** Invalid Data domain error */
export type UpdatePhysicianPracticeStaffAccessByContactIdInvalidDataError = DomainError & {
  __typename?: 'UpdatePhysicianPracticeStaffAccessByContactIdInvalidDataError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
  /** A human-friendly error reason. */
  reason: Scalars['String']['output'];
};

export type UpdatePhysicianPracticeStaffAccessByContactIdResult = UpdatePhysicianPracticeStaffAccessByContactIdFailure | UpdatePhysicianPracticeStaffAccessByContactIdSuccessResult;

export type UpdatePhysicianPracticeStaffAccessByContactIdSuccessResult = {
  __typename?: 'UpdatePhysicianPracticeStaffAccessByContactIdSuccessResult';
  status: UpdatePhysicianPracticeStaffAccessByContactIdSuccessStatus;
};

export enum UpdatePhysicianPracticeStaffAccessByContactIdSuccessStatus {
  Success = 'SUCCESS'
}

export type UpdatePhysicianPracticeStaffByContactIdDomainError = UpdatePhysicianPracticeStaffByContactIdInvalidContactIdError;

export type UpdatePhysicianPracticeStaffByContactIdFailure = {
  __typename?: 'UpdatePhysicianPracticeStaffByContactIdFailure';
  /** All errors associated while creating a prospect. */
  errors: Array<UpdatePhysicianPracticeStaffByContactIdDomainError>;
};

export type UpdatePhysicianPracticeStaffByContactIdInput = {
  Connect_User_Status__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** YYYY-MM-DD formatted date */
  Date_Of_Birth__c?: InputMaybe<Scalars['String']['input']>;
  /** Email of the Physician Practice Staff */
  Email?: InputMaybe<Scalars['String']['input']>;
  /** Emergency Phone of the Physician Practice Staff */
  Emergency_Phone__c?: InputMaybe<Scalars['String']['input']>;
  /** Fax of the Physician Practice Staff */
  Fax?: InputMaybe<Scalars['String']['input']>;
  /** First name of the Physician Practice Staff */
  FirstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the new Physician Practice Staff */
  Gender__c?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the Physician Practice Staff */
  LastName?: InputMaybe<Scalars['String']['input']>;
  MDVIP_Connect_User__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** MailingCity of the new Physician Practice Staff */
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  /** MailingPostalCode of the new Physician Practice Staff */
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** MailingState of the new Physician Practice Staff */
  MailingState?: InputMaybe<Scalars['String']['input']>;
  /** MailingStreet of the new Physician Practice Staff */
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  /** MobilePhone of the Physician Practice Staff */
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  /** Phone of the Physician Practice Staff */
  Phone?: InputMaybe<Scalars['String']['input']>;
  /** User preference to enable push notifications for new secure messages */
  Push_Notifications__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** User preference to enable email notifications for new secure messages */
  SM_Email_Notification__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Salutation of the Physician Practice Staff */
  Salutation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhysicianPracticeStaffByContactIdInvalidContactIdError = DomainError & {
  __typename?: 'UpdatePhysicianPracticeStaffByContactIdInvalidContactIdError';
  /** ContactId that was included in the query */
  ContactId: Scalars['String']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type UpdatePhysicianPracticeStaffByContactIdResult = PhysicianPracticeStaff | UpdatePhysicianPracticeStaffByContactIdFailure;

export type UpdateProspectByContactIdDomainError = UpdateProspectByContactIdInvalidContactIdError;

/** A domain-specific failure to update an existing prospect by contactId. */
export type UpdateProspectByContactIdFailure = {
  __typename?: 'UpdateProspectByContactIdFailure';
  /** All errors associated while updating an existing prospect by contactId. */
  errors: Array<UpdateProspectByContactIdDomainError>;
};

export type UpdateProspectByContactIdInput = {
  /** Date_Of_Birth__c of the prospect contact */
  Date_Of_Birth__c?: InputMaybe<Scalars['String']['input']>;
  /** Email of the prospect contact */
  Email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fax from Contact record
   * Format: (XXX) XXX-XXXX
   */
  Fax?: InputMaybe<Scalars['String']['input']>;
  /** FirstName of the prospect contact */
  FirstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender__c of the prospect contact */
  Gender__c?: InputMaybe<Scalars['String']['input']>;
  /** LastName of the prospect contact */
  LastName?: InputMaybe<Scalars['String']['input']>;
  /** LeadSource of the prospect contact */
  LeadSource?: InputMaybe<Scalars['String']['input']>;
  /** MDVIPID__c of the prospect contact */
  MDVIPID__c?: InputMaybe<Scalars['String']['input']>;
  /** MailingCity of the prospect contact */
  MailingCity?: InputMaybe<Scalars['String']['input']>;
  /** MailingPostalCode of the prospect contact */
  MailingPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** MailingState of the prospect contact */
  MailingState?: InputMaybe<Scalars['String']['input']>;
  /** MailingStreet of the prospect contact */
  MailingStreet?: InputMaybe<Scalars['String']['input']>;
  /**
   * MobilePhone of the prospect contact
   * Format: (XXX) XXX-XXXX
   */
  MobilePhone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Phone of the prospect contact
   * Format: (XXX) XXX-XXXX
   */
  Phone?: InputMaybe<Scalars['String']['input']>;
  /** Referral_Name__c of the prospect contact */
  Referral_Name__c?: InputMaybe<Scalars['String']['input']>;
  /** Salutation of the prospect contact */
  Salutation?: InputMaybe<Scalars['String']['input']>;
  /** Unknown_Insurance_Company_Name__c of the prospect contact */
  Unknown_Insurance_Company_Name__c?: InputMaybe<Scalars['String']['input']>;
  /** UserNameNotQualified__c of the prospect contact */
  UserNameNotQualified__c?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProspectByContactIdInvalidContactIdError = DomainError & {
  __typename?: 'UpdateProspectByContactIdInvalidContactIdError';
  /** ContactId field that was in the input */
  ContactId: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

export type UpdateProspectByContactIdResult = Prospect | UpdateProspectByContactIdFailure;

/** Union of all domain errors that can occur when updating a prospect F2F case. */
export type UpdateProspectF2FCaseByCaseIdDomainError = UpdateProspectF2FCaseByCaseIdInvalidDataError;

/** Encapsulates all domain errors for the updateProspectF2FCaseByCaseId operation. */
export type UpdateProspectF2FCaseByCaseIdFailure = {
  __typename?: 'UpdateProspectF2FCaseByCaseIdFailure';
  /** All errors associated while updating a prospect f2f case. */
  errors: Array<UpdateProspectF2FCaseByCaseIdDomainError>;
};

/** Input parameters for the updateProspectF2FCaseByCaseId mutation. */
export type UpdateProspectF2FCaseByCaseIdInput = {
  /** Date of face to face appointment - Should follow 'MM/DD/YYYY' format */
  DateofFaceofFace?: InputMaybe<Scalars['String']['input']>;
  /** Meeting time of face to face appointment */
  MeetingTime?: InputMaybe<Scalars['String']['input']>;
  /** ProfileName of face to face appointment */
  ProfileName: Scalars['String']['input'];
  /** Result of face to face appointment */
  Result?: InputMaybe<Scalars['String']['input']>;
  /** Status of face to face appointment */
  Status: ProspectF2FCaseStatus;
  /** UserName of face to face appointment */
  UserName: Scalars['String']['input'];
};

/** Domain error returned when the input data for updating a prospect F2F case is invalid. */
export type UpdateProspectF2FCaseByCaseIdInvalidDataError = DomainError & {
  __typename?: 'UpdateProspectF2FCaseByCaseIdInvalidDataError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for updateProspectF2FCaseByCaseId. Returns UpdateProspectF2FCaseByCaseIdSuccess on success or UpdateProspectF2FCaseByCaseIdFailure on failure. */
export type UpdateProspectF2FCaseByCaseIdResult = UpdateProspectF2FCaseByCaseIdFailure | UpdateProspectF2FCaseByCaseIdSuccess;

/** Represents a successful prospect F2F case update. */
export type UpdateProspectF2FCaseByCaseIdSuccess = {
  __typename?: 'UpdateProspectF2FCaseByCaseIdSuccess';
  /** Success status of updating an existing prospect f2f case. */
  status?: Maybe<UpdateProspectF2FCaseByCaseIdSuccessStatus>;
};

/** Defines the success status values for updating a prospect F2F case. */
export enum UpdateProspectF2FCaseByCaseIdSuccessStatus {
  /** Means the Prospect F2F case successfully updated */
  Success = 'SUCCESS'
}

export type UpdateThreadInput = {
  allowReply?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  hasDraft?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnread?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mailBoxId?: InputMaybe<Scalars['String']['input']>;
  messageCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Union of all domain errors that can occur when updating an upcoming payment by ID. */
export type UpdateUpcomingPaymentByIdDomainError = UpdateUpcomingPaymentByIdNotFoundDomainError;

/** Encapsulates all domain errors for the updateUpcomingPaymentById operation. */
export type UpdateUpcomingPaymentByIdFailure = {
  __typename?: 'UpdateUpcomingPaymentByIdFailure';
  /** List of domain errors that occurred. */
  errors: Array<UpdateUpcomingPaymentByIdDomainError>;
};

/** Input parameters for the updateUpcomingPaymentById mutation. */
export type UpdateUpcomingPaymentByIdInput = {
  /** Updated payment amount in dollars. */
  Amount__c?: InputMaybe<Scalars['Float']['input']>;
  /** Updated Salesforce Payment Profile ID. */
  Payment_Profile__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated scheduled date for the payment (YYYY-MM-DD). */
  Schedule_Date__c?: InputMaybe<Scalars['String']['input']>;
  /** Updated payment status. */
  Status__c?: InputMaybe<UpcomingPaymentStatusForUpdate>;
  /** Updated payment type. */
  Type__c?: InputMaybe<PaymentType>;
};

/** Domain error returned when an upcoming payment is not found during update. */
export type UpdateUpcomingPaymentByIdNotFoundDomainError = {
  __typename?: 'UpdateUpcomingPaymentByIdNotFoundDomainError';
  /** The upcoming payment ID that was not found. */
  Id: Scalars['ID']['output'];
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Result type for updateUpcomingPaymentById. Returns UpcomingPayment on success or UpdateUpcomingPaymentByIdFailure on failure. */
export type UpdateUpcomingPaymentByIdResult = UpcomingPayment | UpdateUpcomingPaymentByIdFailure;

export type UpdateWaitlistEntryInput = {
  caseId: Scalars['ID']['input'];
  caseStatus?: InputMaybe<CaseStatus>;
  connectUserName: Scalars['String']['input'];
  contactId: Scalars['ID']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  profileName: Scalars['String']['input'];
};

/** Represents a federated User entity stub used for PDM (Physician Data Manager) resolution. */
export type User = {
  __typename?: 'User';
  /** Avatar image URLs at various resolutions. */
  Avatar: UserAvatar;
  /** Email address of the user. */
  Email: Scalars['String']['output'];
  /** Unique identifier for the user. */
  Id: Scalars['ID']['output'];
  /** Mobile phone number of the user. */
  MobilePhone?: Maybe<Scalars['String']['output']>;
  /** Full display name of the user. */
  Name: Scalars['String']['output'];
  /** Office or home phone number of the user. */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Role assigned to the user (e.g., physician, member). */
  Role: Scalars['String']['output'];
};

/** Represents the avatar image URLs for a user at various resolutions. */
export type UserAvatar = {
  __typename?: 'UserAvatar';
  /** URL for the large-sized avatar image. */
  Large: Scalars['String']['output'];
  /** URL for the medium-sized avatar image. */
  Medium: Scalars['String']['output'];
  /** URL for the thumbnail-sized avatar image. */
  Thumbnail: Scalars['String']['output'];
};

/**
 * Defines the authenticated user roles used by the @authorization directive
 * to enforce role-based access control on field definitions.
 */
export enum UserType {
  /** MDVIP internal employee */
  Employee = 'EMPLOYEE',
  /** Unauthenticated guest making an express payment */
  ExpressPay = 'EXPRESS_PAY',
  /** MDVIP enrolled member (patient) */
  Member = 'MEMBER',
  /** MDVIP affiliated physician */
  Physician = 'PHYSICIAN',
  /** Staff member of a physician's practice */
  PhysicianPracticeStaff = 'PHYSICIAN_PRACTICE_STAFF'
}

/** Domain error returned when ACH information verification fails. */
export type VerifyAchInformationDomainError = DomainError & {
  __typename?: 'VerifyACHInformationDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Encapsulates all domain errors for the verifyACHInformation operation. */
export type VerifyAchInformationFailure = {
  __typename?: 'VerifyACHInformationFailure';
  /** List of domain errors that occurred during ACH verification. */
  errors: Array<VerifyAchInformationDomainError>;
};

/** Input parameters for the verifyACHInformation mutation. */
export type VerifyAchInformationInput = {
  /** Bank account number to verify. */
  AccountNumber: Scalars['String']['input'];
  /** Bank routing number to verify. */
  RoutingNumber: Scalars['String']['input'];
};

/** Result type for verifyACHInformation. Returns VerifyACHInformationSuccess on success or VerifyACHInformationFailure on failure. */
export type VerifyAchInformationResult = VerifyAchInformationFailure | VerifyAchInformationSuccess;

/** Represents a successful ACH verification response from the payment gateway. */
export type VerifyAchInformationSuccess = {
  __typename?: 'VerifyACHInformationSuccess';
  /** Authorization transaction ID from the gateway. */
  authTransactionId: Scalars['String']['output'];
  /** Token ID returned by the payment gateway for the verified ACH account. */
  gatewayTokenId: Scalars['String']['output'];
  /** Payment type determined by the gateway (always ACH for this response). */
  paymentType: PaymentProfilePaymentType;
};

/** Domain error returned when credit card information verification fails. */
export type VerifyCreditCardInformationDomainError = DomainError & {
  __typename?: 'VerifyCreditCardInformationDomainError';
  /** A human-friendly error message. */
  message: Scalars['String']['output'];
};

/** Encapsulates all domain errors for the verifyCreditCardInformation operation. */
export type VerifyCreditCardInformationFailure = {
  __typename?: 'VerifyCreditCardInformationFailure';
  /** List of domain errors that occurred during credit card verification. */
  errors: Array<VerifyCreditCardInformationDomainError>;
};

/** Input parameters for the verifyCreditCardInformation mutation. */
export type VerifyCreditCardInformationInput = {
  /** Card verification value (security code). */
  CVV: Scalars['String']['input'];
  /** Credit card number to verify. */
  CardNumber: Scalars['String']['input'];
  /** Expiration month of the credit card (1-12). */
  ExpirationMonth: Scalars['Int']['input'];
  /** Expiration year of the credit card (four-digit year). */
  ExpirationYear: Scalars['Int']['input'];
};

/** Result type for verifyCreditCardInformation. Returns VerifyCreditCardInformationSuccess on success or VerifyCreditCardInformationFailure on failure. */
export type VerifyCreditCardInformationResult = VerifyCreditCardInformationFailure | VerifyCreditCardInformationSuccess;

/** Represents a successful credit card verification response from the payment gateway. */
export type VerifyCreditCardInformationSuccess = {
  __typename?: 'VerifyCreditCardInformationSuccess';
  /** Authorization transaction ID from the gateway. */
  authTransactionId: Scalars['String']['output'];
  /** Token ID returned by the payment gateway for the verified credit card. */
  gatewayTokenId: Scalars['String']['output'];
  /** Payment type determined by the gateway (e.g., VISA, MC, AMEX, DISC). */
  paymentType: PaymentProfilePaymentType;
};

export type WaitlistResult = {
  __typename?: 'WaitlistResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Defines the possible statuses for a wellness exam appointment. */
export enum WellnessExamStatus {
  /** Member arrived for the exam. */
  Arrived = 'Arrived',
  /** Exam has been booked and scheduled. */
  Booked = 'Booked',
  /** Exam was canceled (alternate spelling). */
  Canceled = 'Canceled',
  /** Exam was cancelled (primary spelling). */
  Cancelled = 'Cancelled',
  /** Exam has been completed. */
  Completed = 'Completed',
  /** Member did not show up for the exam. */
  Noshow = 'Noshow'
}

/** Defines the possible upload statuses for an AWP wellness exam document. */
export enum WellnessExamUploadStatus {
  /** Document has been approved. */
  Approved = 'Approved',
  /** Document has been deleted. */
  Deleted = 'Deleted',
  /** An error occurred during upload processing. */
  Error = 'Error',
  /** Document was not approved. */
  NotApproved = 'Not_Approved',
  /** Document upload is pending. */
  Pending = 'Pending',
  /** Document was rejected. */
  Rejected = 'Rejected',
  /** Document has been uploaded and needs QA review. */
  UploadedNeedsQa = 'Uploaded_needs_QA'
}

export type ContactOptInPreferences = {
  __typename?: 'contactOptInPreferences';
  Automated_Communication_Opt_In__c?: Maybe<Scalars['Boolean']['output']>;
  MobilePhone?: Maybe<Scalars['String']['output']>;
};

export type ContactOptInPreferencesNotFoundError = DomainError & {
  __typename?: 'contactOptInPreferencesNotFoundError';
  message: Scalars['String']['output'];
};

export type ContactOptInPreferencesResult = ContactOptInPreferences | ContactOptInPreferencesNotFoundError;

export type CreateMessageAttachmentInput = {
  createdTimestamp?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum Join__Graph {
  Account = 'ACCOUNT',
  Awp = 'AWP',
  Case = 'CASE',
  Contact = 'CONTACT',
  Featureflag = 'FEATUREFLAG',
  Main = 'MAIN',
  Notification = 'NOTIFICATION',
  Patientreport = 'PATIENTREPORT',
  Payment = 'PAYMENT',
  Paymentgateway = 'PAYMENTGATEWAY',
  Paymentprofile = 'PAYMENTPROFILE',
  Pdm = 'PDM',
  Practicereport = 'PRACTICEREPORT',
  Referral = 'REFERRAL',
  Securemessaging = 'SECUREMESSAGING',
  User = 'USER'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type MessagingContactsForPhysicianInput = {
  AccountId: Scalars['String']['input'];
};

export type CreateNewPaymentProfileMutationVariables = Exact<{
  input: CreateNewPaymentProfileInput;
}>;


export type CreateNewPaymentProfileMutation = { __typename?: 'Mutation', createNewPaymentProfile:
    | { __typename?: 'CreateNewPaymentProfileFailure', errors: Array<
        | { __typename?: 'CreateNewPaymentProfileFailedDomainError', message: string }
        | { __typename?: 'CreateNewPaymentProfileInvalidInputDomainError', message: string }
      > }
    | { __typename?: 'CreateNewPaymentProfileSuccess', Id: string }
   };

export type CreateOneTimePaymentMutationVariables = Exact<{
  input: CreateOneTimePaymentInput;
}>;


export type CreateOneTimePaymentMutation = { __typename?: 'Mutation', createOneTimePayment:
    | { __typename?: 'CreateOneTimePaymentFailure', errors: Array<{ __typename?: 'CreateOneTimePaymentFailedDomainError', message: string }> }
    | { __typename?: 'CreateOneTimePaymentSuccess', Id: string, Name: string }
   };

export type EnableMemberAutopayByContactIdMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  updateOnly: Scalars['Boolean']['input'];
}>;


export type EnableMemberAutopayByContactIdMutation = { __typename?: 'Mutation', enableMemberAutopayByContactId:
    | { __typename?: 'EnableAutopaySuccess' }
    | { __typename?: 'EnableMemberAutopayByContactIdFailure', errors: Array<{ __typename?: 'EnableMemberAutopayByContactIdInvalidContactIdError', ContactId: string, message: string }> }
    | { __typename?: 'Member', AutoPay__c?: boolean | null }
   };

export type ReinstateMemberMutationVariables = Exact<{
  input: ReinstateMemberInput;
}>;


export type ReinstateMemberMutation = { __typename?: 'Mutation', reinstateMember:
    | { __typename?: 'ReinstateMemberError', code: string, message: string, workflowId?: string | null }
    | { __typename?: 'ReinstateMemberResponse', workflowId?: string | null }
   };

export type UpdateContactInfoForReinstatementMutationVariables = Exact<{
  input: UpdateContactInfoForReinstatementInput;
}>;


export type UpdateContactInfoForReinstatementMutation = { __typename?: 'Mutation', updateContactInfoForReinstatement:
    | { __typename?: 'UpdateContactInfoForReinstatementFailure', errors: Array<
        | { __typename?: 'AccountByIdNotFoundError', message: string }
        | { __typename?: 'AttachmentDataByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'AttachmentDataByIdInvalidMessageIdError', message: string }
        | { __typename?: 'AttachmentDataByIdInvalidThreadIdError', message: string }
        | { __typename?: 'AttachmentDataByIdNotFoundError', message: string }
        | { __typename?: 'AwpByPhrIdNotFoundError', message: string }
        | { __typename?: 'ContactNotFoundError', message: string }
        | { __typename?: 'CreateMessageThreadMailboxInvalidIdError', message: string }
        | { __typename?: 'CreateMessageThreadMailboxInvalidMailboxIdError', message: string }
        | { __typename?: 'CreateMessageThreadMailboxNotFoundError', message: string }
        | { __typename?: 'CreateMessageThreadUnauthorizedError', message: string }
        | { __typename?: 'CreateNewAwpFailedError', message: string }
        | { __typename?: 'CreateNewMessageInvalidMailboxIdError', message: string }
        | { __typename?: 'CreateNewMessageInvalidThreadIdError', message: string }
        | { __typename?: 'CreateNewMessageMailboxThreadNotFoundError', message: string }
        | { __typename?: 'CreateNewPaymentProfileFailedDomainError', message: string }
        | { __typename?: 'CreateNewPaymentProfileInvalidInputDomainError', message: string }
        | { __typename?: 'CreateOneTimePaymentFailedDomainError', message: string }
        | { __typename?: 'CreatePhysicianPracticeStaffInvalidDataError', message: string }
        | { __typename?: 'CreateProspectF2FCaseInvalidDataError', message: string }
        | { __typename?: 'CreateProspectInvalidContactIdError', message: string }
        | { __typename?: 'DefaultPaymentProfileNotFoundDomainError', message: string }
        | { __typename?: 'DeleteMessageByIdInvalidIdError', message: string }
        | { __typename?: 'DeleteMessageByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'DeleteMessageByIdInvalidThreadIdError', message: string }
        | { __typename?: 'DeleteMessageByIdNotFoundError', message: string }
        | { __typename?: 'DeleteMessageThreadByIdInvalidIdError', message: string }
        | { __typename?: 'DeleteMessageThreadByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'DeleteMessageThreadByIdNotFoundError', message: string }
        | { __typename?: 'EnableMemberAutopayByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'FeatureFlagByConnectUserIdNotFoundError', message: string }
        | { __typename?: 'FeatureFlagByContactIdMissingInputError', message: string }
        | { __typename?: 'FeatureFlagByContactIdNotFoundError', message: string }
        | { __typename?: 'MDVIPUserProfileNotFoundError', message: string }
        | { __typename?: 'MailboxByIdForbiddenError', message: string }
        | { __typename?: 'MailboxByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'MailboxByIdNotFoundError', message: string }
        | { __typename?: 'MailboxByIdUnauthorizedError', message: string }
        | { __typename?: 'MailboxByIdValidateMailboxInternalError', message: string }
        | { __typename?: 'MailboxMetadataByIdNotFoundError', message: string }
        | { __typename?: 'MemberByContactIdNotFoundError', message: string }
        | { __typename?: 'MessageThreadByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'MessageThreadByIdInvalidThreadIdError', message: string }
        | { __typename?: 'MessageThreadByIdNotFoundError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdForbiddenError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdInternalError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdInvalidMailboxIdError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdNotFoundError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdUnauthorizedError', message: string }
        | { __typename?: 'MessagesByMailboxThreadInvalidMailboxIdError', message: string }
        | { __typename?: 'MessagesByMailboxThreadInvalidThreadIdError', message: string }
        | { __typename?: 'MessagesByMailboxThreadNotFoundError', message: string }
        | { __typename?: 'MyMailboxIdNotFoundError', message: string }
        | { __typename?: 'PatientActivityReportInvalidAccountIdError', message: string }
        | { __typename?: 'PatientCaseReportInvalidAccountIdError', message: string }
        | { __typename?: 'PatientReceiptByDocumentIdFailureError', message: string }
        | { __typename?: 'PaymentProfileByIdNotFoundDomainError', message: string }
        | { __typename?: 'PhysicianByAccountIdNotFoundError', message: string }
        | { __typename?: 'PhysicianByContactIdNotFoundError', message: string }
        | { __typename?: 'PhysicianPracticeStaffByContactIdNotFoundError', message: string }
        | { __typename?: 'ProspectByContactIdNotFoundError', message: string }
        | { __typename?: 'ReinstatementContactInformationNotFoundError', message: string }
        | { __typename?: 'SetupMyMailboxContactNotFoundError', message: string }
        | { __typename?: 'SetupMyMailboxMailboxNotFoundError', message: string }
        | { __typename?: 'TransferProspectToMDVIPInvalidDataError', message: string }
        | { __typename?: 'UpdateAwpByPhrIdFailedError', message: string }
        | { __typename?: 'UpdateAwpByPhrIdFileNotFoundError', message: string }
        | { __typename?: 'UpdateFeatureFlagByIdNotFoundError', message: string }
        | { __typename?: 'UpdateFeatureFlagByIdUnauthorizedError', message: string }
        | { __typename?: 'UpdateMailboxByIdAwayMessageMissingError', message: string }
        | { __typename?: 'UpdateMailboxByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'UpdateMailboxByIdNotFoundError', message: string }
        | { __typename?: 'UpdateMemberByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'UpdateMessageByIdInvalidIdError', message: string }
        | { __typename?: 'UpdateMessageByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'UpdateMessageByIdInvalidThreadIdError', message: string }
        | { __typename?: 'UpdateMessageByIdNotFoundError', message: string }
        | { __typename?: 'UpdateMessageThreadByIdInvalidIdError', message: string }
        | { __typename?: 'UpdateMessageThreadByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'UpdateMessageThreadByIdNotFoundError', message: string }
        | { __typename?: 'UpdatePhysicianByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'UpdatePhysicianPracticeStaffAccessByContactIdInvalidDataError', message: string }
        | { __typename?: 'UpdatePhysicianPracticeStaffByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'UpdateProspectByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'UpdateProspectF2FCaseByCaseIdInvalidDataError', message: string }
        | { __typename?: 'VerifyACHInformationDomainError', message: string }
        | { __typename?: 'VerifyCreditCardInformationDomainError', message: string }
        | { __typename?: 'contactOptInPreferencesNotFoundError', message: string }
      > }
    | { __typename?: 'UpdateContactInfoForReinstatementSuccess', success: boolean }
   };

export type UpdateContactOptInPreferencesMutationVariables = Exact<{
  input: UpdateContactOptInPreferencesInput;
}>;


export type UpdateContactOptInPreferencesMutation = { __typename?: 'Mutation', updateContactOptInPreferences:
    | { __typename?: 'UpdateContactOptInPreferencesFailure', errors: Array<
        | { __typename?: 'AccountByIdNotFoundError', message: string }
        | { __typename?: 'AttachmentDataByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'AttachmentDataByIdInvalidMessageIdError', message: string }
        | { __typename?: 'AttachmentDataByIdInvalidThreadIdError', message: string }
        | { __typename?: 'AttachmentDataByIdNotFoundError', message: string }
        | { __typename?: 'AwpByPhrIdNotFoundError', message: string }
        | { __typename?: 'ContactNotFoundError', message: string }
        | { __typename?: 'CreateMessageThreadMailboxInvalidIdError', message: string }
        | { __typename?: 'CreateMessageThreadMailboxInvalidMailboxIdError', message: string }
        | { __typename?: 'CreateMessageThreadMailboxNotFoundError', message: string }
        | { __typename?: 'CreateMessageThreadUnauthorizedError', message: string }
        | { __typename?: 'CreateNewAwpFailedError', message: string }
        | { __typename?: 'CreateNewMessageInvalidMailboxIdError', message: string }
        | { __typename?: 'CreateNewMessageInvalidThreadIdError', message: string }
        | { __typename?: 'CreateNewMessageMailboxThreadNotFoundError', message: string }
        | { __typename?: 'CreateNewPaymentProfileFailedDomainError', message: string }
        | { __typename?: 'CreateNewPaymentProfileInvalidInputDomainError', message: string }
        | { __typename?: 'CreateOneTimePaymentFailedDomainError', message: string }
        | { __typename?: 'CreatePhysicianPracticeStaffInvalidDataError', message: string }
        | { __typename?: 'CreateProspectF2FCaseInvalidDataError', message: string }
        | { __typename?: 'CreateProspectInvalidContactIdError', message: string }
        | { __typename?: 'DefaultPaymentProfileNotFoundDomainError', message: string }
        | { __typename?: 'DeleteMessageByIdInvalidIdError', message: string }
        | { __typename?: 'DeleteMessageByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'DeleteMessageByIdInvalidThreadIdError', message: string }
        | { __typename?: 'DeleteMessageByIdNotFoundError', message: string }
        | { __typename?: 'DeleteMessageThreadByIdInvalidIdError', message: string }
        | { __typename?: 'DeleteMessageThreadByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'DeleteMessageThreadByIdNotFoundError', message: string }
        | { __typename?: 'EnableMemberAutopayByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'FeatureFlagByConnectUserIdNotFoundError', message: string }
        | { __typename?: 'FeatureFlagByContactIdMissingInputError', message: string }
        | { __typename?: 'FeatureFlagByContactIdNotFoundError', message: string }
        | { __typename?: 'MDVIPUserProfileNotFoundError', message: string }
        | { __typename?: 'MailboxByIdForbiddenError', message: string }
        | { __typename?: 'MailboxByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'MailboxByIdNotFoundError', message: string }
        | { __typename?: 'MailboxByIdUnauthorizedError', message: string }
        | { __typename?: 'MailboxByIdValidateMailboxInternalError', message: string }
        | { __typename?: 'MailboxMetadataByIdNotFoundError', message: string }
        | { __typename?: 'MemberByContactIdNotFoundError', message: string }
        | { __typename?: 'MessageThreadByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'MessageThreadByIdInvalidThreadIdError', message: string }
        | { __typename?: 'MessageThreadByIdNotFoundError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdForbiddenError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdInternalError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdInvalidMailboxIdError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdNotFoundError', message: string }
        | { __typename?: 'MessageThreadsByMailboxIdUnauthorizedError', message: string }
        | { __typename?: 'MessagesByMailboxThreadInvalidMailboxIdError', message: string }
        | { __typename?: 'MessagesByMailboxThreadInvalidThreadIdError', message: string }
        | { __typename?: 'MessagesByMailboxThreadNotFoundError', message: string }
        | { __typename?: 'MyMailboxIdNotFoundError', message: string }
        | { __typename?: 'PatientActivityReportInvalidAccountIdError', message: string }
        | { __typename?: 'PatientCaseReportInvalidAccountIdError', message: string }
        | { __typename?: 'PatientReceiptByDocumentIdFailureError', message: string }
        | { __typename?: 'PaymentProfileByIdNotFoundDomainError', message: string }
        | { __typename?: 'PhysicianByAccountIdNotFoundError', message: string }
        | { __typename?: 'PhysicianByContactIdNotFoundError', message: string }
        | { __typename?: 'PhysicianPracticeStaffByContactIdNotFoundError', message: string }
        | { __typename?: 'ProspectByContactIdNotFoundError', message: string }
        | { __typename?: 'ReinstatementContactInformationNotFoundError', message: string }
        | { __typename?: 'SetupMyMailboxContactNotFoundError', message: string }
        | { __typename?: 'SetupMyMailboxMailboxNotFoundError', message: string }
        | { __typename?: 'TransferProspectToMDVIPInvalidDataError', message: string }
        | { __typename?: 'UpdateAwpByPhrIdFailedError', message: string }
        | { __typename?: 'UpdateAwpByPhrIdFileNotFoundError', message: string }
        | { __typename?: 'UpdateFeatureFlagByIdNotFoundError', message: string }
        | { __typename?: 'UpdateFeatureFlagByIdUnauthorizedError', message: string }
        | { __typename?: 'UpdateMailboxByIdAwayMessageMissingError', message: string }
        | { __typename?: 'UpdateMailboxByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'UpdateMailboxByIdNotFoundError', message: string }
        | { __typename?: 'UpdateMemberByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'UpdateMessageByIdInvalidIdError', message: string }
        | { __typename?: 'UpdateMessageByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'UpdateMessageByIdInvalidThreadIdError', message: string }
        | { __typename?: 'UpdateMessageByIdNotFoundError', message: string }
        | { __typename?: 'UpdateMessageThreadByIdInvalidIdError', message: string }
        | { __typename?: 'UpdateMessageThreadByIdInvalidMailboxIdError', message: string }
        | { __typename?: 'UpdateMessageThreadByIdNotFoundError', message: string }
        | { __typename?: 'UpdatePhysicianByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'UpdatePhysicianPracticeStaffAccessByContactIdInvalidDataError', message: string }
        | { __typename?: 'UpdatePhysicianPracticeStaffByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'UpdateProspectByContactIdInvalidContactIdError', message: string }
        | { __typename?: 'UpdateProspectF2FCaseByCaseIdInvalidDataError', message: string }
        | { __typename?: 'VerifyACHInformationDomainError', message: string }
        | { __typename?: 'VerifyCreditCardInformationDomainError', message: string }
        | { __typename?: 'contactOptInPreferencesNotFoundError', message: string }
      > }
    | { __typename?: 'UpdateContactOptInPreferencesSuccess', success: boolean }
   };

export type VerifyAchInformationMutationVariables = Exact<{
  input: VerifyAchInformationInput;
}>;


export type VerifyAchInformationMutation = { __typename?: 'Mutation', verifyACHInformation:
    | { __typename?: 'VerifyACHInformationFailure', errors: Array<{ __typename?: 'VerifyACHInformationDomainError', message: string }> }
    | { __typename?: 'VerifyACHInformationSuccess', gatewayTokenId: string, authTransactionId: string, paymentType: PaymentProfilePaymentType }
   };

export type VerifyCreditCardInformationMutationVariables = Exact<{
  input: VerifyCreditCardInformationInput;
}>;


export type VerifyCreditCardInformationMutation = { __typename?: 'Mutation', verifyCreditCardInformation:
    | { __typename?: 'VerifyCreditCardInformationFailure', errors: Array<{ __typename?: 'VerifyCreditCardInformationDomainError', message: string }> }
    | { __typename?: 'VerifyCreditCardInformationSuccess', gatewayTokenId: string, authTransactionId: string, paymentType: PaymentProfilePaymentType }
   };

export type ContactOptInPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactOptInPreferencesQuery = { __typename?: 'Query', contactOptInPreferences?:
    | { __typename?: 'contactOptInPreferences', MobilePhone?: string | null, Automated_Communication_Opt_In__c?: boolean | null }
    | { __typename?: 'contactOptInPreferencesNotFoundError', message: string }
   | null };

export type NextPaymentDueQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type NextPaymentDueQuery = { __typename?: 'Query', nextPaymentDue: { __typename?: 'NextPaymentDueResponse', MemberId: string, Amount?: number | null, DueDate?: string | null, CurrentBalance?: number | null } };

export type PatientReceiptByDocumentIdQueryQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type PatientReceiptByDocumentIdQueryQuery = { __typename?: 'Query', patientReceiptByDocumentId:
    | { __typename: 'PatientReceiptByDocumentIdFailure', errors: Array<{ __typename?: 'PatientReceiptByDocumentIdFailureError', message: string, contactId: string, documentId: string, statusCode?: number | null }> }
    | { __typename: 'PatientReceiptByDocumentIdQueryResult', document?: string | null, message?: string | null, documentBalance?: number | null, statusCode?: number | null }
   };

export type PaymentSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentSettingsQuery = { __typename?: 'Query', paymentSettings?: { __typename?: 'PaymentSettingsType', MaximumPaymentAmount?: { __typename: 'MaximumPaymentAmountType', Label?: string | null, Description__c?: string | null, Amount__c?: number | null } | null } | null };

export type ReinstatementContactInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type ReinstatementContactInformationQuery = { __typename?: 'Query', reinstatementContactInformation:
    | { __typename?: 'ReinstatementContactInformation', FirstName?: string | null, LastName?: string | null, Email?: string | null, MobilePhone?: string | null, Account_Name?: string | null, MSRP_Amount__c?: number | null, Account_Non_Accepted_Payment_Plans__c?: Array<NonAcceptedPaymentPlan> | null }
    | { __typename?: 'ReinstatementContactInformationFailure', errors: Array<{ __typename?: 'ReinstatementContactInformationNotFoundError', message: string }> }
   };

export type ReinstatementEligibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type ReinstatementEligibilityQuery = { __typename?: 'Query', reinstatementEligibility:
    | { __typename?: 'ReinstatementActiveAgreement', eligible: boolean, agreementId: number }
    | { __typename?: 'ReinstatementEligible', eligible: boolean }
    | { __typename?: 'ReinstatementIneligible', eligible: boolean, reasonCode: string }
    | { __typename?: 'ReinstatementPending', eligible: boolean, workflowId: string }
   };

export type ReinstatementStatusQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;


export type ReinstatementStatusQuery = { __typename?: 'Query', reinstatementStatus: { __typename?: 'ReinstatementStatus', workflowId: string, status: ReinstatementWorkflowStatus, errorStep?: string | null, errorMessage?: string | null } };


export const CreateNewPaymentProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createNewPaymentProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNewPaymentProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNewPaymentProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNewPaymentProfileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNewPaymentProfileFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNewPaymentProfileInvalidInputDomainError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNewPaymentProfileFailedDomainError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewPaymentProfileMutation, CreateNewPaymentProfileMutationVariables>;
export const CreateOneTimePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOneTimePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneTimePaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTimePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneTimePaymentSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneTimePaymentFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneTimePaymentFailedDomainError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneTimePaymentMutation, CreateOneTimePaymentMutationVariables>;
export const EnableMemberAutopayByContactIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enableMemberAutopayByContactId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableMemberAutopayByContactId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ContactId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AutoPay__c"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnableMemberAutopayByContactIdFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnableMemberAutopayByContactIdInvalidContactIdError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContactId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EnableMemberAutopayByContactIdMutation, EnableMemberAutopayByContactIdMutationVariables>;
export const ReinstateMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReinstateMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstateMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reinstateMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstateMemberResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstateMemberError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}}]}}]}}]} as unknown as DocumentNode<ReinstateMemberMutation, ReinstateMemberMutationVariables>;
export const UpdateContactInfoForReinstatementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateContactInfoForReinstatement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateContactInfoForReinstatementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContactInfoForReinstatement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateContactInfoForReinstatementSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateContactInfoForReinstatementFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateContactInfoForReinstatementMutation, UpdateContactInfoForReinstatementMutationVariables>;
export const UpdateContactOptInPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateContactOptInPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateContactOptInPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContactOptInPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateContactOptInPreferencesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateContactOptInPreferencesFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateContactOptInPreferencesMutation, UpdateContactOptInPreferencesMutationVariables>;
export const VerifyAchInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyACHInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyACHInformationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyACHInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyACHInformationSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayTokenId"}},{"kind":"Field","name":{"kind":"Name","value":"authTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyACHInformationFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyACHInformationDomainError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VerifyAchInformationMutation, VerifyAchInformationMutationVariables>;
export const VerifyCreditCardInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyCreditCardInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyCreditCardInformationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyCreditCardInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyCreditCardInformationSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayTokenId"}},{"kind":"Field","name":{"kind":"Name","value":"authTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyCreditCardInformationFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyCreditCardInformationDomainError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VerifyCreditCardInformationMutation, VerifyCreditCardInformationMutationVariables>;
export const ContactOptInPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contactOptInPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactOptInPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contactOptInPreferences"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"Automated_Communication_Opt_In__c"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contactOptInPreferencesNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ContactOptInPreferencesQuery, ContactOptInPreferencesQueryVariables>;
export const NextPaymentDueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NextPaymentDue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextPaymentDue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MemberId"}},{"kind":"Field","name":{"kind":"Name","value":"Amount"}},{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"CurrentBalance"}}]}}]}}]} as unknown as DocumentNode<NextPaymentDueQuery, NextPaymentDueQueryVariables>;
export const PatientReceiptByDocumentIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"patientReceiptByDocumentIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientReceiptByDocumentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contactId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PatientReceiptByDocumentIdQueryResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"documentBalance"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PatientReceiptByDocumentIdFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PatientReceiptByDocumentIdQueryQuery, PatientReceiptByDocumentIdQueryQueryVariables>;
export const PaymentSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paymentSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"MaximumPaymentAmount"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MaximumPaymentAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description__c"}},{"kind":"Field","name":{"kind":"Name","value":"Amount__c"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<PaymentSettingsQuery, PaymentSettingsQueryVariables>;
export const ReinstatementContactInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReinstatementContactInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reinstatementContactInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstatementContactInformation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FirstName"}},{"kind":"Field","name":{"kind":"Name","value":"LastName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"MobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"Account_Name"}},{"kind":"Field","name":{"kind":"Name","value":"MSRP_Amount__c"}},{"kind":"Field","name":{"kind":"Name","value":"Account_Non_Accepted_Payment_Plans__c"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstatementContactInformationFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstatementContactInformationNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReinstatementContactInformationQuery, ReinstatementContactInformationQueryVariables>;
export const ReinstatementEligibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReinstatementEligibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reinstatementEligibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstatementEligible"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligible"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstatementIneligible"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstatementPending"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReinstatementActiveAgreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"agreementId"}}]}}]}}]}}]} as unknown as DocumentNode<ReinstatementEligibilityQuery, ReinstatementEligibilityQueryVariables>;
export const ReinstatementStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReinstatementStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reinstatementStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workflowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorStep"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ReinstatementStatusQuery, ReinstatementStatusQueryVariables>;